import { Component, EventEmitter, Input, OnInit, OnDestroy, OnChanges, SimpleChanges, Output, Type, ViewChild, inject, DestroyRef, ChangeDetectorRef, ViewContainerRef, TemplateRef, ApplicationRef } from '@angular/core';
import { MatAccordion } from '@angular/material/expansion';
import { ActivatedRoute, Router } from '@angular/router';
import { translate } from '@jsverse/transloco';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import {catchError, filter, take} from 'rxjs'
import { combineLatest, finalize, forkJoin, mergeMap, Observable, of, Subject, Subscription, interval } from 'rxjs';
import { startWith, map, tap } from 'rxjs/operators';
import { Blueprint, BlueprintTypes } from 'src/app/models/blueprints/blueprint';
import { BreadcrumbItem } from 'src/app/models/breadcrumb/breadcrumb-item';
import { DeployStatus } from 'src/app/models/deploy/deploy-status';
import { DeploymentClass } from 'src/app/models/instance-class';
import { AVAILABLE_STATE_ICON, ENV_PROGRESS_STATUS, ENVIRONMENT_STATUS_ICON, Instance } from 'src/app/models/instance/instance';
import { Permission } from 'src/app/models/principal/permission';
import { CapabilitiesGroup, Capability, CapabilityType } from 'src/app/models/service/capability';
import { InstallationSchemaPropertyType } from 'src/app/models/service/installation-schema-property-type';
import { Solution } from 'src/app/models/service/solution';
import { SolutionVersion } from 'src/app/models/service/solution-version';
import { SolutionVersionsInfo } from 'src/app/models/service/solution-versions-info';
import { Tenant } from 'src/app/models/tenant/tenant';
import { InstancesService } from 'src/app/services/api/instances.service';
import { TenantService } from 'src/app/services/api/tenant.service';
import { CustomToastrService } from 'src/app/services/util/toastr.service';
import {PermissionsService} from '../../../services/util/permissions.service';
import {BlueprintVersion} from '../../../models/blueprints/blueprint-version';
import { DataZone } from 'src/app/models/data-zone/data-zone';
import { RouterSegments } from 'src/app/models/router-segments';
import {Configuration} from '../../../models/configurations/configuration';
import { OperationType } from 'src/app/models/workflow-approval/operation-type';
import { WorkflowTicketStatus } from 'src/app/models/workflow-approval/ticket-status';
import { PathToLiveEnvironment } from 'src/app/models/blueprints/path-to-live-environment';
import { EndpointType } from 'src/app/models/endpoint-type';
import { AuthService } from 'src/app/services/auth/auth.service';
import { MatDialog } from '@angular/material/dialog';
import { ErrorPageService } from 'src/app/services/util/error-page.service';
import { BlueprintsService } from 'src/app/services/api/blueprints.service';
import { SolutionsService } from 'src/app/services/api/solutions.service';
import { ConfigurationsService } from 'src/app/services/api/configurations.service';
import { UrlService } from 'src/app/services/util/url.service';
import { SidenavService } from 'src/app/services/util/sidenav.service';
import { DeploymentsService } from 'src/app/services/api/deployments.service';
import { WorkflowService } from 'src/app/services/api/workflow.service';
import { TourService } from 'src/app/services/util/tour.service';
import { SolutionVersionsService } from 'src/app/services/util/solution-versions.service';
import { NotificationsService } from 'src/app/services/api/notifications.service';
import { InstallationSpecificationService } from 'src/app/services/util/installation-specification.service';
import { DateTimeService } from 'src/app/services/util/date-time.service';
import { Title } from '@angular/platform-browser';
import { ClipboardService } from 'ngx-clipboard';
import {Deployment} from '../../../models/deploy/deployment';
import { ErrorDialogComponent } from 'src/app/components/error-dialog/error-dialog.component';
import { GenericErrorComponent } from 'src/app/components/generic-error/generic-error.component';
import { WorkflowApproval } from 'src/app/models/workflow-approval/workflow-approval';
import { ReportIssueComponent } from '../../service/report-issue/report-issue.component';
import { ViewEndpointsComponent } from '../../service/view-endpoints/view-endpoints.component';
import { ChangeTask } from 'src/app/models/service/change-task';
import { ChangeState } from 'src/app/models/service/change-state';
import { ConfirmationDialogComponent } from 'src/app/components/confirmation-dialog/confirmation-dialog.component';
import {ViewUpdateResultsComponent} from 'src/app/main/service/view-update-results/view-update-results.component';
import { DeployInstanceComponent } from '../../service/deploy-instance/deploy-instance.component';
import { DeployInstanceFormComponent } from '../../service/deploy-instance-form/deploy-instance-form.component';
import { ContactUsDialogComponent } from 'src/app/layout/toolbar/contact-us-dialog/contact-us-dialog.component';
import moment from 'moment';
import { getDiffDays, isReleaseVersion } from 'src/app/services/util/utils';
import { PathToLiveConfiguration } from 'src/app/models/blueprints/path-to-live-configuration';
import {Constants} from 'src/app/models/constants';
import { ConfigurationApplicationStatus, ConfigurationState } from 'src/app/models/configurations/configuration-state';
import {PathToLiveWorkflowComponent} from 'src/app/main/service/path-to-live-workflow/path-to-live-workflow.component';
import { animate, style, transition, trigger } from '@angular/animations';
import { ConfigurationDetailsComponent } from 'src/app/components/configuration-details/configuration-details.component';
import { Permissions, Datazone, Attributes} from 'src/app/models/principal/permission';
import { PermissionKeys } from 'src/app/models/principal/permission-keys';
import { AgentStatus } from 'src/app/models/agents/agent-status';
import { ManagementMode } from 'src/app/models/instance/instance';
import { ViewServiceDefinitionVersionDetailsComponent } from 'src/app/components/view-service-definition-version-details/view-service-definition-version-details.component';
import { UpdateDefinitionComponent } from '../update-definition/update-definition.component';
import { VersionDetailsPopupComponent } from '../version-details-popup/version-details-popup.component';
import { CobService } from 'src/app/services/api/cob.service';
import cloneDeep from 'lodash/cloneDeep';
import { TenantInstanceService } from 'src/app/main/blueprint-summary/tenant-instance/tenant-instance.service';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Types } from 'src/app/models/service/schedule';
import { BackupService } from 'src/app/services/api/backup.service';

import { FeatureKeys } from 'src/app/models/feature/feature-keys';
import { Feature, FeatureAttributes, FeatureDatazone } from 'src/app/models/feature/feature';
import { FeatureFlags } from 'src/app/models/constants/feature-flags.constant';
import { FeatureFlagsManagerService } from 'src/app/services/util/feature-flags-manager.service';
import { FeaturePermissionsService } from 'src/app/services/util/feature-permissions.service';
import { DbbackupService } from 'src/app/services/api/dbbackup.service';
import {CdkDragDrop, moveItemInArray, transferArrayItem, CdkDragEnter, CdkDragStart, CdkDragExit} from '@angular/cdk/drag-drop';
import { FormUtilService } from 'src/app/services/util/form-util.service';
import { InstancePollingService } from 'src/app/services/util/instance-polling.service';
import { handleInstanceMenuPositioning } from 'src/app/services/util/utils';
import { WarningDialogComponent } from 'src/app/components/warning-dialog/warning-dialog.component';
import { SelectDatabaseComponent } from '../select-database/select-database.component';
import { InstanceType } from 'src/app/models/instance/instance-type';
import { BackupDetailsComponent } from '../backup-details/backup-details.component';
import { ColumnFilterComponent } from '../../instances-mgmt/column-filter/column-filter.component';
import { DatePipe } from '@angular/common';
import { CloudProvider } from 'src/app/models/cloud-provider/cloud-provider';
import { FeatureNotSupportedComponent } from 'src/app/components/feature-not-supported/feature-not-supported.component';
import { Overlay, OverlayRef, OverlayPositionBuilder } from '@angular/cdk/overlay';
import { TemplatePortal } from '@angular/cdk/portal';
import { RedirectionDialogComponent } from 'src/app/components/redirection-dialog/redirection-dialog.component';
import { LocalConfiguration } from 'src/app/services/api/local-config.service';
import { dataBaseStatus, DataBaseStatus } from 'src/app/models/deploy/database-status';
import { UserService } from 'src/app/services/api/user.service';
import { TenantOrigin } from 'src/app/models/tenant/tenant-status';
import { formatAvailabilityState, toUtcString } from 'src/app/services/util/utils';
import { ActivityService } from 'src/app/services/api/activity.service';
import { ActivityProgressService } from 'src/app/services/util/activity-progress.service';
import { EnvironmentActivityDetails } from '../../environment-details/environment-activity-details/environment-activity-details';
import { EnvScheduleService } from 'src/app/services/api/env-schedule.service';
const REQUIRED_PERMISSIONS = [
  {
    key: PermissionKeys.INSTANCE_CREATE_DATAZONE_NONPII,
    action: Permissions.INSTANCE_CREATE,
    attribute: Attributes.DATAZONE,
    attributeValue: Datazone.NONPII
  },
  {
    key: PermissionKeys.INSTANCE_CREATE_DATAZONE_PII,
    action: Permissions.INSTANCE_CREATE,
    attribute: Attributes.DATAZONE,
    attributeValue: Datazone.PII
  },
  {
    key: PermissionKeys.INSTANCE_CREATE_DATAZONE_LIVE,
    action: Permissions.INSTANCE_CREATE,
    attribute: Attributes.DATAZONE,
    attributeValue: Datazone.LIVE
  },
  {
    key: PermissionKeys.INSTANCE_DELETE_DATAZONE_NONPII,
    action: Permissions.INSTANCE_DELETE,
    attribute: Attributes.DATAZONE,
    attributeValue: Datazone.NONPII
  },
  {
    key: PermissionKeys.INSTANCE_DELETE_DATAZONE_PII,
    action: Permissions.INSTANCE_DELETE,
    attribute: Attributes.DATAZONE,
    attributeValue: Datazone.PII
  },
  {
    key: PermissionKeys.INSTANCE_DELETE_DATAZONE_LIVE,
    action: Permissions.INSTANCE_DELETE,
    attribute: Attributes.DATAZONE,
    attributeValue: Datazone.LIVE
  },
  {
    key: PermissionKeys.INSTANCE_START_DATAZONE_NONPII,
    action: Permissions.INSTANCE_START,
    attribute: Attributes.DATAZONE,
    attributeValue: Datazone.NONPII
  },
  {
    key: PermissionKeys.INSTANCE_STOP_DATAZONE_NONPII,
    action: Permissions.INSTANCE_STOP,
    attribute: Attributes.DATAZONE,
    attributeValue: Datazone.NONPII
  },
  {
    key: PermissionKeys.INSTANCE_START_DATAZONE_PII,
    action: Permissions.INSTANCE_START,
    attribute: Attributes.DATAZONE,
    attributeValue: Datazone.PII
  },
  {
    key: PermissionKeys.INSTANCE_STOP_DATAZONE_PII,
    action: Permissions.INSTANCE_STOP,
    attribute: Attributes.DATAZONE,
    attributeValue: Datazone.PII
  },
  {
    key: PermissionKeys.CONFIGURATION_READ,
    action: Permissions.CONFIGURATION_READ,
  },
  {
    key: PermissionKeys.INSTANCE_CREATE,
    action: Permissions.INSTANCE_CREATE,
  },
  {
    key: PermissionKeys.BLUEPRINT_CREATE,
    action: Permissions.BLUEPRINT_CREATE,
  },
  {
    key: PermissionKeys.BLUEPRINT_READ,
    action: Permissions.BLUEPRINT_READ,
  },
  {
    key: PermissionKeys.BLUEPRINT_UPDATE,
    action: Permissions.BLUEPRINT_UPDATE,
  },
  {
    key: PermissionKeys.BLUEPRINT_DELETE,
    action: Permissions.BLUEPRINT_DELETE,
  },
  {
    key: PermissionKeys.INSTANCE_UPDATE_DATAZONE_NONPII,
    action: Permissions.INSTANCE_UPDATE,
    attribute: Attributes.DATAZONE,
    attributeValue: Datazone.NONPII
  },
  {
    key: PermissionKeys.INSTANCE_UPDATE_DATAZONE_PII,
    action: Permissions.INSTANCE_UPDATE,
    attribute: Attributes.DATAZONE,
    attributeValue: Datazone.PII
  },
  {
    key: PermissionKeys.INSTANCE_UPDATE_DATAZONE_LIVE,
    action: Permissions.INSTANCE_UPDATE,
    attribute: Attributes.DATAZONE,
    attributeValue: Datazone.LIVE
  },
  {
    key: PermissionKeys.INSTANCE_READ_DATAZONE_NONPII,
    action: Permissions.INSTANCE_READ,
    attribute: Attributes.DATAZONE,
    attributeValue: Datazone.NONPII
  },
  {
    key: PermissionKeys.INSTANCE_READ_DATAZONE_PII,
    action: Permissions.INSTANCE_READ,
    attribute: Attributes.DATAZONE,
    attributeValue: Datazone.PII
  },
  {
    key: PermissionKeys.INSTANCE_READ_DATAZONE_LIVE,
    action: Permissions.INSTANCE_READ,
    attribute: Attributes.DATAZONE,
    attributeValue: Datazone.LIVE
  },
  {
    key: PermissionKeys.INSTANCE_CONFIG_DATAZONE_NONPII,
    action: Permissions.INSTANCE_CONFIG,
    attribute: Attributes.DATAZONE,
    attributeValue: Datazone.NONPII
  },
  {
    key: PermissionKeys.INSTANCE_CONFIG_DATAZONE_PII,
    action: Permissions.INSTANCE_CONFIG,
    attribute: Attributes.DATAZONE,
    attributeValue: Datazone.PII
  },
  {
    key: PermissionKeys.INSTANCE_CONFIG_DATAZONE_LIVE,
    action: Permissions.INSTANCE_CONFIG,
    attribute: Attributes.DATAZONE,
    attributeValue: Datazone.LIVE
  }

];

const REQUIRED_FEATURES = [
  {
    key: FeatureKeys.INSTANCE_START_NONPII,
    name: Feature.INSTANCE_START,
    attribute: FeatureAttributes.DATAZONE,
    attributeValue: FeatureDatazone.NONPII
  },
  {
    key: FeatureKeys.INSTANCE_START_PII,
    name: Feature.INSTANCE_START,
    attribute: FeatureAttributes.DATAZONE,
    attributeValue: FeatureDatazone.PII
  },
  {
    key: FeatureKeys.INSTANCE_START_LIVE,
    name: Feature.INSTANCE_START,
    attribute: FeatureAttributes.DATAZONE,
    attributeValue: FeatureDatazone.LIVE
  },
  {
    key: FeatureKeys.INSTANCE_STOP_NONPII,
    name: Feature.INSTANCE_STOP,
    attribute: FeatureAttributes.DATAZONE,
    attributeValue: FeatureDatazone.NONPII
  },
  {
    key: FeatureKeys.INSTANCE_STOP_PII,
    name: Feature.INSTANCE_STOP,
    attribute: FeatureAttributes.DATAZONE,
    attributeValue: FeatureDatazone.PII
  },
  {
    key: FeatureKeys.INSTANCE_STOP_LIVE,
    name: Feature.INSTANCE_STOP,
    attribute: FeatureAttributes.DATAZONE,
    attributeValue: FeatureDatazone.LIVE
  }
];
@Component({
    selector: 'app-tenant-instance',
    templateUrl: './tenant-instance.component.html',
    styleUrls: ['./tenant-instance.component.scss'],
    animations: [
        trigger('rotate', [
            transition('void=>*', [style({ transform: 'rotate(0)' })]),
            transition('* => *', [
                style({ transform: 'rotate(0)' }),
                animate('650ms ease-in-out', style({ transform: 'rotate(360deg)' })),
            ])
        ])
    ],
    standalone: false
})
export class TenantInstanceComponent implements OnInit, OnDestroy, OnChanges {
  isReleaseGreaterOrEqual  = isReleaseVersion;
  toUtcString = toUtcString;
  currentTime: number = Date.now();
  private progressTimer: any;
  @ViewChild(MatAccordion) accordion: MatAccordion;
  @Output() deleteBlueprints = new EventEmitter<string>();
  @Input() blueprint: Blueprint;
  @Input() tenantId: string;
  @Input() runHours: any;
  @Input() shutDownHours: any;
  @Input() timetakenChartLoaded = false;
  @Input() isResponseOk = false;
  @Input() isErrorResponse = false;
  private destroyRef = inject(DestroyRef);
  private overlayRef: OverlayRef | null = null;
  private closeTimeout: any;
  capabilities: Capability[];
  AgentStatus = AgentStatus;
  ManagementMode = ManagementMode;
  capabilitiesGroups: CapabilitiesGroup[];
  CapabilityType = CapabilityType;
  service: Solution;
  serviceVersionsInfo: SolutionVersionsInfo;
  serviceVersions: SolutionVersion[];
  publishedServiceVersions: SolutionVersion[];
  permissionsMap: { [key: string]: boolean };
  updatedPermissionsMap: { [key: string]: boolean };
  initStatusMap: { [key: string]: string | null } = {};
  PermissionKeys = PermissionKeys;
  blueprintType = BlueprintTypes;
  errorMessage: any;
  sandboxCreationStatus: any;
  availableEndpoints = 0;
  endpointView = false;
  gotoWorkBench = false;
  liveReleaseData: any;
  environment: any;
  instanceName: any;
  state = 'default';
  count: any;
  defaultState;
  updateReleasePackage: any;
  isAMR: boolean;
  latestReleaseVersion: any;
  enterPriseSandbox: boolean;
  releaseVersion: any;
  Permissions = Permissions;
  Constants = Constants;
  sortedSolutionVersionId: any;
  configurationStatus: any;
  showVersionAlert:any
  solVersionMsg:any
  showVersionAlertMsg:boolean;
  updateServiceId:any;
  isEAASScheduleClicked: boolean;
  metricMonth:any;
  metricConfigMonth:any;
  configurationStateResponse : any;
  successConfigStates = [];
  metricsPiechart: any;
  metricsPieChartLoaded: boolean;
  timeTakenPie:any;
  timeTakenInfo: any;
  metricsTab = false;
  metricsInstances: any;
  selectedMetricInstance: string;
  minDate: any;
  subscriptionData: any;
  hoveredInstance: any = null;
  formatAvailabilityState = formatAvailabilityState;
  bookmarkInProgress = new Set<string>();

  ConfigurationApplicationStatus = ConfigurationApplicationStatus;
  dbInitialStatus = [DataBaseStatus.PROMOTING, DataBaseStatus.DELETING, DataBaseStatus.PREPARING]
  

  readonly INSTANCE_AVAILABLE_STATES = [DeployStatus.INITIALIZED, DeployStatus.DEPLOYED, DeployStatus.FAILED, DeployStatus.TERMINATION_FAILED,
    DeployStatus.CONFIGURING, DeployStatus.CONFIGURATION_FAILED, DeployStatus.CONFIGURED, DeployStatus.TESTED, DeployStatus.UPDATED,
    DeployStatus.UPDATE_FAILED, DeployStatus.TEST_FAILED, DeployStatus.FAILOVER_APPLYING, DeployStatus.FAILBACK_APPLYING, DeployStatus.FAILOVER_INPROGRESS, DeployStatus.FALLBACK_INPROGRESS,
    DeployStatus.PRE_FAILBACK_APPLYING, DeployStatus.FAILOVER_FAILED, DeployStatus.FAILBACK_FAILED, DeployStatus.PRE_FAILBACK_FAILED, DeployStatus.POST_FAILBACK_APPLYING, DeployStatus.POST_FAILBACK_FAILED, DeployStatus.STOP_FAILED];

    readonly INSTANCE_FAILED_STATES = [DeployStatus.FAILED, DeployStatus.CONFIGURATION_FAILED, DeployStatus.UPDATE_FAILED, DeployStatus.TEST_FAILED];

    readonly INSTANCE_CONFIG_AVAILABLE_STATES = [DeployStatus.DEPLOYED, DeployStatus.TERMINATION_FAILED, DeployStatus.TESTING,
      DeployStatus.CONFIGURING, DeployStatus.CONFIGURED, DeployStatus.TESTED, DeployStatus.UPDATED, DeployStatus.UPDATING,
      DeployStatus.FAILOVER_APPLYING, DeployStatus.FAILBACK_APPLYING, DeployStatus.FAILOVER_INPROGRESS, DeployStatus.FALLBACK_INPROGRESS,
      DeployStatus.PRE_FAILBACK_APPLYING, DeployStatus.FAILOVER_FAILED, DeployStatus.FAILBACK_FAILED, DeployStatus.PRE_FAILBACK_FAILED, DeployStatus.POST_FAILBACK_APPLYING, DeployStatus.POST_FAILBACK_FAILED, DeployStatus.STOP_FAILED];

    readonly INSTANCE_TERMINATE_AVAILABLE_STATES = [DeployStatus.DEPLOYED, DeployStatus.FAILED, DeployStatus.TERMINATION_FAILED,
      DeployStatus.CONFIGURATION_FAILED, DeployStatus.CONFIGURED, DeployStatus.TESTED, DeployStatus.UPDATED,
      DeployStatus.UPDATE_FAILED, DeployStatus.TEST_FAILED,
      DeployStatus.FAILOVER_FAILED, DeployStatus.FAILBACK_FAILED, DeployStatus.PRE_FAILBACK_FAILED, DeployStatus.POST_FAILBACK_FAILED, DeployStatus.STOP_FAILED];

    readonly INSTANCE_FILTERED_STATES = [DeployStatus.INITIALIZED, DeployStatus.INITIALIZE_FAILED, DeployStatus.INITIALIZING, DeployStatus.DEPLOYED, DeployStatus.FAILED, DeployStatus.DEPLOYING,
      DeployStatus.CONFIGURING, DeployStatus.CONFIGURATION_FAILED, DeployStatus.CONFIGURED, DeployStatus.TESTED, DeployStatus.UPDATED,
      DeployStatus.UPDATE_FAILED, DeployStatus.TEST_FAILED, DeployStatus.FAILOVER_APPLYING, DeployStatus.FAILBACK_APPLYING, DeployStatus.FAILOVER_INPROGRESS, DeployStatus.FALLBACK_INPROGRESS, DeployStatus.OPERATION_INPROGRESS,
      DeployStatus.PRE_FAILBACK_APPLYING, DeployStatus.FAILOVER_FAILED, DeployStatus.FAILBACK_FAILED, DeployStatus.PRE_FAILBACK_FAILED, DeployStatus.POST_FAILBACK_APPLYING, DeployStatus.POST_FAILBACK_FAILED];

  readonly INSTANCE_DEPLOYED_STATES = [DeployStatus.DEPLOYED, DeployStatus.CONFIGURING, DeployStatus.TERMINATION_FAILED,
    DeployStatus.CONFIGURATION_FAILED, DeployStatus.CONFIGURED, DeployStatus.UPDATING, DeployStatus.UPDATED, DeployStatus.TESTED,
    DeployStatus.TESTING, DeployStatus.UPDATE_FAILED, DeployStatus.TEST_FAILED, DeployStatus.FAILOVER_APPLYING, DeployStatus.FAILBACK_APPLYING, DeployStatus.FAILOVER_INPROGRESS, DeployStatus.FALLBACK_INPROGRESS,
    DeployStatus.OPERATION_INPROGRESS, DeployStatus.PRE_FAILBACK_APPLYING, DeployStatus.FAILOVER_FAILED, DeployStatus.FAILBACK_FAILED, DeployStatus.PRE_FAILBACK_FAILED,
    DeployStatus.POST_FAILBACK_APPLYING, DeployStatus.POST_FAILBACK_FAILED, DeployStatus.STOPPED, DeployStatus.STOP_FAILED, DeployStatus.START_FAILED, DeployStatus.STOPPING, DeployStatus.STARTING, DeployStatus.STOPPING_AGENT, DeployStatus.STARTING_AGENT];

  readonly INSTANCE_DEPLOYED_STATES_FAILED = [DeployStatus.FAILED, DeployStatus.TERMINATION_FAILED];

  readonly INSTANCE_DEPLOYING_STATES = [DeployStatus.INITIALIZED, DeployStatus.DEPLOYING, DeployStatus.TERMINATED,
    DeployStatus.CONFIGURING, DeployStatus.UPDATING, DeployStatus.OPERATION_INPROGRESS,
    DeployStatus.FAILOVER_APPLYING, DeployStatus.FAILBACK_APPLYING, DeployStatus.FAILOVER_INPROGRESS, DeployStatus.FALLBACK_INPROGRESS,
    DeployStatus.PRE_FAILBACK_APPLYING, DeployStatus.POST_FAILBACK_APPLYING, DeployStatus.TERMINATING, DeployStatus.TESTING, DeployStatus.TENANT_AGENT_CREATION_IN_PROGRESS, DeployStatus.INITIALIZING, DeployStatus.STARTING, DeployStatus.STOPPING, DeployStatus.STARTING_AGENT, DeployStatus.STOPPING_AGENT, DeployStatus.INPROGRESS];

    readonly PREPROD_RE_DEPLOYING_STATES = [DeployStatus.NOT_DEPLOYED, DeployStatus.INITIALIZED, DeployStatus.INITIALIZE_FAILED, DeployStatus.INITIALIZING, DeployStatus.DEPLOYING, DeployStatus.TERMINATED,
      DeployStatus.CONFIGURING, DeployStatus.UPDATING, DeployStatus.OPERATION_INPROGRESS,
      DeployStatus.FAILOVER_APPLYING, DeployStatus.FAILOVER_INPROGRESS, DeployStatus.FAILBACK_APPLYING, DeployStatus.FALLBACK_INPROGRESS,
      DeployStatus.PRE_FAILBACK_APPLYING, DeployStatus.POST_FAILBACK_APPLYING, DeployStatus.TERMINATING, DeployStatus.TESTING, DeployStatus.TENANT_AGENT_CREATION_IN_PROGRESS, DeployStatus.INPROGRESS];

  readonly INSTANCE_AVAILABLE_STATUS = [DeployStatus.DEPLOYED, DeployStatus.UPDATED,
    DeployStatus.UPDATE_FAILED, DeployStatus.TESTED, DeployStatus.TEST_FAILED,
    DeployStatus.CONFIGURED, DeployStatus.CONFIGURATION_FAILED,
    DeployStatus.FAILED, DeployStatus.FAILOVER_FAILED, DeployStatus.FAILBACK_FAILED, DeployStatus.PRE_FAILBACK_FAILED, DeployStatus.POST_FAILBACK_FAILED, DeployStatus.STOP_FAILED];

    readonly INSTANCE_CONTRACT_STATUS = [DeployStatus.OPERATION_INPROGRESS, DeployStatus.DEPLOYING, DeployStatus.TERMINATING, DeployStatus.CONFIGURING, DeployStatus.UPDATING, DeployStatus.TESTING, DeployStatus.FAILOVER_APPLYING,
      DeployStatus.FAILBACK_APPLYING,  DeployStatus.FAILOVER_INPROGRESS, DeployStatus.FALLBACK_INPROGRESS, DeployStatus.PRE_FAILBACK_APPLYING, DeployStatus.POST_FAILBACK_APPLYING, DeployStatus.STARTING_AGENT, DeployStatus.STOPPING_AGENT, DeployStatus.STARTING, DeployStatus.STOPPING, DeployStatus.INITIALIZING,
      DeployStatus.TENANT_AGENT_CREATION_IN_PROGRESS, DeployStatus.INPROGRESS];

    readonly INSTANCE_DEPLOYED_STATUS = [DeployStatus.DEPLOYED, DeployStatus.CONFIGURING, DeployStatus.TERMINATION_FAILED,
      DeployStatus.CONFIGURATION_FAILED, DeployStatus.CONFIGURED, DeployStatus.UPDATING, DeployStatus.UPDATED, DeployStatus.TESTED,
      DeployStatus.TESTING, DeployStatus.UPDATE_FAILED, DeployStatus.TEST_FAILED, DeployStatus.FAILOVER_APPLYING, DeployStatus.FAILBACK_APPLYING,  DeployStatus.FAILOVER_INPROGRESS, DeployStatus.FALLBACK_INPROGRESS,
      DeployStatus.OPERATION_INPROGRESS, DeployStatus.PRE_FAILBACK_APPLYING, DeployStatus.FAILOVER_FAILED, DeployStatus.FAILBACK_FAILED, DeployStatus.PRE_FAILBACK_FAILED,
      DeployStatus.POST_FAILBACK_APPLYING, DeployStatus.POST_FAILBACK_FAILED, DeployStatus.STOP_FAILED];

  readonly OP_MESSAGE_KEYS: Record<string, { inprogress: string; failed: string }> = {
    sanity_test:     { inprogress: 'BLUEPRINT_SUMMARY.SANITY_TEST_INPROGRESS',     failed: 'BLUEPRINT_SUMMARY.SANITY_TEST_FAILED' },
    ef_test:         { inprogress: 'BLUEPRINT_SUMMARY.EF_TEST_INPROGRESS',         failed: 'BLUEPRINT_SUMMARY.EF_TEST_FAILED' },
    rvt_test:        { inprogress: 'BLUEPRINT_SUMMARY.RVT_TEST_INPROGRESS',        failed: 'BLUEPRINT_SUMMARY.RVT_TEST_FAILED' },
    config_rvt_test: { inprogress: 'BLUEPRINT_SUMMARY.CONFIG_RVT_TEST_INPROGRESS', failed: 'BLUEPRINT_SUMMARY.CONFIG_RVT_TEST_FAILED' },
    inventory:       { inprogress: 'BLUEPRINT_SUMMARY.INVENTORY_INPROGRESS',       failed: 'BLUEPRINT_SUMMARY.INVENTORY_FAILED' },
    backup_create:   { inprogress: 'BLUEPRINT_SUMMARY.BACKUP_CREATE_INPROGRESS',   failed: 'BLUEPRINT_SUMMARY.BACKUP_CREATE_FAILED' },
    backup_delete:   { inprogress: 'BLUEPRINT_SUMMARY.BACKUP_DELETE_INPROGRESS',   failed: 'BLUEPRINT_SUMMARY.BACKUP_DELETE_FAILED' },
    backup_update:   { inprogress: 'BLUEPRINT_SUMMARY.BACKUP_UPDATE_INPROGRESS',   failed: 'BLUEPRINT_SUMMARY.BACKUP_UPDATE_FAILED' },
    cob_config:      { inprogress: 'BLUEPRINT_SUMMARY.COB_CONFIG_INPROGRESS',      failed: 'BLUEPRINT_SUMMARY.COB_CONFIG_FAILED' },
    cob_delete:      { inprogress: 'BLUEPRINT_SUMMARY.COB_DELETE_INPROGRESS',      failed: 'BLUEPRINT_SUMMARY.COB_DELETE_FAILED' },
    runbook:         { inprogress: 'BLUEPRINT_SUMMARY.RUNBOOK_INPROGRESS',         failed: 'BLUEPRINT_SUMMARY.RUNBOOK_FAILED' },
    start_agent:     { inprogress: 'BLUEPRINT_SUMMARY.START_AGENT_INPROGRESS',     failed: 'BLUEPRINT_SUMMARY.START_AGENT_FAILED' },
    stop_agent:      { inprogress: 'BLUEPRINT_SUMMARY.STOP_AGENT_INPROGRESS',      failed: 'BLUEPRINT_SUMMARY.STOP_AGENT_FAILED' },
  };

    readonly INSTANCE_STATUS_BAR = [DeployStatus.DEPLOYING, DeployStatus.INITIALIZED, DeployStatus.INITIALIZING,
      DeployStatus.TERMINATING, DeployStatus.CONFIGURING, DeployStatus.TESTING, DeployStatus.STOPPING,
      DeployStatus.STARTING, DeployStatus.POST_FAILBACK_APPLYING, DeployStatus.PRE_FAILBACK_APPLYING,
      DeployStatus.FAILOVER_APPLYING,  DeployStatus.FAILOVER_INPROGRESS, DeployStatus.FALLBACK_INPROGRESS, DeployStatus.FAILED, DeployStatus.FAILOVER_FAILED, DeployStatus.FAILBACK_FAILED, DeployStatus.PRE_FAILBACK_FAILED, DeployStatus.POST_FAILBACK_FAILED,
      DeployStatus.START_FAILED, DeployStatus.STOP_FAILED, DeployStatus.INITIALIZE_FAILED, DeployStatus.TERMINATION_FAILED, DeployStatus.CONFIGURATION_FAILED, DeployStatus.UPDATE_FAILED,
      DeployStatus.UPDATING];

    readonly INSTANCE_DRAG_DROP_NEGATIVE_STATUS = [DeployStatus.INITIALIZED, DeployStatus.INITIALIZING, DeployStatus.INITIALIZE_FAILED,
      DeployStatus.TERMINATING, DeployStatus.TERMINATED, DeployStatus.TERMINATION_FAILED, DeployStatus.NOT_DEPLOYED
    ]

     readonly INSTANCE_DEPLOYING_STATES_COUNT = [DeployStatus.DEPLOYING, DeployStatus.TERMINATED,
      DeployStatus.CONFIGURING, DeployStatus.UPDATING, DeployStatus.INITIALIZED,
      DeployStatus.FAILOVER_APPLYING, DeployStatus.FAILBACK_APPLYING,
      DeployStatus.PRE_FAILBACK_APPLYING, DeployStatus.POST_FAILBACK_APPLYING, DeployStatus.TERMINATING, DeployStatus.TESTING,];


      STATUS_ICON = {
    [DeployStatus.DEPLOYING]: 'change_circle',
    [DeployStatus.TESTING]: 'change_circle',
    [DeployStatus.TERMINATING]: 'schedule',
    [DeployStatus.DEPLOYED]: 'done',
    [DeployStatus.TERMINATED]: 'close',
    [DeployStatus.TERMINATION_FAILED]: 'close',
    [DeployStatus.NOT_DEPLOYED]: 'schedule',
    [DeployStatus.FAILED]: 'close',
    [DeployStatus.FAILOVER_APPLYING]: 'change_circle',
    [DeployStatus.FAILBACK_APPLYING]: 'change_circle',
    [DeployStatus.FAILOVER_INPROGRESS]: 'change_circle',
    [DeployStatus.FALLBACK_INPROGRESS]: 'change_circle',
    [DeployStatus.PRE_FAILBACK_APPLYING]: 'change_circle',
    [DeployStatus.POST_FAILBACK_APPLYING]: 'change_circle',
    [DeployStatus.POST_FAILBACK_FAILED]: 'close',
    [DeployStatus.FAILOVER_FAILED]: 'close',
    [DeployStatus.FAILBACK_FAILED]: 'close',
    [DeployStatus.PRE_FAILBACK_FAILED]: 'close',
    [DeployStatus.OPERATION_INPROGRESS]: 'change_circle',
    [DeployStatus.INPROGRESS]: 'change_circle',
  };

  STATUS_CLASS = {
    [DeployStatus.DEPLOYING]: 'orange-oval',
    [DeployStatus.TESTING]: 'orange-oval',
    [DeployStatus.TERMINATING]: 'orange-oval',
    [DeployStatus.DEPLOYED]: 'green-oval',
    [DeployStatus.TERMINATED]: 'green-oval',
    [DeployStatus.TERMINATION_FAILED]: 'warn-solid-bg',
    [DeployStatus.NOT_DEPLOYED]: 'neutral-blue-6-oval',
    [DeployStatus.FAILED]: 'warn-solid-bg',
    [DeployStatus.FAILOVER_APPLYING]: 'orange-oval',
    [DeployStatus.FAILBACK_APPLYING]: 'orange-oval',
    [DeployStatus.FAILOVER_INPROGRESS]: 'orange-oval',
    [DeployStatus.FALLBACK_INPROGRESS]: 'orange-oval',
    [DeployStatus.PRE_FAILBACK_APPLYING]: 'orange-oval',
    [DeployStatus.POST_FAILBACK_APPLYING]: 'orange-oval',
    [DeployStatus.POST_FAILBACK_FAILED]: 'warn-solid-bg',
    [DeployStatus.FAILOVER_FAILED]: 'warn-solid-bg',
    [DeployStatus.FAILBACK_FAILED]: 'warn-solid-bg',
    [DeployStatus.PRE_FAILBACK_FAILED]: 'warn-solid-bg',
    [DeployStatus.OPERATION_INPROGRESS]: 'orange-oval',
    [DeployStatus.INPROGRESS]: 'orange-oval'
  };

  CONFIGURATION_FINAL_STATES = Constants.CONFIGURATION_FINAL_STATES;
  InstallationSchemaPropertyType = InstallationSchemaPropertyType;

  breadcrumbItems: BreadcrumbItem[];
  tenant: string;
  dataLoaded: boolean;
  isLive: boolean;
  isSandbox: boolean;

  // blueprint: Blueprint;
  blueprintSingleVersion: Blueprint;
  blueprintVersion: BlueprintVersion;
  trialStatus: string;

  DataZone = DataZone;
  DeployStatus = DeployStatus;
  RouterSegments = RouterSegments;
  InstanceType = InstanceType;

  allInstances: Instance[];
  allInstancesWithClassE: Instance[];
  devInstance: any;
  otherInstance: any;
  classEInstances: any;
  pathToLiveInstances: any[];
  testDataZoneInstances: any[];
  piiDataZoneInstances: any[];
  private activelyPolledInstances: Set<string> = new Set();

  configurations: Configuration[];

  groupedWorkflowApprovals: Map<string, any> = new Map();
  OperationType = OperationType;
  TicketStatus = WorkflowTicketStatus;
  PathToLiveEnvironment = PathToLiveEnvironment;
  showCharts: boolean;
  changeTaskApplying: boolean;

  workbenchUrl: string;
  isLoading = false;
  updateWindowPolicy: string;
  showTopBanner = true;
  isInstance: boolean;

  displayTime$: Observable<Date>;
  lastUpdateTime$: Observable<Date | null>;
  isRefreshing = false;
  selectedInstanceId: string;

  loadDataSubscription: Subscription;
  extendSandbox = false;
  selectedCapabilities: Capability[];
  includedCapabilities: Capability[];
  viewReleaseNotes: string;
  currentDate = new Date();
  deployedDate = new Date();
  tenantDetails: any;

  configTypeEndpoints: any;
  accessTypeEndpoints: any;
  exploreTypeEndpoints: any;
  otherTypeEndpoints: any;

  progressIntervalSubscription: Subscription;
  demoInstance: Instance;
  showStepsLoadingSection = true;
  isInit = false;
  isEndpointAvailable: boolean;
  enterpriseClient: boolean;
  devInstanceEnvironment: any;
  blueprintLatestVersion: any;
  liveDataZone: any;
  blueprintsVersionList: any;
  getVersion: any;
  deployedVersion: any;
  inProgressVersion: any;
  isInstanceSection = true;
  isServiceDefinitionSection = false;
  isNewServiceDefinitionVersion: boolean;
  configStateMessageExpireTime = 60 * 5;
  configStateSubscription: Subscription;
  buildNumber: any;

  blueprintId: string;
  instanceId: string;
  descriptionArray: any;
  createNewBtnEnable = false;
  configStateVerify = false;
  configLastRecord: any = [];
  liveInstanceId: any;
  devDeploymentClass: any;
  skipTest: boolean;
  extendSandboxMessage: boolean;
  bluerprintById: Blueprint;
  instanceBlueprint: Instance[];
  isDevInstanceDeployed: any;
  instanceClass = DeploymentClass;
  updateMessageRemainingTime: any;
  copy = false;
  initialLoader = true;
  instances: any;
  devInstances: any;
  otherInstances: any;
  isOtherInstanceDeployed: any;
  configurationMonth : any;


  DrStates = {
    FAILOVER: "failover",
    PRE_FALLBACK: "pre_fallback",
    FALLBACK: "fallback",
    POST_FALLBACK: "post_fallback"
  }

  DrStatus = {
    FAILOVER_INPROGRESS: "failover_inprogress",
    PRE_FALLBACK_INPROGRESS: "pre_fallback_inprogress",
    FALLBACK_INPROGRESS: "fallback_inprogress",
    POST_FALLBACK_INPROGRESS: "post_fallback_inprogress"
  }
  applyLocalConfigValue: boolean;
  applyingLocalConfigInstanceIds = new Set<string>();
  serviceDefTab: boolean;
  solutionId: any;
  activeInstanceValue: boolean = true;
  deployAgentIds = new Map<string, 'deploy' | 're-deploy'>();
  adoptStartedIds = new Set<string>();

  statusIcons = {
    deployed: 'done',
    configured: 'check_circle',
    initialized: 'check_circle',
    updated: 'check_circle',
    tested: 'check_circle',
    failed: 'cancel_filled',
    configuration_failed: 'cancel_filled',
    terminated: 'error_outline',
    termination_failed: 'cancel_filled',
    test_failed: 'cancel_filled',
    update_failed: 'cancel_filled',
    stopped: 'error_outline',
    start_failed: 'cancel_filled',
    stop_failed: 'cancel_filled',
    initialize_failed: 'cancel_filled',
    deploying: 'change_circle',
    terminating: 'change_circle',
    configuring: 'change_circle',
    updating: 'change_circle',
    initializing: 'change_circle',
    operation_inprogress: 'change_circle',
    inprogress: 'change_circle',
    stopping: 'change_circle',
    stopping_agent: 'change_circle',
    starting: 'change_circle',
    starting_agent: 'change_circle',
    testing: 'change_circle',
    fallback_inprogress: 'change_circle',
    failover_inprogress: 'change_circle',
  };
  ptlTerminatedInstances: Instance[];
  instanceTotal: any;
  showLoader = false;
  onBoardingProcess: any;
  nonpiiStartStop: boolean;
  piiStartStop: boolean;
  showValidationLoader = false;
  instancesLoaded = false;
  preprodEnvironment: boolean;
  showLoaderConfig: boolean;
  configLoader: boolean;
  tenantOwner: string;
  matchingTenant: any;
  tenantOwnershipStatus: { [key: string]: boolean } = {};
  FeatureKeys = FeatureKeys;
  featuresMap: { [key: string]: boolean };
  viewPermission = true;
  draggingItem: any;
  instancesByOrder: any;
  instanceTab = true
  dbTab = false;
  createRestorePage = false;
  stepsArray = [0,1,2];
  currentStep = 0;
  dbForms: FormGroup[];
  environments: any;
  targetEnvt: any;
  sourceEnvt: any;
  backupTypes = [
    {
      name: translate('INSTANCE_DETAILS.SNAPSHOT'),
      value: 'snapshot'
    },
    {
      name: translate('INSTANCE_DETAILS.ARCHIVE'),
      value: 'archive'
    }
  ];
  archiveDBTypes = [
    {
      name: translate('INSTANCE_DETAILS.MONTHEND'),
      value: 'monthEnd'
    },
    {
      name: translate('INSTANCE_DETAILS.YEAR_END'),
      value: 'yearEnd'
    },
    {
      name: translate('INSTANCE_DETAILS.ADHOC'),
      value: 'adhoc'
    }
  ];
  snapshotDBTypes = [
    {
      name: translate('DB_DETAILS.ADHOC'),
      value: 'adhoc'
    }
  ];
  intervalTypes = [];
  databases: any;
  selectDatabase = false;
  isBackupTableLoading = false;
  backupResults: any;
  selectedDatabase: any;
  disableNext = false;
  restoreValidation = {
    nonpii: ['nonpii'],
    pii: ['nonpii', 'pii', 'prod'],
    prod: ['prod']
  };
  hasSecondaryRegion: boolean;
  serverEmptyError = false;
  dbEmptyError = false;
  restoreRecords = [];
  restoreLoading = true;
  restoreDisplayColumns = [
    {
      key: 'sourceInstanceName',
      name: translate('INSTANCE_SUMMARY.SOURCE'),
      type: 'text',
      keyLink: 'navigation',
      sortable: true,
      visible: true,
      disable: true
    },
    {
      key: 'targetInstanceName',
      name: translate('INSTANCE_SUMMARY.TARGET'),
      type: 'text',
      sortable: true,
      visible: true,
      disable: true
    },
    {
      key: 'ticketNumber',
      name: translate('INSTANCE_SUMMARY.TICKET_ID'),
      type: 'text',
      sortable: true,
      keyLink: 'ticketNumber',
      visible: true,
      disable: false
    },
    {
      key: 'createdAt',
      name: translate('INSTANCE_SUMMARY.CREATED_DATE'),
      type: 'date',
      sortable: true,
      visible: true,
      disable: false
    },
    {
      key: 'createdBy',
      name: translate('INSTANCE_SUMMARY.CREATED_BY'),
      type: 'userIcon',
      sortable: false,
      visible: true,
      disable: false
    },
    {
      key: 'status',
      name: translate('INSTANCE_SUMMARY.STATUS'),
      type: 'status',
      sortable: true,
      visible: true,
      disable: true
    },
    {
      key: 'restore',
      name: '',
      type: 'button',
      sortable: false,
      visible: true,
      disable: true
    },
    {
      key: 'restoreSettings',
      name: '',
      type: 'settings'
    }
  ];
  restoreSearchTerm: any;
  selectedTarget: any;
  restoreEnvironments: any;
  disableRestore = false;
  dropdownsList: any;
  restoreStatus: any;
  selectedStatus = [];
  status: any;
  filteredColumns: any;
  clearData: boolean;
  initialRestoreRecords = [];
  filterStartDate: any;
  filterEndDate: any;
  date: any;
  restoreError = false;
  searchedResult: any;
  restoreTicketsLoading = false;
  dbDetailsLoading = false;
  isAWS: boolean;
  showCreateButton: boolean;
  showCreateIcon: boolean;
  isDragging: boolean;
  draggingSource: any;
  showWarningPopup: boolean;
  bookmark: any;
  uniqueDatabases = [];
  isExternalTenant = false;
  private instanceWarningStatus: Map<string, boolean> = new Map();
  availableStateIcon = AVAILABLE_STATE_ICON;
  environmentStatusIcon = ENVIRONMENT_STATUS_ICON;
  envProgressStatus = ENV_PROGRESS_STATUS;
  devDeployed = false;
  private featureFlagsManagerService = inject(FeatureFlagsManagerService);

  constructor( private activatedRoute: ActivatedRoute, private tenantService: TenantService,
    private instanceService: InstancesService, private toastrService: CustomToastrService,
    private authService: AuthService, private instancesService: InstancesService,
    private matDialog: MatDialog,
    private errorPageService: ErrorPageService,
    private blueprintsService: BlueprintsService,
    private solutionsService: SolutionsService,
    private configurationsService: ConfigurationsService,
    private urlService: UrlService,
    private sidenavService: SidenavService,
    private deploymentsService: DeploymentsService,
    private dialog: MatDialog,
    private workflowService: WorkflowService,
    private tourService: TourService,
    private solutionVersionsService: SolutionVersionsService,
    private permissionsService: PermissionsService,
    private notificationsService: NotificationsService,
    private router: Router,
    private installationSpecificationService: InstallationSpecificationService,
    private dateTimeService: DateTimeService,
    private readonly titleService: Title,
    private clipboardApi: ClipboardService,
    private cobService: CobService,
    private tenantInstanceService: TenantInstanceService, private backupService: BackupService,
    private featurePermissionsService: FeaturePermissionsService,private dbBackupService: DbbackupService,
    private formBuilder: FormBuilder,
    private changeDetectorRef: ChangeDetectorRef,
    public datePipe: DatePipe,
    private configService: ConfigurationsService,
    private overlay: Overlay,
    private viewContainerRef: ViewContainerRef,
    private positionBuilder: OverlayPositionBuilder,
    private localConfigService: LocalConfiguration,
    private userService: UserService,
    private activityService: ActivityService,
    public activityProgressService: ActivityProgressService,
    private appRef: ApplicationRef,
    private envScheduleService: EnvScheduleService,
    private instancePollingService: InstancePollingService
  ) {

  }

  ngOnDestroy(): void {
    if (this.progressTimer) clearInterval(this.progressTimer);
  }

  ngOnInit(): void {
    this.tenantService.tenantData$.subscribe((data: any) => {
      this.isAWS = data === CloudProvider.AWS ? true : false;
    });

    this.getBookmarks();
    this.userService.bookmarkRefresh$.subscribe(() => {
      this.getBookmarks();
      this.loadData();
    });
    this.otherInstance = [];
    this.preprodEnvironment = (window.location.href.split('.')[0].split('/')[2] === 'preprod');
    this.updatedPermissionsMap = this.permissionsService.resolveAPIPermissions(REQUIRED_PERMISSIONS);
    this.featuresMap = this.featurePermissionsService.resolveFeaturePermissions(REQUIRED_FEATURES);
    this.asyncInstances();
    this.progressTimer = setInterval(() => { this.currentTime = Date.now(); }, 1000);

    this.tenantInstanceService.reloadData$.subscribe(() => {
      this.loadData();
    });

    this.instanceService.refresh$.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(() => {
      this.loadBlueprint();
      this.loadData();
    });
      this.tenantOwnershipStatus = {};

      this.tenantService.tenant$.pipe(filter(tenant => tenant != null),take(1),takeUntilDestroyed(this.destroyRef)).subscribe(tenant => {
        this.isExternalTenant = tenant?.origin === TenantOrigin.EXTERNAL? true : false;
      });

      this.tenantService.getTenants().subscribe((tenantOwners: any[]) => {
        const instanceObj: any = {
          blueprintId: this.blueprintId
        };

        const allInstances: any[] = [];

        const fetchInstances = (page: number) => {
          this.instanceService.getInstances({ ...instanceObj, page }).subscribe((response: any) => {
            if (response?.data) {
              allInstances.push(...response.data);
            }
            if (response.hasNext === "true") {
              fetchInstances(page + 1);
            } else {
              for (let instance of allInstances) {
                const matchingTenant = tenantOwners.find(t => t.tenantId === instance.tenantId);
                const loggedInUserEmail = this.authService.principal.attributes.email;
                const isOwner = matchingTenant && matchingTenant.tenantOwner === loggedInUserEmail;
                this.tenantOwnershipStatus[instance.id] = isOwner;
              }
            }
          })
        };
        fetchInstances(0);
      });

    this.restoreStatus = [
      {value: 'preparing', label: "Setting Up",selected: false},
      {value: 'prepared', label: "Ready to Restore",selected: false},
      {value: 'preparation_failed', label: "Failed",selected: false},
      {value: 'promoting', label: "Restoring",selected: false},
      {value: 'promoted', label: "Restored",selected: false},
      {value: 'promotion_failed', label: "Restore Failed",selected: false},
    ];
    const date = [
      {value: 'Created date', selected: false}
    ];
    this.dropdownsList = [
      {
        title: 'Status',
        placeholder: 'Select Status',
        options: this.restoreStatus
      },
      {
        title: 'Date',
        placeholder: 'Select Date',
        options: date
      }
    ];
     if (localStorage.getItem('filteredRestoreStatus')) {
      const statusData = JSON.parse(localStorage.getItem('filteredRestoreStatus'));
      if (statusData) {
        this.selectedStatus = statusData;
        this.dropdownsList[0].options.forEach(element => {
          if(this.selectedStatus.find(item=> item === element.value)) {
            element.selected = true;
          }
        });
      }
    }

    if (localStorage.getItem('filteredRestoreDate')) {
      const dateData = JSON.parse(localStorage.getItem('filteredRestoreDate'));
      if (dateData) {
        this.date = dateData;
        this.dropdownsList[1].options.forEach(element => {
          if(dateData.find(item=> item === element.value)) {
            element.selected = true;
          }
        });
      }
    }
    this.getTenantAccountDetails();
    this.filterStartDate = localStorage.getItem('filteredRestoreStartDate') ? localStorage.getItem('filteredRestoreStartDate'): '';
    this.filterEndDate = localStorage.getItem('filteredRestoreEndDate') ? localStorage.getItem('filteredRestoreEndDate'): '';
  }

  hasMenuPermissions(instance: Instance): boolean {
    if (instance?.dataZone === DataZone.DEVELOPMENT) {
      return (this.permissionsMap[PermissionKeys.INSTANCE_CREATE_DATAZONE_NONPII]);
    }
    if (instance?.dataZone === DataZone.SECURE) {
      return (this.permissionsMap[PermissionKeys.INSTANCE_CREATE_DATAZONE_PII]);
    }
    if (instance?.dataZone === DataZone.LIVE) {
      return (this.permissionsMap[PermissionKeys.INSTANCE_CREATE_DATAZONE_LIVE]);
    }
    return false;
  }

  isExpiringSoon(contractEndDate: string): boolean {
    const today = new Date();
    const endDate = new Date(contractEndDate);
    const diffInDays = Math.ceil((endDate.getTime() - today.getTime()) / (1000 * 3600 * 24));
    return diffInDays < 0;
  }

  viewErrors(instance): void {
    if (instance?.errors?.length > 0) {
      let dialogData = {
        title: translate('NOTIFICATIONS.DEPLOYMENT_FAILED'),
        descriptionError: instance?.errors,
        subtitle: instance?.name
      };
      if (instance?.status === DeployStatus.TERMINATION_FAILED) {
        dialogData.title = translate('BLUEPRINT_SUMMARY.TERMINATION_FAILED');
      } else if (instance?.status === DeployStatus.CONFIGURATION_FAILED) {
        dialogData.title = translate('BLUEPRINT_SUMMARY.CONFIGURATION_FAILED');
      } else if (instance?.status === DeployStatus.TEST_FAILED) {
        dialogData.title = translate('CONFIGURATIONS.STATE.TEST_FAILED');
      } else if (instance?.status === DeployStatus.FAILED) {
        dialogData.title = translate('BLUEPRINT_SUMMARY.FAILED');
      } else {
        dialogData.title = translate('NOTIFICATIONS.DEPLOYMENT_FAILED');
      }
      dialogData.descriptionError = instance?.errors;
      this.dialog.open(ErrorDialogComponent, {
        minHeight: '342px',
        width: '630px',
        panelClass: 'flex-dialog',
        data: dialogData
      });
    }
  }

  openEditContractDateInstanceForm(instance): void {
    if(this.blueprintsVersionList) {
    const data = {
      title: translate('INSTANCE_DETAILS.UPDATE_MENU.EDIT_CONTRACT_END_DATE'),
      subtitle: instance.deploymentClass === this.devDeploymentClass ? 'DEV' : instance.environment,
      deployment: {
        blueprintId: this.blueprint.id
      } as Deployment,
      service: this.service,
      tenantDetails: this.tenantDetails,
      requestOrigination: instance.requestOrigination,
      blueprintsVersionList: this.blueprintsVersionList,
      name: instance.name,
      id: instance.id,
      releaseVersion: this.getBuildVersion(instance.solutionVersionId),
      editMode: true,
      instance: instance
  };
    this.openDeployInstance(data)
    .pipe(takeUntilDestroyed(this.destroyRef))
    .subscribe(deployment => {
      if (deployment) {
        this.loadData();
      }
    });
    this.sidenavService.openInRightSidenav(DeployInstanceFormComponent,  data);
  } else {
    if (this.blueprintsVersionList?.error) {
      this.instanceErrorModal(this.blueprintsVersionList.error);
    }
  }
}

// changing the tab selection
  onTabChange(data) {
    if (data === 2) {
      this.dbTab = true;
      this.instanceTab = false;
      this.serviceDefTab = false;
      this.metricsTab = false;
      // to reset previous selections
      this.cancel();
    } else if (data === 1) {
      this.selectedTarget = undefined;
      this.serviceDefTab = true;
      this.instanceTab = false;
      this.dbTab = false;
      this.metricsTab = false;
    } else if (data === 3) {
      this.serviceDefTab = false;
      this.instanceTab = false;
      this.dbTab = false;
      this.metricsTab = true;
      this.initializeUsageForm();
    } else {
      this.selectedTarget = undefined;
      this.instanceTab = true;
      this.serviceDefTab = false;
      this.dbTab = false;
      this.metricsTab = false;
    }
  }

  // to initialize restore db forms for target and source
  initializeRestoreForms(): void {
      const formConfig1: any = {
        targetEnvt: [undefined, [Validators.required]],
      };
      const formConfig2: any = {
        sourceEnvt: [undefined, [Validators.required]],
        backupType: [undefined, [Validators.required]],
        interval: [undefined, [Validators.required]],
        server: [undefined, [Validators.required]],
      }
      this.dbForms = [this.formBuilder.group(formConfig1), this.formBuilder.group(formConfig2)];
      this.environments = this.allInstances.filter(item => !this.INSTANCE_DRAG_DROP_NEGATIVE_STATUS.includes(item.status));
      this.environments = this.environments.sort((a, b) => a?.name.localeCompare(b?.name));
  }

  // getting databases to list when azure is selected as server
  getDatabases(): void  {
    this.serverEmptyError = false;
    this.instanceService.getInstanceDatabases(this.sourceEnvt[0].id)
    .pipe(takeUntilDestroyed(this.destroyRef))
    .subscribe(response => {
      this.databases = response.databases;
      this.uniqueDatabases = this.databases.filter((item, index) =>this.databases.findIndex(data => data.serverName === item.serverName) === index);
      if (this.uniqueDatabases?.length === 0) {
        this.serverEmptyError = true;
      }
    },
    (error) => {
      setTimeout(() => {
        const title = translate('ERRORS.SERVICE_AVAILABILITY');
        const message = error?.message ? error?.message : (error?.error?.message ? error?.error?.message : (error?.errmsg ? error?.errmsg : translate('SERVICE.INTERNAL_SERVER_ERROR')));
        this.toastrService.errMessage(message, title);
      }, 500);
    });
  }
  

  // setting solution version, datazone, class, release package to target once it is selected
  targetEnvtChange(event): void {
    this.disableNext = false;
    this.targetEnvt = [event.value];
    this.targetEnvt[0].solutionVersion = this.serviceVersions.find(ver => ver.id === this.targetEnvt[0].solutionVersionId).releaseVersion;
    this.targetEnvt[0].blueprintVersion = this.blueprintsVersionList.find(ver => ver.id === this.targetEnvt[0].blueprintVersionId).version;
    this.targetEnvt[0].releasePackage = this.configurations?.find(config => config.id === this.targetEnvt[0].configurationId)?.manifest?.version;
    this.dbForms[0].addControl('solutionVersion', new FormControl(''));
    this.dbForms[0].get('solutionVersion').setValue(this.targetEnvt[0].solutionVersion);
    this.dbForms[0].get('solutionVersion').disable();
    this.dbForms[0].addControl('dataZone', new FormControl(''));
    this.dbForms[0].get('dataZone').setValue(this.targetEnvt[0].dataZone);
    this.dbForms[0].get('dataZone').disable();
    this.dbForms[0].addControl('instanceClass', new FormControl(''));
    this.dbForms[0].get('instanceClass').setValue(this.targetEnvt[0].instanceClass);
    this.dbForms[0].get('instanceClass').disable();
    this.dbForms[0].addControl('releasePackage', new FormControl(''));
    this.dbForms[0].get('releasePackage').setValue(this.targetEnvt[0]?.releasePackage);
    this.dbForms[0].get('releasePackage').disable();
    if (this.targetEnvt[0].dataZone === Datazone.LIVE) {
      this.disableNext = true;
      const datazone = this.targetEnvt[0].dataZone[0].toUpperCase() + this.targetEnvt[0].dataZone.substr(1).toLowerCase();
      this.dialog.open(ErrorDialogComponent, {
        minHeight: '280px',
        width: '630px',
        panelClass: 'flex-dialog',
        data: {
          title:  translate('ERROR_DIALOG.INVALID_RESTORE_OPERATION'),
          description: translate('ERROR_DIALOG.INVALID_RESTORE_MESSAGE').replace(/datazone/g, datazone),
        }
      });
      return;
    }
    if (this.sourceEnvt?.[0]?.dataZone === Datazone.LIVE && this.targetEnvt?.[0]?.dataZone === Datazone.NONPII) {
      this.disableNext = true;
      const datazoneSource = this.sourceEnvt[0].dataZone === Datazone.PII ? this.sourceEnvt[0].dataZone.toUpperCase() : this.sourceEnvt[0].dataZone[0].toUpperCase() + this.sourceEnvt[0].dataZone.substr(1).toLowerCase();
      const datazoneTarget = this.targetEnvt[0].dataZone === Datazone.PII ? this.targetEnvt[0].dataZone.toUpperCase() : this.targetEnvt[0].dataZone[0].toUpperCase() + this.targetEnvt[0].dataZone.substr(1).toLowerCase();
      this.dialog.open(ErrorDialogComponent, {
        minHeight: '280px',
        width: '630px',
        panelClass: 'flex-dialog',
        data: {
          title:  translate('ERROR_DIALOG.INVALID_RESTORE_OPERATION'),
          description: translate('ERROR_DIALOG.INVALID_RESTORE_TARGET_SOURCE', {
                      source: datazoneSource,
                      target: datazoneTarget
                    })
                  }
      });
      return;
    }
    if (this.INSTANCE_DEPLOYING_STATES.includes(this.targetEnvt[0]?.status)) {
      this.disableNext = true;
      this.dialog.open(ErrorDialogComponent, {
        minHeight: '280px',
        width: '630px',
        panelClass: 'flex-dialog',
        data: {
          title:  translate('ERROR_DIALOG.RESTRICT_INPROGRESS_STATUS_TITLE'),
          description: translate('ERROR_DIALOG.RESTRICT_INPROGRESS_STATUS_MESSAGE').replace(/actual/g, '<b>' + this.targetEnvt[0]?.status + '</b>'),
          alertError: true
        }
      });
    }
  }

  // setting solution version, datazone, class, release package to source once it is selected
  sourceEnvtChange(event): void {
    this.disableNext = false;
    this.sourceEnvt = [event.value];
    this.selectDatabase = false;
    this.selectedDatabase = undefined;
    this.dbForms[1].get('backupType').setValue(undefined);
    this.dbForms[1].get('interval').setValue(undefined);
    this.dbForms[1].get('server').setValue(undefined);
    this.sourceEnvt[0].solutionVersion = this.serviceVersions.find(ver => ver.id === this.sourceEnvt[0].solutionVersionId).releaseVersion;
    this.sourceEnvt[0].blueprintVersion = this.blueprintsVersionList.find(ver => ver.id === this.sourceEnvt[0].blueprintVersionId).version;
    this.sourceEnvt[0].releasePackage = this.configurations?.find(config => config.id === this.sourceEnvt[0].configurationId)?.manifest?.version;
    this.getDatabases();
    this.dbForms[1].addControl('solutionVersion', new FormControl(''));
    this.dbForms[1].get('solutionVersion').setValue(this.sourceEnvt[0].solutionVersion);
    this.dbForms[1].get('solutionVersion').disable();
    this.dbForms[1].addControl('dataZone', new FormControl(''));
    this.dbForms[1].get('dataZone').setValue(this.sourceEnvt[0].dataZone);
    this.dbForms[1].get('dataZone').disable();
    this.dbForms[1].addControl('instanceClass', new FormControl(''));
    this.dbForms[1].get('instanceClass').setValue(this.sourceEnvt[0].instanceClass);
    this.dbForms[1].get('instanceClass').disable();
    this.dbForms[1].addControl('releasePackage', new FormControl(''));
    this.dbForms[1].get('releasePackage').setValue(this.sourceEnvt[0]?.releasePackage);
    this.dbForms[1].get('releasePackage').disable();
    if (this.sourceEnvt[0].dataZone === Datazone.LIVE && this.targetEnvt[0].dataZone === Datazone.NONPII) {
      this.disableNext = true;
      const datazoneSource = this.sourceEnvt[0].dataZone === Datazone.PII ? this.sourceEnvt[0].dataZone.toUpperCase() : this.sourceEnvt[0].dataZone[0].toUpperCase() + this.sourceEnvt[0].dataZone.substr(1).toLowerCase();
      const datazoneTarget = this.targetEnvt[0].dataZone === Datazone.PII ? this.targetEnvt[0].dataZone.toUpperCase() : this.targetEnvt[0].dataZone[0].toUpperCase() + this.targetEnvt[0].dataZone.substr(1).toLowerCase();

      this.dialog.open(ErrorDialogComponent, {
        minHeight: '280px',
        width: '630px',
        panelClass: 'flex-dialog',
        data: {
          title:  translate('ERROR_DIALOG.INVALID_RESTORE_OPERATION'),
          description: translate('ERROR_DIALOG.INVALID_RESTORE_TARGET_SOURCE', {
                      source: datazoneSource,
                      target: datazoneTarget
                    })
        }
      });
      return;
    }

    if ((this.targetEnvt?.[0]?.dataZone === DataZone.DEVELOPMENT && this.sourceEnvt?.[0]?.dataZone === DataZone.SECURE)
      || (this.targetEnvt?.[0]?.dataZone === DataZone.SECURE && this.sourceEnvt?.[0]?.dataZone === DataZone.DEVELOPMENT)
    ) {
      this.disableNext = true;
      this.dialog.open(ErrorDialogComponent, {
        minHeight: '280px',
        width: '630px',
        panelClass: 'flex-dialog',
        data: {
          title:  translate('ERROR_DIALOG.INVALID_RESTORE_OPERATION'),
          description: translate('ERROR_DIALOG.INVALID_RESTORE_MESSAGE'),
          source: this.sourceEnvt[0].name,
          target: this.targetEnvt[0].name
        }
      });
      return;
    }
    if (this.INSTANCE_DEPLOYING_STATES.includes(this.sourceEnvt[0]?.status)) {
      this.disableNext = true;
      this.dialog.open(ErrorDialogComponent, {
        minHeight: '280px',
        width: '630px',
        panelClass: 'flex-dialog',
        data: {
          title:  translate('ERROR_DIALOG.RESTRICT_INPROGRESS_STATUS_TITLE'),
          description: translate('ERROR_DIALOG.RESTRICT_INPROGRESS_STATUS_MESSAGE').replace(/actual/g, '<b>' + this.sourceEnvt[0]?.status + '</b>'),
          alertError: true
        }
      });
      return;
    }
    this.checkWarnings();
  }

  // to validate current step and move backward/forward in restore db page
  goToStep(step): void {
    const goingBackward = step < this.currentStep;
    if (!goingBackward && FormUtilService.validateForm(this.dbForms[this.currentStep])) {
      this.currentStep = step;
    } else if (goingBackward) {
      this.currentStep = step;
    }
  }

  // to set interval types based on db type selection
  backupTypeChange(): void {
    this.dbForms[1].get('interval').setValue(undefined);
    this.dbForms[1].get('server').setValue(undefined);
    this.selectDatabase = false;
    this.selectedDatabase = undefined;
    if (this.dbForms[1].get('backupType').value === 'snapshot') {
      this.intervalTypes = this.snapshotDBTypes;
    } else if (this.dbForms[1].get('backupType').value === 'archive') {
      this.intervalTypes = this.archiveDBTypes;
    }
  }

  backupIntervalChange(): void {
    this.dbForms[1].get('server').setValue(undefined);
    this.selectDatabase = false;
    this.selectedDatabase = undefined;
  }

  // confirmation for cancel restore
  cancelClick(): void {
    this.dialog.open(ConfirmationDialogComponent, {
      panelClass: 'default-dialog-wrapper',
      width: '566px',
      autoFocus: false,
      data: {
        title: translate('INSTANCE_SUMMARY.CANCEL_TITLE'),
        message: translate('INSTANCE_SUMMARY.CANCEL_MESSAGE'),
        confirmButtonText: translate('BUTTONS.CONFIRM')
      }
    })
    .afterClosed()
    .pipe(takeUntilDestroyed(this.destroyRef))
    .subscribe(confirm => {
      if (confirm) {
        this.cancel();
      }
    })
  }

  // resetting form on restore db cancel click
  cancel(): void {
    this.createRestorePage = false;
    this.targetEnvt = undefined;
    this.sourceEnvt = undefined;
    this.intervalTypes = [];
    this.currentStep = 0;
    this.selectedDatabase = undefined;
    this.selectDatabase = false;
    this.initializeRestoreForms();
  }

  // checking for warnings after target and source selected
  checkWarnings(): void {
    let warnings = [];
    const target = this.targetEnvt[0];
    const source = this.sourceEnvt[0];
    if (target.solutionVersion !== source.solutionVersion) {
      warnings = [...warnings, translate('BLUEPRINT_SUMMARY.SOLUTION_VERSION_WARNING').replace(/from/g, target.name).replace(/to/g, source.name)];
    }
     if (target.blueprintVersion !== source.blueprintVersion) {
      warnings = [...warnings, translate('BLUEPRINT_SUMMARY.BLUEPRINT_MISMATCH').replace(/from/g, target.name).replace(/to/g, source.name)];
    }
    if (target.configurationId && source.configurationId && this.configurations?.find(config => config.id === target.configurationId)?.manifest?.version !== this.configurations?.find(config => config.id === source.configurationId)?.manifest?.version) {
      warnings = [...warnings, translate('BLUEPRINT_SUMMARY.RELEASE_PACKAGE_MISMATCH').replace(/from/g, target.name).replace(/to/g, source.name)];
    }
    if (warnings?.length > 0) {
      this.dialog.open(WarningDialogComponent, {
        minHeight: '280px',
        width: '630px',
        panelClass: 'flex-dialog',
        data: {
          title:  translate('INSTANCE_SUMMARY.RESTORE_DATABASE'),
          description: warnings,
          cancelButton: false
        }
      })
    }
  }

  // to go to create restore flow from table view
  createRestore(): void {
    this.createRestorePage = true;
  }

  // showing select database section when server is selected as azure
  serverChange(event): void {
    if (this.sourceEnvt[0].dataZone !== Datazone.LIVE &&
      !((this.targetEnvt?.[0]?.dataZone === DataZone.DEVELOPMENT && this.sourceEnvt?.[0]?.dataZone === DataZone.SECURE)
      || (this.targetEnvt?.[0]?.dataZone === DataZone.SECURE && this.sourceEnvt?.[0]?.dataZone === DataZone.DEVELOPMENT)
    ) &&
      !this.INSTANCE_DEPLOYING_STATES.includes(this.sourceEnvt[0]?.status) && !this.INSTANCE_DEPLOYING_STATES.includes(this.targetEnvt[0]?.status) && this.targetEnvt[0].dataZone !== Datazone.LIVE) {
        this.disableNext = false;
      }
    this.selectDatabase = false;
    this.selectedDatabase = undefined;
    const database = this.databases.find(item => item.serverName === event.value);
    if (database?.type?.toLowerCase()?.includes('sql') && !database?.type?.toLowerCase()?.includes('postgre')) {
      this.selectDatabase = true;
      this.getInstanceBackupResults();
    } else if (database?.type?.toLowerCase()?.includes('postgre')) {
      this.disableNext = true;
      this.dialog.open(ErrorDialogComponent, {
        minHeight: '280px',
        width: '630px',
        panelClass: 'flex-dialog',
        data: {
          title:  translate('ERROR_DIALOG.RESTORE_POSTGRE_ERROR_TITLE'),
          description: translate('ERROR_DIALOG.RESTORE_POSTGRE_ERROR_MESSAGE'),
          alertError: true
        }
      });
    } else {
      this.selectDatabase = false;
    }
  }

  // getting backup results of source instance
  getInstanceBackupResults(): void {
    this.dbEmptyError = false;
    this.isBackupTableLoading = true;
    this.dbBackupService.getInstanceDbBackups(this.sourceEnvt[0].id)
    .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(results => {
        if (results?.data?.length === 0) {
          this.dbEmptyError = true;
        }
        if (Number(results.total) > 10) {
          this.dbBackupService.getInstanceDbBackups(this.sourceEnvt[0].id, results?.total)
          .pipe(takeUntilDestroyed(this.destroyRef))
            .subscribe(response => {
              this.processDbData(response);
            })
        } else {
          this.processDbData(results);
        }
      },
      (error) => {
        this.isBackupTableLoading = false;
        setTimeout(() => {
		      const title = translate('ERRORS.SERVICE_AVAILABILITY');
          const message = error?.message ? error?.message : (error?.error?.message ? error?.error?.message : (error?.errmsg ? error?.errmsg : translate('SERVICE.INTERNAL_SERVER_ERROR')));
          this.toastrService.errMessage(message, title);
        }, 500);
      });
  }

  // sorting Db data by latest on top
    processDbData(results): void {
    this.backupResults = [];
    results.data = results?.data?.sort((a, b) => new Date(b?.createdAt).getTime() - new Date(a?.createdAt).getTime());
    results.data.forEach(record => {
      if (record.status === 'completed' && (new Date(record?.expirationDate).setHours(12, 0, 0, 0) - new Date().setHours(12, 0, 0, 0) < 0)) {
        record.status = 'expired';
      }
    })
    this.backupResults = results?.data.filter(item => item.status !== 'deleted' && item.status !== 'expired');
    this.isBackupTableLoading = false;
  }

  // show the popup with db list
  selectBackupClick(): void {
    this.backupResults?.forEach(item => item.name = item.backupType === 'snapshot' ? (item.to?.databaseName ?  item.to?.databaseName : item.to?.fileName) : item.backupType === 'archive' ? (item.to?.fileName ? item.to?.fileName : item.to?.databaseName) : '');
    this.matDialog.open(SelectDatabaseComponent, {
        panelClass: 'default-dialog-wrapper-db',
        width: '86vw',
        maxHeight: '98vh',
        autoFocus: false,
        data: {
          backupResults: this.backupResults?.filter(item => item.status?.toLowerCase() === 'completed' && item.from?.serverName === this.dbForms[1].get('server').value && item.backupType === this.dbForms[1].get('backupType').value)?.map(item => ({...item, name: item.backupType === 'snapshot' ? (item.to?.databaseName ? item.to?.databaseName : item.to?.fileName) : item.backupType === 'archive' ? (item.to?.fileName ? item.to?.fileName : item.to?.databaseName) : '' })),
          server: this.dbForms[1].get('server').value,
          tenantId: this.tenantId
        }
      })
      .afterClosed()
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(data => {
        this.selectedDatabase = data;
      })
  }

  // resetting the selected database on delete icon click
  deleteSelectedDb(): void {
    this.selectedDatabase = undefined;
  }

  // refreshing restore records
  refreshRestores(): void {
    this.getInstanceRestores();
  }

  // submitting restore db
  submitRestore(): void {
    this.restoreTicketsLoading = true;
    let data = [];
    this.dbBackupService.getInstanceRestores(this.targetEnvt[0].id)
      .subscribe(results => {
        if (Number(results.total) > 10) {
          this.dbBackupService.getInstanceRestores(this.targetEnvt[0].id, results?.limit)
          .pipe(takeUntilDestroyed(this.destroyRef))
            .subscribe(response => {
              data = response?.data;
              this.getConfirmation(data);
              this.restoreTicketsLoading = false;
            })
        } else {
          data = results?.data;
          this.getConfirmation(data);
          this.restoreTicketsLoading = false;
        }
      },
      (error) => {
        this.restoreTicketsLoading = false;
        setTimeout(() => {
          const title = translate('ERRORS.SERVICE_AVAILABILITY');
          const message = error?.message ? error?.message : (error?.error?.message ? error?.error?.message : (error?.errmsg ? error?.errmsg : translate('SERVICE.INTERNAL_SERVER_ERROR')));
          this.toastrService.errMessage(message, title);
        }, 500);
      });
  }

  getConfirmation(data): void {
    this.dialog.open(ConfirmationDialogComponent, {
      panelClass: 'default-dialog-wrapper',
      width: '566px',
      autoFocus: false,
      data: {
        title: translate('INSTANCE_SUMMARY.RESTORE_DATABASE'),
        message: translate('INSTANCE_SUMMARY.SUBMIT_MESSAGE'),
        note: translate('INSTANCE_SUMMARY.RESTORE_NOTE'),
        noteTextColor: true,
        ticketIdField: true,
        restoreList: data,
        confirmButtonText: translate('BUTTONS.CONFIRM')
      }
    })
    .afterClosed()
    .pipe(takeUntilDestroyed(this.destroyRef))
    .subscribe(data => {
      if (data) {
        const obj = {
          id: this.targetEnvt[0].id,
          backupId: this.selectedDatabase?.id,
          ticketNumber: data.ticketNumber
        }
        this.dbBackupService.postInstanceRestore(obj).pipe(takeUntilDestroyed(this.destroyRef))
          .subscribe(data => {
            this.createRestorePage = false;
            this.selectedTarget = this.allInstances.find(item => item.id === this.targetEnvt[0].id);
            this.cancel();
            this.getInstanceRestores();
          },
          (error) => {
            const errorMessage = typeof error === 'string' ? error: typeof error?.error === 'string' ? error.error : error;
            this.dialog.open(ErrorDialogComponent, {
              minHeight: '280px',
              width: '630px',
              panelClass: 'flex-dialog',
              data: {
                title:  translate('INSTANCE_SUMMARY.CREATE_RESTORE_FAILED'),
                description: errorMessage
              }
            });
          });
      }
    })
  }

  getInstanceRestores(): void {
    if (this.selectedTarget) {
      this.disableRestore = false;
      this.restoreLoading = true;
      this.restoreError = false;
      this.dbBackupService.getInstanceRestores(this.selectedTarget.id)
      .subscribe(results => {
        if (Number(results.total) > 10) {
          this.dbBackupService.getInstanceRestores(this.selectedTarget.id, results?.limit)
          .pipe(takeUntilDestroyed(this.destroyRef))
            .subscribe(response => {
              this.restoreLoading = false;
              this.initialRestoreRecords = response?.data?.sort((a, b) => (a.createdAt > b.createdAt) ? -1 : 1);
              this.disableRestore = this.initialRestoreRecords.some(item => this.dbInitialStatus.includes(item.status));
              this.initialRestoreRecords.forEach(item => {
                item.disableRestore = this.disableRestore;
                item.targetInstanceName = this.selectedTarget?.name;
                item.sourceInstanceName = this.allInstances.find(envt => envt.id === item.backupInstanceId)?.name;
              })
              this.restoreRecords = this.initialRestoreRecords;
              this.initialFilterItems();
            })
        } else {
          this.restoreLoading = false;
          this.initialRestoreRecords = results?.data?.sort((a, b) => (a.createdAt > b.createdAt) ? -1 : 1);
          this.disableRestore = this.initialRestoreRecords.some(item => this.dbInitialStatus.includes(item.status));
          this.initialRestoreRecords.forEach(item => {
            item.disableRestore = this.disableRestore;
            item.targetInstanceName = this.selectedTarget?.name;
            item.sourceInstanceName = this.allInstances.find(envt => envt.id === item.backupInstanceId)?.name;
          })
          this.restoreRecords = this.initialRestoreRecords;
          this.initialFilterItems();
        }
      },
      (error) => {
        this.restoreLoading = false;
        this.restoreError = true;
        const errorMessage = typeof error === 'string' ? error: typeof error?.error === 'string' ? error.error : error;
        this.dialog.open(ErrorDialogComponent, {
          minHeight: '280px',
          width: '630px',
          panelClass: 'flex-dialog',
          data: {
            title:  translate('INSTANCE_SUMMARY.RESTORED_DATABASE'),
            description: errorMessage
          }
        });
      });
    } else {
      this.restoreLoading = false;
    }
  }

  searchRestore(event): void {
    this.restoreSearchTerm = event;
  }

  promoteClick(event): void {
    if (this.initialRestoreRecords.some(item => this.dbInitialStatus.includes(item.status))) {
      this.dialog.open(GenericErrorComponent, {
        minHeight: '342px',
        width: '566px',
        panelClass: 'flex-dialog'
      });
    } else {
      if(event.action === 'delete') {
        this.deleteDataBase(event);
      } else if (event.action === 'retry') {
        this.handleRetry(event);
        return;
      }
      else {
      this.dialog.open(ConfirmationDialogComponent, {
        panelClass: 'default-dialog-wrapper',
        width: '566px',
        autoFocus: false,
        data: {
          title: translate('INSTANCE_SUMMARY.RESTORE_DATABASE'),
          message: translate('INSTANCE_SUMMARY.SUBMIT_MESSAGE'),
          confirmButtonText: translate('BUTTONS.CONFIRM')
        }
      })
      .afterClosed()
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(data => {
        if (data) {
          this.dbBackupService.putInstanceRestore(this.selectedTarget.id, event.id).pipe(takeUntilDestroyed(this.destroyRef))
          .subscribe(data => {
            this.restoreRecords.find(item => item.id === data.id).status = data.status;
            this.disableRestore = true;
            this.initialRestoreRecords.forEach(item => {
              item.disableRestore = this.disableRestore;
            });
            this.restoreRecords.forEach(item => {
              item.disableRestore = this.disableRestore;
            });
          },
          (error) => {
            setTimeout(() => {
              const title = translate('ERRORS.SERVICE_AVAILABILITY');
              const message = error?.message ? error?.message : (error?.error?.message ? error?.error?.message : (error?.errmsg ? error?.errmsg : translate('SERVICE.INTERNAL_SERVER_ERROR')));
              this.toastrService.errMessage(message, title);
            }, 500);
          });
        }
      })
    }
   }
  }

/* Handles retry restore action with confirmation dialog and 7-day validation */
handleRetry(event): void {

  const isWithin7Days = this.isWithin7Days(event.createdAt);

  if (!isWithin7Days) {
    this.dialog.open(ErrorDialogComponent, {
      minHeight: '280px',
      width: '630px',
      panelClass: 'flex-dialog',
      data: {
        title: translate('INSTANCE_SUMMARY.RESTORE_VALIDATION'),
        description: translate('INSTANCE_SUMMARY.RETRY_NOTE'),
        alertError: true
      }
    });
    return;
  }

  this.dialog.open(ConfirmationDialogComponent, {
    panelClass: 'default-dialog-wrapper',
    width: '566px',
    autoFocus: false,
    data: {
      title: translate('INSTANCE_SUMMARY.RETRY_RESTORE'),
      message: translate('INSTANCE_SUMMARY.SUBMIT_MESSAGE'),
      confirmButtonText: translate('BUTTONS.CONFIRM')
    }
  })
  .afterClosed()
  .pipe(takeUntilDestroyed(this.destroyRef))
  .subscribe(confirm => {
    if (confirm) {
      this.dbBackupService.putInstanceRestore(this.selectedTarget.id, event.id).pipe(takeUntilDestroyed(this.destroyRef))
          .subscribe(data => {
            this.restoreRecords.find(item => item.id === data.id).status = data.status;
            this.disableRestore = true;
            this.initialRestoreRecords.forEach(item => {
              item.disableRestore = this.disableRestore;
            });
            this.restoreRecords.forEach(item => {
              item.disableRestore = this.disableRestore;
            });
          },
          (error) => {
            setTimeout(() => {
              const title = translate('ERRORS.SERVICE_AVAILABILITY');
              const message = error?.message ? error?.message : (error?.error?.message ? error?.error?.message : (error?.errmsg ? error?.errmsg : translate('SERVICE.INTERNAL_SERVER_ERROR')));
              this.toastrService.errMessage(message, title);
            }, 500);
          });
    }
  });
}

/* Checks if the given date is within the last 7 calendar days */
isWithin7Days(date: string): boolean {
  if (!date) return false;
  return moment().startOf('day').diff(moment(date).startOf('day'), 'days') < 7;
}

  sourceClicked(event): void {
    this.dbDetailsLoading = true;
    this.dbBackupService.getInstanceDbBackupById(event.backupInstanceId, event.backupId)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(response => {
        this.dbDetailsLoading = false;
        event.backupType = response?.backupType;
        event.backupInterval = response?.backupInterval;
        event.serverName = response?.from?.serverName;
        event.databaseName = response?.from?.databaseName;
        event.dbDetails = response;
        this.matDialog.open(BackupDetailsComponent, {
          minHeight: '533px',
          width: '760px',
          panelClass: 'flex-dialog',
          data: {
            details: event
          }
        })
      },
      (error) => {
        this.dbDetailsLoading = false;
        setTimeout(() => {
          const title = translate('ERRORS.SERVICE_AVAILABILITY');
          const message = error?.message ? error?.message : (error?.error?.message ? error?.error?.message : (error?.errmsg ? error?.errmsg : translate('SERVICE.INTERNAL_SERVER_ERROR')));
          this.toastrService.errMessage(message, title);
        }, 500);
      });
  }

  selectionChanged(event): void {
    this.selectedTarget = this.restoreEnvironments.find(item => item.name === event?.value);
    this.getInstanceRestores();
  }

  searchedItems(result): void {
    this.searchedResult = result;
  }

  filterColumns(): void {
    if (this.status) {
      this.dropdownsList[0].options.filter((item) => {
        if (this.status?.find(status => status === item.value)) {
          item.selected = true;
        }
      });
    }
    if (this.date) {
      this.dropdownsList[1].options.filter((item) => {
        if (item.value === this.date) {
          item.selected = true;
        }
      });
    }
    const data = {
      name: translate('SCHEDULES.SCHEDULE_FILTERS'),
      title: translate('INSTANCE_STATUS.FILTER_TITLE'),
      subtitle: translate('INSTANCE_STATUS.FILTER_SUBTITLE'),
      filteredColumns: this.dropdownsList,
      scheduleStatusList: this.dropdownsList[0].options,
      scheduleDate: this.dropdownsList[1].options,
      scheduleStartDate: this.dropdownsList[1].options[0]?.selected ? moment(this.filterStartDate) : '',
      scheduleEndDate: this.dropdownsList[1].options[0]?.selected ? moment(this.filterEndDate) : '',
      scheduleColumns: [
        'status',
        'date'
      ]
    };
    this.sidenavService.openInRightSidenav(ColumnFilterComponent, data)
    .pipe(takeUntilDestroyed(this.destroyRef))
    .subscribe(filteredColumns => {
      this.filteredColumns = filteredColumns;
      if (filteredColumns) {
        this.clearData = true;
        if (filteredColumns[0] !== '') {
          this.status = filteredColumns[0];
        }
        if (filteredColumns[2] !== '') {
          localStorage.removeItem('filteredRestoreDate');
          this.date = filteredColumns[2];
          localStorage.setItem('filteredRestoreDate', JSON.stringify(filteredColumns[2]));
        }
        if (filteredColumns[0]?.length === 0 && filteredColumns[2]?.length === 0){
          this.resetRestoreFilter();
        } else {
          this.filterRestoreItems(filteredColumns);
        }
      }
    });
  }

  filterRestoreItems(filteredColumns): void {
    if (!filteredColumns){
      this.initialFilterItems()
    }
    if (filteredColumns) {
      this.restoreRecords = this.initialRestoreRecords;
      this.selectedStatus = [];
      if (filteredColumns[0]?.length > 0) {
        this.selectedStatus = filteredColumns[0];
        if (filteredColumns[0].length > 0) {
          localStorage.setItem('filteredRestoreStatus', JSON.stringify(this.selectedStatus));
          this.restoreRecords = this.restoreRecords?.filter(item => this.selectedStatus?.includes(item?.status));
        } else {
          localStorage.removeItem('filteredRestoreStatus');
        }
      }

      if (this.dropdownsList[1].options[0].selected && moment(filteredColumns[3].filteredStartDate).isValid() && moment(filteredColumns[3].filteredEndDate).isValid()) {
        this.filterStartDate = filteredColumns[3].filteredStartDate;
        this.filterEndDate = filteredColumns[3].filteredEndDate;
        localStorage.setItem('filteredRestoreStartDate', this.filterStartDate);
        localStorage.setItem('filteredRestoreEndDate', this.filterEndDate);
        this.restoreRecords = this.restoreRecords?.filter(item => (this.datePipe.transform(item.createdAt, 'yyyy-MM-dd') >= this.datePipe.transform(this.filterStartDate, 'yyyy-MM-dd') &&
          this.datePipe.transform(item.createdAt, 'yyyy-MM-dd') <= this.datePipe.transform(this.filterEndDate, 'yyyy-MM-dd')));
      } else {
        this.filterStartDate = undefined;
        this.filterEndDate = undefined;
        localStorage.removeItem('filteredRestoreStartDate');
        localStorage.removeItem('filteredRestoreEndDate');
      }
    }
  }

  initialFilterItems() {
    this.restoreRecords = this.initialRestoreRecords;
    if (this.selectedStatus?.length > 0) {
      this.restoreRecords = this.restoreRecords?.filter(item => this.selectedStatus?.includes(item?.status));
    }

    if (this.dropdownsList[1].options[0].selected && this.filterStartDate && this.filterEndDate) {
      this.restoreRecords = this.restoreRecords?.filter(item => (this.datePipe.transform(item.createdAt, 'yyyy-MM-dd') >= this.datePipe.transform(this.filterStartDate, 'yyyy-MM-dd') &&
        this.datePipe.transform(item.createdAt, 'yyyy-MM-dd') <= this.datePipe.transform(this.filterEndDate, 'yyyy-MM-dd')));
    }
  }

  getUTCTimestamp(date): any {
    return Date.parse(moment(new Date(date)).utc().format('DD MMM YYYY HH:mm:ss'));
  }

  getStatusLabel(status): void {
    return this.restoreStatus.find(item=> item.value === status).label;
  }

  cancelStatusFilter(data) {
    let selectedItem = this.selectedStatus.indexOf(data);
    if (selectedItem > -1) {
      localStorage.removeItem('filteredRestoreStatus');
      this.selectedStatus.splice(selectedItem, 1);
      this.dropdownsList[0].options.find(item => item.value === data).selected = false;
      localStorage.setItem('filteredRestoreStatus', JSON.stringify(this.selectedStatus));
      this.filterRestoreItems(this.filteredColumns);
    }
  }

  cancelRestoreDateFilter() {
    this.filterStartDate = undefined;
    this.filterEndDate = undefined;
    this.dropdownsList[1].options[0].selected = false;
    this.date?.forEach(element => {
      if(element.includes(this.dropdownsList[1].options[0].value)) {
        this.date.pop(element);
      }
    });

    localStorage.removeItem('filteredRestoreStartDate');
    localStorage.removeItem('filteredRestoreEndDate');
    localStorage.removeItem('filteredRestoreDate');
    this.filterRestoreItems(this.filteredColumns);
  }

  resetRestoreFilter(): void {
    this.selectedStatus = [];
    this.dropdownsList[0].options.filter((item) => {item.selected = false});
    this.dropdownsList[1].options.filter((item) => {item.selected = false});
    this.status = undefined;
    this.date = undefined;
    this.filterStartDate = undefined;
    this.filterEndDate = undefined;
    this.restoreRecords = this.initialRestoreRecords;
    localStorage.removeItem('filteredRestoreStatus');
    localStorage.removeItem('filteredRestoreDate');
    localStorage.removeItem('filteredRestoreStartDate');
    localStorage.removeItem('filteredRestoreEndDate');
  }

  mouseOver(data): void {
   this.hoveredInstance = data.id ?? data.name;
  }

  mouseOut(data): void {
    this.hoveredInstance = null;
  }

  asyncInstances(): void {
        this.blueprintId = this.blueprint.id;

    // this.enterpriseClient = this.authService.hasPermission(Permission.VIEW_ENTERPRISE);
    this.permissionsMap = this.permissionsService.resolveAPIPermissions(REQUIRED_PERMISSIONS);
    this.viewPermission =(!this.permissionsMap.INSTANCE_READ_DATAZONE_LIVE) && (!this.permissionsMap.INSTANCE_READ_DATAZONE_NONPII) && (!this.permissionsMap.INSTANCE_READ_DATAZONE_PII) ? false :true;
    this.tenant = this.authService.principal.provider;
    this.tenantId = this.activatedRoute.snapshot.params.id;
    this.devDeploymentClass = DeploymentClass.D;

    this.subscribeForNotifications();
    this.subscribeForNotification();

    // If navigated to the same route with different parameters (through notifications for example).
    this.activatedRoute.params
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(() => {
        this.loadService();
      });

    this.tenantService.getTenantDetails(this.tenantId)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(tenantData => {
        this.tenantDetails = tenantData;
        if(this.tenantDetails?.parameters?.hasSecondaryRegion && (this.tenantDetails?.parameters?.hasSecondaryRegion === 'true' || this.tenantDetails?.parameters?.hasSecondaryRegion === true)) {
          this.hasSecondaryRegion = true;
        } else if(!this.tenantDetails?.parameters?.hasSecondaryRegion) {
          this.hasSecondaryRegion = true;
        } else {
          this.hasSecondaryRegion = false;
        }
        if(this.tenantDetails?.parameters?.instanceStopStart?.length > 0) {
          this.tenantDetails?.parameters?.instanceStopStart.forEach(data => {
            if(data === 'nonpii') {
              this.nonpiiStartStop = true;
            }
            if(data === 'pii') {
              this.piiStartStop = true;
            }
          })
        }
      });

    this.isNewServiceDefinitionVersion = !!history.state.data;
  }

  /**
   * Opens the form for creating the configuration instance and when the user is done
   * providing the needed information the proper method is called to proceed further
   */
  openCreateConfigurationInstanceForm(firstDev?: string): void {
    let migrationMsg;
    if(firstDev && !(firstDev === "nonPtl") && this.onBoardingProcess === 'migration') {
      migrationMsg = true;
    }
      const devInstance = DataZone.DEVELOPMENT;
      if(this.blueprintsVersionList) {
      const data = {
        confirmationMsg: migrationMsg,
        selectedISBType: this.blueprint?.selectedISBType,
        title: firstDev && firstDev === "nonPtl" ? translate('NON_PTL.CREATE_NON_PATH_TO_LIVE') : translate('INSTANCE_SUMMARY.CREATE_DEVELOPMENT_INSTANCE.TITLE'),
        subtitle: firstDev && firstDev === "nonPtl" ? translate('NON_PTL.NON_PATH_TO_LIVE') : devInstance.charAt(0).toUpperCase() + devInstance.slice(1),
        deployment: {
          blueprintId: this.blueprint.id,
          ...(firstDev && firstDev === "nonPtl" ? {} : { dataZone: DataZone.DEVELOPMENT }),
          ...(firstDev && firstDev === "nonPtl" ? {} : { deploymentClass: DeploymentClass.D }),
          blueprintVersionId: this.blueprintsVersionList,
          devInstanceFlow: true
        } as Deployment,
        ...(firstDev && firstDev === "nonPtl" ? { nonPtlFlow: true } : {}),
        service: this.service,
        tenantDetails: this.tenantDetails,
        blueprintsVersionList: this.blueprintsVersionList,
        instanceBlueprint: this.instanceBlueprint,
        checkInstanceClass: DeploymentClass.D
    };
    this.openDeployInstance(data)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(deployment => {
        if (deployment) {
          this.loadData();
        }
      });
    } else {
      if (this.blueprintsVersionList?.error) {
        this.instanceErrorModal(this.blueprintsVersionList.error);
      }
    }
  }

  instanceErrorModal(error?: any): void {
    const errorMessage = typeof error === 'string' ? error: typeof error?.error === 'string' ? error.error : error;
    this.matDialog.open(ErrorDialogComponent, {
      minHeight: '342px',
      width: '566px',
      panelClass: 'flex-dialog',
      data: {
        title:  translate('NOTIFICATIONS.INSTANCE_FAILED'),
        description: errorMessage,
      }
    });
  }

 /**
 * @param instanceId
 * @returns true if the instance has a latest failed config or update activity.
 */
  getInstaceActivity(instanceId): Observable<boolean> {
    return this.activityService.getInstanceActivityLogs(instanceId).pipe(takeUntilDestroyed(this.destroyRef),
      map(data => {
        if (!data?.length) {
          return false;
        }
        const latestAction = data.filter(log => log?.status === 'failed' || (log?.action === 'config' && this.instances?.status === DeployStatus.CONFIGURATION_FAILED) || (log?.action === 'config' && this.instances?.status === DeployStatus.TEST_FAILED) ||
        (log?.action === 'update' && this.instances?.status === DeployStatus.UPDATE_FAILED)).sort((a, b) => new Date(b?.startTime).getTime() -new Date(a?.startTime).getTime())[0];
        return !!latestAction;
      })
    );
  }

  /**
 * @param data
 * @returns if it is failed based on actvity actions, then it will the show warning messaage .
 */
  applyLocalConfig(data): void {
    const showWarning = this.instanceWarningStatus.get(data.id);
    if (showWarning) {
      this.dialog.open(ConfirmationDialogComponent, {
        panelClass: 'default-dialog-wrapper',
        autoFocus: false,
        width: '566px',
        data: {
          title: translate('INSTANCE_SUMMARY.MENU.APPLY_CONFIG', { action: translate('INSTANCE_SUMMARY.MENU.APPLY_LOCAL') }),
          message: translate('INSTANCE_SUMMARY.MENU.LOCAL_CONFIG', { action: translate('INSTANCE_SUMMARY.MENU.APPLY_LOCAL') }),
          confirmButtonText: translate('INSTANCE_DETAILS.UPDATE_BUILD.PROCEED'),
          warning: true
        },
      })
        .afterClosed()
        .pipe(takeUntilDestroyed(this.destroyRef))
        .subscribe(confirm => {
          if (confirm) {
            this.applyLocalConfigConfirm(data);
          }
        });
    } else {
      this.applyLocalConfigConfirm(data);
    }
  }

  applyLocalConfigConfirm(data): void {
    if (this.INSTANCE_AVAILABLE_STATES.includes(data?.status)) {
      this.dialog.open(ConfirmationDialogComponent, {
        panelClass: 'default-dialog-wrapper',
        autoFocus: false,
        width: '566px',
        data: {
          title: translate(`BLUEPRINT_SUMMARY.CONFIRM_LOCAL_APPLY.TITLE`),
          message: translate(`BLUEPRINT_SUMMARY.CONFIRM_LOCAL_APPLY.MESSAGE`),
          confirmButtonText: translate('BUTTONS.SUBMIT')
        }
      })
        .afterClosed()
        .pipe(takeUntilDestroyed(this.destroyRef))
        .subscribe(confirm => {
          if (confirm) {
            this.applyingLocalConfigInstanceIds.add(data.id);
            this.applyLocalConfigValue = true;
            this.instanceService.applyLocalConfig(data.id, 'local_config')
            .pipe(takeUntilDestroyed(this.destroyRef))
            .subscribe((data) => {
              if(data){
                this.applyLocalConfigValue = false;
                this.applyingLocalConfigInstanceIds.delete(data.id);
                this.instanceService.setConfigApplied(data.id);
              }
              this.loadData();
            setTimeout(() => {
              const title = translate('INSTANCE_SUMMARY.MENU.APPLY_LOCAL_CONFIG');
              const message = translate('INSTANCE_SUMMARY.MENU.APPLY_LOCAL_CONFIG_SUCCESS');
              this.toastrService.successMessage(message, title);
            }, 500);
            },
            (error) => {
              this.applyingLocalConfigInstanceIds.delete(data.id);
              this.applyLocalConfigValue = false;
              const errorMessage = typeof error === 'string' ? error: typeof error?.error === 'string' ? error.error : error;
              this.matDialog.open(ErrorDialogComponent, {
                minHeight: '342px',
                width: '566px',
                panelClass: 'flex-dialog',
                data: {
                  title:  translate('NOTIFICATIONS.APPLY_LOCAL_CONFIGURATION_FAILED'),
                  description: errorMessage,
                }
              });
          });
          }
        });
    }
  }

  // secret(instance): void {
  //   this.instanceId = instance?.id;
  //   this.instanceName = instance?.name;
  //   this.environment = (instance.deploymentClass === this.devDeploymentClass ? 'DEV' : instance.environment);
  //   this.matDialog.open(SecretComponent, {
  //     minHeight: '680px',
  //     minWidth: '1080px',
  //     panelClass: 'flex-dialog',
  //     data: {
  //       serviceName:  this.service?.name,
  //       serviceDefinition : this.isBlueprintsVersionlAvaliable(this.blueprintsVersionList,
  //         instance.blueprintVersionId)?.length? this.getVersion[0]?.version: '-',
  //       blueprintName: this.blueprint?.name,
  //       environment : this.environment,
  //       instanceName: this.instanceName,
  //       instanceId: this.instanceId,
  //       capabilities: this.isBlueprintsVersionlAvaliable(this.blueprintsVersionList,
  //         instance.blueprintVersionId)?.length? this.getVersion[0]?.capabilities: '-',
  //     }
  //   });
  // }

  onDeploy(instance: Instance, workflowApproval: WorkflowApproval, event): void {
    if ((instance.previousEnvironment && !this.INSTANCE_DEPLOYED_STATES.includes(instance.previousInstance?.status)) || (!instance.previousEnvironment && instance.deploymentClass !== this.devDeploymentClass && !this.devDeployed) || 
      !this.permissionsMap[PermissionKeys.INSTANCE_CREATE_DATAZONE_LIVE] || !this.permissionsMap[PermissionKeys.INSTANCE_CREATE_DATAZONE_PII]){
      this.matDialog.open(GenericErrorComponent, {
        minHeight: '342px',
        width: '566px',
        panelClass: 'flex-dialog'
      });
    } else {
    event.stopPropagation();
      if(this.blueprintsVersionList[0]) {
        this.openDeployPTLInstanceDialog(instance);
      } else {
        this.instanceErrorModal(this.blueprintsVersionList.error);
      }
    }
  }

  onReDeploy(instance: Instance, event): void {
    event.stopPropagation();
    this.dialog.open(ConfirmationDialogComponent, {
      panelClass: 'default-dialog-wrapper',
      width: '566px',
      autoFocus: false,
      data: {
        title: translate('VERSIONS.REDEPLOY_TITLE'),
        message: translate('VERSIONS.REDEPLOY_SUBTITLE'),
        confirmButtonText: translate('DIALOG.SUBMIT')
      }
    })
      .afterClosed()
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(confirm => {
        if (confirm) {
          this.instanceService.redeployInstance(instance.id)
            .pipe(takeUntilDestroyed(this.destroyRef))
            .subscribe(() => {this.loadBlueprint()},
            (error)=>{
              const errorMessage = typeof error === 'string' ? error: typeof error?.error === 'string' ? error.error : error;
              this.dialog.open(ErrorDialogComponent, {
                    minHeight: '342px',
                    width: '630px',
                    panelClass: 'flex-dialog',
                    data: {
                      title: translate('ERROR_DIALOG.REDEPLOY_FAILED'),
                      description: errorMessage
                    }
              });
            }
          );
        }
      });
  }

  openDeployPTLInstanceDialog(instance: any): void {
    this.loadBlueprint();
    const data = this.buildDeployDialogData(instance, `${translate('INSTANCE_SUMMARY.DEPLOY')}`);
    let serviceDefinitionData = [];

    if (this.devInstance && instance.previousInstance?.status === DeployStatus.DEPLOYED) {
      serviceDefinitionData = this.serviceDefinitionsForInstance(instance);
    } else {
      serviceDefinitionData = this.blueprintsVersionList;
      if (instance.previousInstance?.status === DeployStatus.DEPLOYED && instance.previousInstance?.blueprintVersionId) {
        serviceDefinitionData = serviceDefinitionData.filter(
          item => item.id === instance.previousInstance?.blueprintVersionId);
      }
    }

    data.blueprintsVersionList = serviceDefinitionData;
    data.checkInstanceClass = instance.deploymentClass;
    data.bluerprintById = this.bluerprintById.pathToLiveConfiguration;

    this.openDeployInstance(data)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(deployment => {
        if (deployment) {
          this.loadBlueprint();
        }
      });
  }

  openDeployInstance(data: any): Observable<any> {
    let currentBuildNumber;
    if(this.isSandbox) {
      currentBuildNumber= this.serviceVersionsInfo?.devVersion?.version;
    } else {
      currentBuildNumber = this.serviceVersionsInfo?.currentVersion?.version;
    }
    data.currentBuildNumber = currentBuildNumber;
    data.buildNumber = this.publishedServiceVersions;
    data.blueprint = this.blueprint;
    data.buildNumber = data.buildNumber.filter(item => item.releaseVersion);
    /**
     * This code should not be removed. we are commenting now which we need later.
     */
    // if (data.checkInstanceClass === DeploymentClass.A) {
    //   const getSolutionVersionId = data.instanceBlueprint.find(item=> item.environment === PathToLiveEnvironment.PREPROD).solutionVersionId;
    //   data.buildNumber = data.buildNumber.filter(item => item.releaseVersion && item.id === getSolutionVersionId);
    // } else {
      data.buildNumber = data.buildNumber.filter(item => item.releaseVersion);
    // }
    data.allInstances = this.allInstances;
    return this.sidenavService.openInRightSidenav(DeployInstanceComponent, data)
      .pipe(
        mergeMap((deploymentData) => {
          if (deploymentData) {
            if (data.nonPtlFlow === true) {
              deploymentData.nonPtlFlow = true;
            }
            deploymentData.tenantId = this.tenantId;
            return this.deployInstance(deploymentData);
          }
          return of(null);
        })
      );
  }

  getSolVersion(solutionVersionId: any): string {
    return this.serviceVersions?.find(test => test.id === solutionVersionId)?.version;
  }

  resourceConfigure(instance: Instance): void {

    this.solutionsService
    .getSolutionVersion(instance.solutionId, instance.solutionVersionId)
    .pipe(takeUntilDestroyed(this.destroyRef))
    .subscribe(solution => {

      const isNewRelease = isReleaseVersion(solution?.version);
      const targetRoute = isNewRelease && !this.isAWS ? RouterSegments.DEPLOY_SIZING : RouterSegments.RESOURCE_CONFIG;

    if(!this.hasSecondaryRegion && instance.deploymentClass === DeploymentClass.A) {
        this.dialog.open(ConfirmationDialogComponent, {
      panelClass: 'default-dialog-wrapper',
      width: '566px',
      autoFocus: false,
      data: {
        confirmButtonText: translate('TENANT_FORM.CONFIRM_BUTTON_REGION'),
        secondaryRegionWarn: true,
        secondaryMsg: true
      }
    })
    .afterClosed()
    .pipe(takeUntilDestroyed(this.destroyRef))
    .subscribe(confirm => {
      if (confirm) {
            this.router.navigate(['/', this.authService.principal.provider, RouterSegments.TENANT , this.tenantId, RouterSegments.BLUEPRINTS, this.blueprintId, RouterSegments.ENVIRONMENT, instance.id, targetRoute]);
          }
        })
    } else {
    this.router.navigate(['/', this.authService.principal.provider, RouterSegments.TENANT , this.tenantId, RouterSegments.BLUEPRINTS, this.blueprintId, RouterSegments.ENVIRONMENT, instance.id, targetRoute]);
    }
  });
  }

  updateResourceConfigure(instance: Instance): void {
    this.router.navigate(['/', this.authService.principal.provider, RouterSegments.TENANT , this.tenantId, RouterSegments.BLUEPRINTS, this.blueprintId, instance.id, RouterSegments.UPDATE_RESOURCE_CONFIG]);
  }

  getBuildVersion(solutionVersionId: any): string {
    const solnVersion = this.serviceVersions.find(v => v.id === solutionVersionId);
    return solnVersion?.releaseVersion;
  }

  activeInstance(): void {
    if(this.activeInstanceValue) {
    this.activeInstanceValue = false;
    } else {
      this.activeInstanceValue = true;
    }
  }

  canAccessFeature(flagId: string): boolean {
    const isEnabled = this.featureFlagsManagerService.isFeatureEnabled(flagId);
    return isEnabled;
  }

  isTerminateAllowed(): boolean {
    return !this.isAWS || this.canAccessFeature(FeatureFlags.AZURE_TERMINATE);
  }

  /**
   * Terminates an instance
   *
   * @param instance - the instance to be terminated
   */
  terminate(instance: Instance): void {
    if (!this.INSTANCE_TERMINATE_AVAILABLE_STATES.includes(instance.status) ||
      (instance?.status === DeployStatus.STARTING || instance?.status === DeployStatus.STOPPED || instance?.status === DeployStatus.STOPPING || instance?.status === DeployStatus.START_FAILED)) {
        this.matDialog.open(GenericErrorComponent, {
          minHeight: '342px',
          width: '566px',
          panelClass: 'flex-dialog'
        });
    } else {
      this.dialog.open(ConfirmationDialogComponent, {
        panelClass: 'default-dialog-wrapper',
        width: '566px',
        autoFocus: false,
        data: {
          title: translate('INSTANCE_SUMMARY.TITLE'),
          message: translate('INSTANCE_SUMMARY.CONFIRM_TERMINATION'),
          confirmButtonText: translate('BUTTONS.CONFIRM')
        }
      })
        .afterClosed()
        .pipe(takeUntilDestroyed(this.destroyRef))
        .subscribe(confirm => {
          if (confirm) {
            this.instanceService.deleteInstance(instance.id)
              .pipe(takeUntilDestroyed(this.destroyRef))
              .subscribe(() => {this.loadBlueprint()},
              (error) => {
                const errorMessage = typeof error === 'string' ? error: typeof error?.error === 'string' ? error.error : error;
                this.dialog.open(ErrorDialogComponent, {
                  minHeight: '342px',width: '630px',panelClass: 'flex-dialog',
                  data: {
                    title:  translate('ERROR_DIALOG.TERMINATE_FAILED'),
                    description: errorMessage
                  }
                });
              });
          }
        });
    }
  }

  serviceDefinitionsForInstance(instance): any {
    let serviceDefinitionData = this.blueprintsVersionList;
    const requiredEnvironment = this.blueprint.pathToLiveConfiguration.find(
      ptl => ptl.environment === instance.environment && ptl.instanceId === instance.id)?.requires;
      /**
     * This code should not be removed. we are commenting now which we need later.
     */
    // if(requiredEnvironment === PathToLiveEnvironment.PREPROD) {
    //   const filterData = serviceDefinitionData.filter(item => item.id === instance.previousInstance?.blueprintVersionId);
    //   const deployedVersion = this.blueprintsVersionList.find(item => item.id === instance.blueprintVersionId);
    //   const previousVersions = this.blueprintsVersionList.filter(version => version?.version <= deployedVersion?.version);
    //   const appendData = [...filterData, ...previousVersions];
    //   const removeDuplicates = this.removeDuplicateVersions(appendData);
    //   serviceDefinitionData = removeDuplicates.sort((a,b) => a.version - b.version);
    // } else {
      let devServiceDefinitions = [];
      let previousVersions= [];
      if (!this.serviceVersionsInfo?.currentVersion?.applyConfigurationInstructionId) {
        devServiceDefinitions = this.blueprintsVersionList;
      } else {
        this.allInstances.forEach(devInstance => {
          if(devInstance.status === DeployStatus.DEPLOYED) {
          const getVersion = serviceDefinitionData.find(version => version.id === devInstance.blueprintVersionId);
          if(getVersion) {
            devServiceDefinitions.push(getVersion);
           }
         }
       });
       const deployedVersion = this.blueprintsVersionList.find(item => item.id === instance.blueprintVersionId);
       previousVersions = this.blueprintsVersionList.filter(version => version?.version <= deployedVersion?.version);
      }
      const appendData = [...devServiceDefinitions, ...previousVersions];
      const removeDuplicateVersions = this.removeDuplicateVersions(appendData);
      serviceDefinitionData = removeDuplicateVersions.sort((a,b) => a.version - b.version);
    // }
    return serviceDefinitionData;
  }

  removeDuplicateVersions(devServiceDefinitions): any {
    const unique = devServiceDefinitions.reduce((acc, version) => {
      if(!acc.includes(version)){
        acc.push(version);
      }
      return acc;
    }, []);
    return unique;
  }

  showViewDetails(version?): void {
    let selectedVersion: any;
    if(this.isSandbox) {
      this.blueprintsService.getBlueprintVersionById(this.blueprintId, this.blueprintLatestVersion.id)
      .pipe(takeUntilDestroyed(this.destroyRef)).subscribe(
        blueprintVersion => {
          selectedVersion = blueprintVersion;
          this.showViewDetailsInDetail(selectedVersion);
        }
      );
    } else {
      selectedVersion = version;
      this.showViewDetailsInDetail(selectedVersion);
    }
  }

  showViewDetailsInDetail(selectedVersion): any {
    let installationSpecificationForms = [];
    const selectedISBType = this.blueprint?.selectedISBType === 'system' ? true : false;
    if (this.serviceVersionsInfo?.currentVersion?.installationSpecification &&
       this.serviceVersionsInfo.currentVersion.installationSpecification !== '' && selectedVersion?.installDocRaw && selectedVersion) {
      try
      {
        JSON.parse( this.serviceVersionsInfo.currentVersion.installationSpecification );
        installationSpecificationForms = this.installationSpecificationService
        .buildDynamicForms(this.serviceVersionsInfo.currentVersion.installationSpecification), selectedISBType;
      }
      catch (error)
      {
        installationSpecificationForms = this.installationSpecificationService
        .buildDynamicForms(atob(this.serviceVersionsInfo.currentVersion.installationSpecification), selectedISBType);
      }
      installationSpecificationForms.forEach(installationSpecificationForm => {
        this.mapProperties(installationSpecificationForm, selectedVersion?.installDocRaw);
      });

      const installDocRaw = Object.keys(selectedVersion?.installDocRaw);
      const existingForms = new Map(installationSpecificationForms.map(f => [f.property.name, f]));
      installationSpecificationForms = installDocRaw.map(key => {
          const existing = existingForms.get(key);
         const formatTitle = (text: string) => text.replace(/([A-Z])/g, ' $1').replace(/^./, str => str.toUpperCase()).trim();
        return {
          property: {
            name: key,
            title: existing?.property?.title || formatTitle(key),
            type: 'object',
            properties: Array.isArray(existing?.property?.properties)
              ? existing.property.properties
              : Object.entries(existing?.property?.properties || selectedVersion.installDocRaw[key] || {})
                  .map(([key, value]) => ({
                    title: key.replace(/_/g, ' '),
                    value: value === null || value === undefined || value === '' ? '-' : value
                  }))
          },
          formGroup: existing?.formGroup || new FormGroup({})
        };
      });

      this.dialog.open(ViewServiceDefinitionVersionDetailsComponent, {
        panelClass: 'default-dialog-wrapper',
        autoFocus: false,
        data: {
          dynamicForm: installationSpecificationForms,
          serviceName: this.service.name,
          blueprintName: this.blueprint.name,
          region: this.tenantDetails.region || this.tenantDetails.regionPair,
          capabilities: selectedVersion?.capabilities,
          ISBMode: this.blueprint?.selectedISBType
        }
      });
    } else {
    this.matDialog.open(ErrorDialogComponent, {
      minHeight: '342px',
      width: '566px',
      panelClass: 'flex-dialog',
      data: {
        title: translate('NOTIFICATIONS.NOT_AVAILABLE'),
        description: translate('NOTIFICATIONS.INSTALLATION_SPECIFICATION_NOT_AVAILABLE'),
            }
        });
      }
  }

  mapProperties(installationSpecificationForm, selectedVersion): void {
    const keys = Object.keys(selectedVersion);
    keys.forEach(key => {
      if (key === installationSpecificationForm?.property?.name) {
        const properties = installationSpecificationForm.property?.properties;
        if (installationSpecificationForm.property?.type === InstallationSchemaPropertyType.ARRAY) {
          installationSpecificationForm.property.items.enum = selectedVersion[key];
        }
        if(properties) {
          properties.forEach(property =>{
            const selectedItem = Object.keys(selectedVersion[key]);
            selectedItem.forEach(item => {
              if (property?.name === item) {
                property.value = selectedVersion[key][item];
              }
            });
          });
        }
      }
    });
  }

  /**
   * Reports an issue related with the instance
   *
   * @param instance - the instance for which we are going to report the issue
   */
  reportIssue(instance: Instance): void {
    const deployedVersion = this.blueprintsVersionList.filter(item => item.id === instance.blueprintVersionId);
    const releaseVersionText = this.getBuildVersion(instance.solutionVersionId);
    const isAMR = releaseVersionText && this.solutionVersionsService.releaseVersion(releaseVersionText) ? true : false;
    const data = {
      title: translate('INSTANCE_SUMMARY.REPORT_ISSUE.TITLE'),
      subtitle: '',
      report: {
        service: this.service,
        blueprint: this.blueprint,
        instance
      },
      configurations: this.configurations,
      buildNumber: this.buildNumber,
      version: deployedVersion[0]?.version,
      releaseVersion: releaseVersionText,
      isAMR
    };

    this.sidenavService.openInRightSidenav(ReportIssueComponent, data)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe();
  }

  openViewEndpointsComponent(instance: Instance, event): void {
    event.stopPropagation();
    const data = {
      instanceName: instance.name,
      endpoints: instance.endpoints,
      title: translate('VIEW_ENDPOINTS.TITLE')
    };

    this.sidenavService.openInRightSidenav(ViewEndpointsComponent, data);
  }

  stopPropagation(event): void {
    event.stopPropagation();
  }

  openServiceDefinition(instance: Instance): void {
  this.solutionsService
    .getSolutionVersion(instance.solutionId, instance.solutionVersionId)
    .pipe(takeUntilDestroyed(this.destroyRef))
    .subscribe(solution => {
      const isNewRelease = isReleaseVersion(solution?.version);
      this.openServiceDefinitionComponent(instance, isNewRelease);
      // Temporarily restricted: extend flow does not involve sizing
      // if(isNewRelease && !this.isAWS) {
      //   this.openServiceDefinitionComponentforR26(instance);
      // } else {
      //   this.openServiceDefinitionComponent(instance);
      // }
    })
  }

  openServiceDefinitionComponent(instance: Instance, isNewRelease): void {
    if (this.INSTANCE_AVAILABLE_STATES.includes(instance?.status)) {
      const findDeployedVersion = this.blueprintsVersionList.filter(item => item.id === instance.blueprintVersionId);
      this.deployedVersion = findDeployedVersion[0]?.version;
      const serviceDefinitionData =
      instance.deploymentClass === DeploymentClass.D ? this.blueprintsVersionList : this.serviceDefinitionsForInstance(instance);

      const data = {
        instance,
        title: translate('INSTANCE_SUMMARY.SERVICE_DEFINITION.TITLE'),
        subtitle: instance.name,
        serviceName: this.blueprint.name,
        blueprintsVersionList: serviceDefinitionData,
        deployedVersion: this.deployedVersion
      };
      this.sidenavService.openInRightSidenav(UpdateDefinitionComponent, data)

        .pipe(takeUntilDestroyed(this.destroyRef))
        .subscribe(newDefinition => {
          this.updateServiceId =  instance.id ;
          localStorage.setItem("updatedServiceInstance",this.updateServiceId);
          this.instances = this.instances.map(obj => ({ ...obj, serviceDefinitionUpdate: obj.id === this.updateServiceId }));
          if (newDefinition) {
            this.instanceService.applyDefinition(newDefinition.id, instance.id, (isNewRelease && !this.isAWS) ? instance?.sizingDocumentId : undefined)
              .pipe(takeUntilDestroyed(this.destroyRef))
              .subscribe((data)=>{
                this.loadBlueprint();
              },(error)=>{
                const errorMessage = typeof error === 'string' ? error: typeof error?.error === 'string' ? error.error : error;
                this.dialog.open(ErrorDialogComponent, {
                  minHeight: '342px',
                  width: '566px',
                  panelClass: 'flex-dialog',
                  data: {
                    title: translate('NOTIFICATIONS.UPDATE_SERVICE_DEFINITION_FAILED'),
                    description: errorMessage,
                  }
               });
              })
            }
        });
    }
  }

  openServiceDefinitionComponentforR26(instance: Instance): void {
    if (this.INSTANCE_AVAILABLE_STATES.includes(instance?.status)) {
      const findDeployedVersion = this.blueprintsVersionList.filter(item => item.id === instance.blueprintVersionId);
      this.deployedVersion = findDeployedVersion[0]?.version;
      const serviceDefinitionData =
      instance.deploymentClass === DeploymentClass.D ? this.blueprintsVersionList : this.serviceDefinitionsForInstance(instance);

      const data = {
        instance,
        title: translate('INSTANCE_SUMMARY.SERVICE_DEFINITION.TITLE'),
        subtitle: instance.name,
        serviceName: this.blueprint.name,
        blueprintsVersionList: serviceDefinitionData,
        deployedVersion: this.deployedVersion
      };

      // Store instance id for tracking
      this.updateServiceId = instance.id;
      localStorage.setItem("updatedServiceInstance", this.updateServiceId);
      this.instances = this.instances.map(obj => ({ ...obj, serviceDefinitionUpdate: obj.id === this.updateServiceId }));

      // Navigate to the update definition screen
      this.router.navigate([
        '/',
        this.authService.principal.provider,
        RouterSegments.TENANT,
        this.tenantId,
        RouterSegments.BLUEPRINTS,
        this.blueprintId,
        instance.id,
        'update-definition'
      ], {
        state: data
      });
    }
  }

  /**
   * Opens the appropriate form to define a workflow
   */
  defineWorkflow(): void {
    this.sidenavService.openInRightSidenav(PathToLiveWorkflowComponent, {
      service: this.service,
      pathToLiveConfiguration: this.blueprint.pathToLiveConfiguration,
      devInstance: this.devInstance,
      tenant: this.tenantDetails
    })
      .pipe(
        mergeMap(pathToLiveConfiguration => {
          if (pathToLiveConfiguration) {
             // Clone selected blueprint in case that update is not successfully
            return this.blueprintsService.updateBlueprint({ ...this.blueprint, pathToLiveConfiguration });
          } else {
            return of(null);
          }
        }),
        takeUntilDestroyed(this.destroyRef)
      )
      .subscribe((result: Blueprint) => {
        if (result) {
          this.blueprint.pathToLiveConfiguration = result.pathToLiveConfiguration;
          this.loadData();
        }
      },
      (error) => {
        const errorMessage = typeof error === 'string' ? error: typeof error?.error === 'string' ? error.error : error;
        this.matDialog.open(ErrorDialogComponent, {
          minHeight: '342px',
          width: '566px',
          panelClass: 'flex-dialog',
          data: {
            title:  translate('NOTIFICATIONS.UPDATE_SERVICE_DEFINITION_FAILED'),
            description: errorMessage,
          }
        });
      });
  }

  /**
   * Contains the logic to be executed when Update button is pressed
   * in order to update the applied configuration
   *
   * First case - If requires is null/undefined
   * If we don't have any current configuration - we use all the configurations from dev
   * If we have a current configuration - we filter all the configurations from dev to have
   * a newer date generated than the one applied currently
   *
   * Second case - If requires has value
   * If we don't have any current configuration - we use all the applied configurations from the previous/required env
   * If we have a current configuration - we filter all the applied configurations from the previous env to have
   * a newer date generated than the one applied currently
   *
   * @param instance - the row data as instance object
   */
  // updateInstance(instance: Instance, workflowApproval: WorkflowApproval, configStatus): void {
  //   if(instance.dataZone === DataZone.LIVE && !this.configStateVerify && configStatus !== ConfigurationApplicationStatus.VERIFIED) {
  //   this.matDialog.open(VerifypopupComponent, {
  //     minHeight: '342px',
  //     width: '566px',
  //     panelClass: 'flex-dialog',
  //   })
  //   .afterClosed()
  //   .pipe(takeUntilDestroyed(this.destroyRef))
  //   .subscribe(data => {
  //     if (data) {
  //       const dataVerify = localStorage.getItem('verifyUpdate');
  //       if(configStatus === ConfigurationApplicationStatus.VERIFIED) {
  //         this.configStateVerify = true;
  //       }
  //       if (dataVerify === 'true') {
  //         this.openRequestUpdateConfiguration(instance, this.getAvailableConfigurations(instance));
  //         //TODO: Commenting the below code as approval is not needed for now
  //         /*const requestBody = workflowApproval.data.requestBody;
  //         this.applyConfiguration(requestBody.id, requestBody.instanceId);*/
  //       }
  //       else if(dataVerify === 'false') {
  //         this.openUpdateConfiguration(instance, this.getAvailableConfigurations(instance));
  //       }
  //     }
  //   });
  // } else {
  //     this.openUpdateConfiguration(instance, this.getAvailableConfigurations(instance));
  //  }
  // }

  // requestDeployApproval(instance: Instance): void {
  //   const data = this.buildDeployDialogData(instance, `${translate('INSTANCE_SUMMARY.REQUEST_DEPLOY')}`);
  //   this.sidenavService.openInRightSidenav(RequestDeployInstanceDialogComponent, data)
  //     .pipe(
  //       mergeMap((requestDeployment) => {
  //         if (requestDeployment) {
  //           const deploymentData = requestDeployment.deployment;
  //           const maintenanceWindow = {
  //             dayOfTheWeek: deploymentData.dayOfTheWeek,
  //             startingHour: deploymentData.startingHour,
  //             endingHour: deploymentData.endingHour
  //           };

  //           delete deploymentData.dayOfTheWeek;
  //           delete deploymentData.startingHour;
  //           delete deploymentData.endingHour;

  //           const workflowApprovalEntry = {
  //             operationType: OperationType.CREATE_INSTANCE,
  //             entity: {
  //               entityId: this.blueprint.id,
  //               entityType: EntityType.BLUEPRINT
  //             },
  //             data: {
  //               targetEnvironment: instance.environment,
  //               requestBody: deploymentData,
  //               maintenanceWindow,
  //               requestDescription: requestDeployment.requestDescription
  //             },
  //           } as WorkflowApproval;
  //           // return this.workflowService.postWorkflowApproval(workflowApprovalEntry);
  //         }

  //         return of(null);
  //       }),
  //       takeUntilDestroyed(this.destroyRef)
  //     ).subscribe((workflowEntry) => {
  //     if (workflowEntry) {
  //       this.updateWorkflowEntry(workflowEntry);
  //     }
  //   });
  // }

  // requestUpdateApproval(instance: Instance): void {
  //   const data = {
  //     title: translate('INSTANCE_SUMMARY.UPDATE_CONFIGURATION.TITLE'),
  //     subtitle: instance.name,
  //     availableConfigurations: this.getAvailableConfigurations(instance)
  //   };
  //   this.sidenavService.openInRightSidenav(UpdateConfigurationComponent, data)
  //     .pipe(takeUntilDestroyed(this.destroyRef))
  //     .subscribe(newConfiguration => {
  //       if (newConfiguration) {
  //         const workflowApprovalEntry = {
  //           operationType: OperationType.UPDATE_INSTANCE,
  //           entity: {
  //             entityId: instance.id,
  //             entityType: EntityType.INSTANCE
  //           },
  //           data: {
  //             requestBody: {
  //               id: newConfiguration.id,
  //               instanceId: instance.id,
  //             }
  //           }
  //         } as WorkflowApproval;
  //       }
  //     });
  // }

  // abortWorkflowAproval(workflowApproval: WorkflowApproval): void {
  //   this.dialog.open(ConfirmationDialogComponent, {
  //     panelClass: 'default-dialog-wrapper',
  //     autoFocus: false,
  //     width: '566px',
  //     data: {
  //       title: translate(`BLUEPRINT_SUMMARY.WORKFLOW_APPROVAL.${workflowApproval.operationType}.TITLE`),
  //       message: translate(`BLUEPRINT_SUMMARY.WORKFLOW_APPROVAL.${workflowApproval.operationType}.CONFIRM_ABORT`),
  //       confirmButtonText: translate('BUTTONS.ABORT')
  //     }
  //   })
  //     .afterClosed()
  //     .pipe(takeUntilDestroyed(this.destroyRef))
  //     .subscribe(confirm => {
  //       if (confirm) {
  //         workflowApproval.aborting = true;
  //         // this.workflowService.deleteWorkflowApproval(workflowApproval.id)
  //         //   .pipe(takeUntilDestroyed(this.destroyRef))
  //         //   .subscribe(() => {
  //         //     this.loadWorkflowApprovals();
  //         //   });
  //       }
  //     });
  // }

  filterInstanceByDataZone(dataZones: DataZone[]): (instance: any) => boolean {
    return (instance): boolean => dataZones.includes(instance.dataZone);
  }

  onChangeTaskChange(changeTask: ChangeTask): void {
    if (changeTask) {
      this.changeTaskApplying = ChangeState.APPLYING === changeTask.changeState;
    }
  }

  deleteServiceDefinition(selectedBlueprintVersion): void {
    localStorage.removeItem('selectedCapabilitiesExtend');
    localStorage.removeItem('blueprintExtend');
    this.dialog.open(ConfirmationDialogComponent, {
      panelClass: 'default-dialog-wrapper',
      width: '566px',
      autoFocus: false,
      data: {
        title: translate('BLUEPRINT_SUMMARY.CONFIRM_DELETE_BLUEPRINT'),
        message: translate('BLUEPRINT_SUMMARY.DELETE_SERVICE_DEFINITION'),
        confirmButtonText: translate('BLUEPRINT_SUMMARY.DELETE')
      }
    })
      .afterClosed()
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(confirm => {
        if (confirm) {
          this.showLoader = true;
          this.blueprintsService.deleteBlueprintVersionById(this.blueprint.id, selectedBlueprintVersion)
            .pipe(
              takeUntilDestroyed(this.destroyRef))
            .subscribe(() => {
              this.loadBlueprint();
              this.showLoader = false;
              this.loadBlueprintVersion(this.blueprint.id);
            setTimeout(() => {
              const title = translate('INSTANCE_DETAILS.UPDATE_BUILD.SERVICE_DEFINITION');
              const message = translate('NOTIFICATIONS.DELETE_SERVICE_DEFINITION_SUCCESS');
              this.toastrService.successMessage(message, title);
            }, 500);
            },
            (error) => {
              this.showLoader = false;
              const errorMessage = typeof error === 'string' ? error : typeof error?.error === 'string' ? error.error : error;
              this.dialog.open(ErrorDialogComponent, {
              minHeight: '280px',
              width: '630px',
              panelClass: 'flex-dialog',
              data: {
                title: translate('NOTIFICATIONS.DELETE_SERVICE_DEFINITION_FAILED'),
                description: errorMessage
              }
              });
            });
        }
      });
  }

  removeActiveInstance(instance): any {
    return instance?.every(item => item.status === DeployStatus.TERMINATED) ? true : false;
  }

  deleteBlueprint(): void {
    if (this.allInstances?.length > 0 || !this.permissionsMap[PermissionKeys.BLUEPRINT_DELETE]) {
      this.matDialog.open(GenericErrorComponent, {
        minHeight: '342px',
        width: '566px',
        panelClass: 'flex-dialog'
      });
    } else {
      this.dialog.open(ConfirmationDialogComponent, {
        panelClass: 'default-dialog-wrapper',
        width: '566px',
        autoFocus: false,
        data: {
          message: translate('BLUEPRINT_SUMMARY.CONFIRM_DELETE_BLUEPRINT')
        }
      })
      .afterClosed()
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(confirm => {
        if (confirm && this.allInstances?.length === 0) {
          this.isLoading = true;
          this.blueprintsService.deleteBlueprint(this.blueprint.id)
          .pipe(
            finalize(() => this.isLoading = false),
            takeUntilDestroyed(this.destroyRef))
          .subscribe(() => {
            this.router.navigate(['/', this.tenant, RouterSegments.SERVICES, this.service.id]);
          },
          (error) => {
            const errorMessage = typeof error === 'string' ? error: typeof error?.error === 'string' ? error.error : error;
            this.matDialog.open(ErrorDialogComponent, {
              minHeight: '342px',
              width: '566px',
              panelClass: 'flex-dialog',
              data: {
                title:  translate('NOTIFICATIONS.DELETE_SERVICE_DEFINITION_FAILED'),
                description: errorMessage,
              }
            });
          });
        }
      });
    }
  }

  goToExtendSandbox(): void {
    this.router.navigate([this.tenant, RouterSegments.SERVICES, this.service.id, translate('BLUEPRINT_SUMMARY.EXTEND.EXTEND'),
        this.blueprint.id],
      { state: { installDoc: this.blueprint.installationDocument } });
  }

  /**
   * Add / remove bookmark for the selected instance
   * @param data - the selected instance
   */
  addRemoveBookmark(data): void {
    if (this.bookmarkInProgress.has(data.id)) {
      return;
    }
    this.bookmarkInProgress.add(data.id);
    const userId = this.authService?.principal?.attributes?.email;
    const existing = this.bookmark?.find(b => b.instanceId === data.id);
    this.bookmark = this.bookmark ?? [];
    this.bookmark = existing ? this.bookmark.filter(b => b.instanceId !== data.id) : [...this.bookmark, { instanceId: data.id }];
    setTimeout(() => {
      if (!existing) {
        const bookmarkObj: any = {
          instanceId: data.id,
          instanceName: data.name,
          blueprintId: data.blueprintId,
          tenantId: data.tenantId,
          userId: userId
        };
        this.userService.addBookmark(bookmarkObj).pipe(finalize(() => this.bookmarkInProgress.delete(data.id))).subscribe({
          next: () => this.getBookmarks(),
          error: () => this.bookmark = this.bookmark.filter(b => b.instanceId !== data.id)
        });
      } else {
        this.userService.deleteBookmark(existing.id).pipe(finalize(() => this.bookmarkInProgress.delete(data.id))).subscribe({
          next: () => this.getBookmarks(),
          error: () => this.bookmark = [...this.bookmark, existing]
        });
      }
     }, 50);
  }

  viewUpdateResults(instance: Instance): void {
    const data = {
      title: translate('CONFIGURATIONS.STATE.VIEW_RESULTS'),
      subtitle: instance.environment,
      configurationStates: instance.configurationStates,
      configurations: this.configurations,
      viewAllResults: true,
    };

    this.sidenavService.openInRightSidenav(ViewUpdateResultsComponent, data)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe();
  }

  retryUpdate(event: any): void {
    this.dialog.open(ConfirmationDialogComponent, {
      panelClass: 'default-dialog-wrapper',
      autoFocus: false,
      width: '566px',
      data: {
        title: translate(`BLUEPRINT_SUMMARY.CONFIRM_RETRY.TITLE`),
        message: translate(`BLUEPRINT_SUMMARY.CONFIRM_RETRY.MESSAGE`),
        confirmButtonText: translate('BUTTONS.RETRY')
      }
    })
      .afterClosed()
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(confirm => {
        if (confirm) {
          // this.applyConfiguration(event.configurationId, event.instanceId, event.configurations);
        }
      });
  }

  goBack(): void {
    if (window.history.length > 4) {
      window.history.go(-2);
    }
    else {
      this.router.navigate(['/' + this.tenant]);
    }
  }
  openContactForm(): void {
    this.sidenavService.openInRightSidenav(ContactUsDialogComponent);
  }

  isBlueprintsVersionlAvaliable(blueprintVersionList, versionId): any {
    let filterData = [];
    if (!Array.isArray(blueprintVersionList)) {
      return filterData;
    }
    if (versionId && !this.blueprintsVersionList?.error && !this.blueprintsVersionList?.errmsg) {
      filterData = blueprintVersionList?.filter(item => item.id === versionId);
      this.getVersion = filterData;
    }
    return filterData;
  }

  serviceVersionStatus(versionId): any {
    if (this.allInstances) {
      for (const data of this.allInstances) {
        if(versionId === data.blueprintVersionId) {
          return true;
        }
      }
    }
  }

  getCapabilitiesGroup(blueprintsVersionList: any): any {
    for (const version of blueprintsVersionList) {
      version.capabilitiesGroups = this.frameCapabilities(version.capabilities);
    }
  }

  frameCapabilities(selectedCapabilities: Capability[]): any {
    if (selectedCapabilities?.length > 0) {
      const capabilitiesByType = selectedCapabilities
        .reduce((acc, capability) => {
          if (capability.required !== CapabilityType.OPTIONAL) {
            capability.selected = true;
          }

          let capabilitiesArr = acc[capability.required];
          if (capabilitiesArr == null) {
            capabilitiesArr = [];
            acc[capability.required] = capabilitiesArr;
          }
          capabilitiesArr.push(capability);
          return acc;
        }, {});
      return this.capabilitiesMapping(capabilitiesByType);
    }
  }

  extendedService(capabilities?: Capability, blueprintVersion?: any): void {
    if (!capabilities) {
      return;
    } else {
      const filteredInstances = this.allInstances.filter(item => this.INSTANCE_FILTERED_STATES.includes(item.status));
      // let instanceSolutionVersion;
      // instanceSolutionVersion = (filteredInstances?.find(instances => instances.deploymentClass === DeploymentClass.A)) ? (filteredInstances?.find(instances => instances.deploymentClass === DeploymentClass.A).solutionVersionId)
      // : (filteredInstances?.find(instances => instances.deploymentClass === DeploymentClass.B)) ? (filteredInstances.filter(i => i.deploymentClass === DeploymentClass.B)[filteredInstances.filter(i => i.deploymentClass === DeploymentClass.B).length -1].solutionVersionId)
      // : (filteredInstances?.find(instances => instances.deploymentClass === DeploymentClass.C)) ? (filteredInstances.filter(i => i.deploymentClass === DeploymentClass.C)[filteredInstances.filter(i => i.deploymentClass === DeploymentClass.C).length -1].solutionVersionId)
      // : (filteredInstances?.find(instances => instances.deploymentClass === DeploymentClass.D)) ? (filteredInstances.filter(i => i.deploymentClass === DeploymentClass.D)[filteredInstances.filter(i => i.deploymentClass === DeploymentClass.D).length -1].solutionVersionId)  : this.sortedSolutionVersionId[0].id;
      // localStorage.setItem('instanceSolutionVersion', instanceSolutionVersion);
      this.router.navigate(['/', this.authService.principal.provider, RouterSegments.TENANT , this.tenantId, RouterSegments.BLUEPRINTS, this.blueprintId, blueprintVersion.solutionId, RouterSegments.EXTEND]);
    }
  }

  gotoWorkBenchURL(instance): void {
    if (this.allInstances?.find(instances => instances.id === instance.id)) {
      return instance?.endpoints?.find(endpoint => endpoint.useType === EndpointType.CONFIGURATION);
    }
  }

  onCopyId(data): void {
    this.copy = true;
    this.clipboardApi.copyFromContent(data);
    setTimeout(() => {
      this.copy = false;
    }, 500);
  }

  openUrl(data): void {
    const url = data;
    window.open(url, '_blank');
  }

  versionPopup(instance): void {
    this.blueprintsService.getBlueprintVersionById(this.blueprintId, instance.blueprintVersionId)
      .pipe(takeUntilDestroyed(this.destroyRef)).subscribe(
        blueprintVersion => {
          this.matDialog.open(VersionDetailsPopupComponent, {
            height: '50vh',
            width: '40vw',
            data: {
              blueprintVersion, instance
            }
          });
        });

  }

  releasePopup(configuration: any, instance): void {
    if(configuration){
    configuration.instanceName = instance.name;
    this.matDialog.open(ConfigurationDetailsComponent, {
      height: '50vh',
      width: '40vw',
      data: {
        configuration
      }
    });
  }
  }

  public instanceClick(instance): void {
    this.router.navigate(['/', this.authService.principal.provider, RouterSegments.TENANT, this.tenantId,
      RouterSegments.BLUEPRINTS, this.blueprint.id,  RouterSegments.ENVIRONMENT, instance.id]);
  }

  private convertDayAndTimeToUTC(dayOfTheWeek, startingHour, endingHour): string {
    const weekdays = ['sun', 'mon', 'tue', 'wed', 'thu', 'fri', 'sat'];
    const start = moment(startingHour, 'hh:mm a').day(dayOfTheWeek);
    const end = moment(endingHour, 'hh:mm a').day(dayOfTheWeek);
    if (start.isAfter(end)) {
      end.add(1, 'days');
    }
    const startUTC = start.utc();
    const endUTC = end.utc();
    return weekdays[startUTC.day()] + ':' + startUTC.format('HH:mm') + '-' +
      weekdays[endUTC.day()] + ':' + endUTC.format('HH:mm');
  }

  /**
   * If the conditions are met, we open the table of applied configurations in the right sidenav and get
   * the configuration object ready to be posted
   *
   * @param instance - the row data as instance object
   * @param availableConfigurations - the configurations to be displayed
   */
  // private openUpdateConfiguration(instance, availableConfigurations: Configuration[]): void {
  //   const data = {
  //     title: translate('INSTANCE_SUMMARY.UPDATE_CONFIGURATION.TITLE'),
  //     subtitle: instance.name,
  //     availableConfigurations
  //   };
  //   this.sidenavService.openInRightSidenav(UpdateConfigurationComponent, data)
  //     .pipe(takeUntilDestroyed(this.destroyRef))
  //     .subscribe(newConfiguration => {
  //       if (newConfiguration) {
  //         this.configStateVerify = false;
  //         this.applyConfiguration(newConfiguration.id, instance.id, newConfiguration);
  //       }
  //     });
  // }

  // private openUpdateSuccessConfiguration(instance, availableConfigurations: Configuration[]): void {
  //   const data = {
  //     title: translate('INSTANCE_SUMMARY.TABLE.UPDATE'),
  //     subtitle: instance.name,
  //     instance,
  //     availableConfigurations
  //   };
  //   this.sidenavService.openInRightSidenav(RequestUpdateConfigurationComponent, data)
  //     .pipe(takeUntilDestroyed(this.destroyRef))
  //     .subscribe(newConfiguration => {
  //       if (newConfiguration) {
  //         this.configStateVerify = false;
  //         this.applyConfiguration(
  //           newConfiguration.configurationStates[0].configurationId, newConfiguration.configurationStates[0].instanceId);
  //       }
  //     });
  // }

  // private openRequestUpdateConfiguration(instance, availableConfigurations: Configuration[]): void {
  //   const data = {
  //     title: translate('INSTANCE_SUMMARY.REQUEST_UPDATE_CONFIGURATION.TITLE'),
  //     subtitle: instance.name,
  //     availableConfigurations
  //   };
  //   this.sidenavService.openInRightSidenav(RequestUpdateConfigurationComponent, data)
  //     .pipe(takeUntilDestroyed(this.destroyRef))
  //     .subscribe(newConfiguration => {
  //       if (newConfiguration) {
  //         this.configStateVerify = true;
  //         this.liveInstanceId = instance.id;
  //         this.verifyConfiguration(newConfiguration.id, instance.id);
  //       }
  //     });
  // }

  /**
   * Makes a call to post a new configuration. When we get a successful
   * response, we are directed then to the workbench
   *
   * @param configurationId the id of the configuration to be applied
   * @param instanceId - the id of the target instance
   */
  // private applyConfiguration(configurationId: string, instanceId: string, config?): void {
  //   if (this.allInstances.find(instance => instance.id === instanceId).deploymentClass === InstanceClass.D) {
  //     this.matDialog.open(SkiptestPopupComponent, {
  //       minHeight: '342px',
  //       width: '566px',
  //       panelClass: 'flex-dialog',
  //     })
  //     .afterClosed()
  //     .pipe(takeUntilDestroyed(this.destroyRef))
  //     .subscribe(data => {
  //       if (data) {
  //         data.skipTest = !data.skipTest;
  //         this.skipTest = data.skipTest;
  //         this.applyConfigurationBasedOnInstance(configurationId, instanceId, this.skipTest);
  //       }
  //     });
  //   } else {
  //     this.skipTest = this.allInstances.find(instance => instance.id === instanceId).deploymentClass === InstanceClass.A? true : false;
  //     this.applyConfigurationBasedOnInstance(configurationId, instanceId, this.skipTest);
  //   }
  // }

  // private applyConfigurationBasedOnInstance(configurationId, instanceId, skipTest): void {
  //   this.configurationsService.applyConfiguration(configurationId, instanceId, skipTest)
  //     .pipe(takeUntilDestroyed(this.destroyRef))
  //     .subscribe(() => {
  //       this.loadData();
  //     },
  //     (error) => {
  //       this.matDialog.open(ErrorDialogComponent, {
  //         minHeight: '342px',
  //         width: '566px',
  //         panelClass: 'flex-dialog',
  //         data: {
  //           title:  translate('NOTIFICATIONS.APPLY_CONFIGURATION_FAILED'),
  //           description: error,
  //         }
  //       });
  //     });
  // }

  // private verifyConfiguration(configurationId: string, instanceId: string): void {
  //   this.configurationsService.verifyConfiguration(configurationId, instanceId)
  //     .pipe(takeUntilDestroyed(this.destroyRef))
  //     .subscribe(() => {
  //       this.loadData();
  //     },
  //     (error) => {
  //       this.matDialog.open(ErrorDialogComponent, {
  //         minHeight: '342px',
  //         width: '566px',
  //         panelClass: 'flex-dialog',
  //         data: {
  //           title:  translate('NOTIFICATIONS.APPLY_CONFIGURATION_FAILED'),
  //           description: error,
  //         }
  //       });
  //     });
  // }
  /**
   * Prepares the guide for the users
   */


  private loadWorkflowApprovals(): void {
    this.groupedWorkflowApprovals.clear();
    const eligibleForWorkflowApproval = this.pathToLiveInstances.filter(
      instance => instance.environment === PathToLiveEnvironment.LIVE);
    const entityIds = [];

    if (!eligibleForWorkflowApproval[0]?.id) {
      entityIds.push(this.blueprint.id);
    } else {
      entityIds.push(eligibleForWorkflowApproval[0].id || this.blueprint.id);
    }

    // this.workflowService.search({ entityIds })
    //   .pipe(takeUntilDestroyed(this.destroyRef))
    //   .subscribe(result => {
    //     const workflowApprovals = result.workflowApprovals;
    //     Object.keys(result.workflowApprovals)
    //       .forEach(instanceId => {
    //         workflowApprovals[instanceId].forEach(workflowEntry => this.updateWorkflowEntry(workflowEntry));
    //       });
    //   });
  }

  private updateWorkflowEntry(workflowEntry): void {
    let key = workflowEntry.entity.entityId + workflowEntry.operationType;
    if (workflowEntry?.data.targetEnvironment) {
      key += workflowEntry.data.targetEnvironment;
    }
    this.groupedWorkflowApprovals.set(key, workflowEntry);
  }

  /**
   * Calls urlService method to open the workbench URL in a new tab
   */
  private navigateToWorkbench(event): void {
    event.stopPropagation();
    this.urlService.openUrlInNewTab(this.workbenchUrl);
  }

  /**
   * Returns the dev instance after finding it in the list of instances
   */
  private getDevInstance(allInstances: any): Instance {
    return allInstances.filter(i => i.type !== InstanceType.OTHER && i.type !== InstanceType.EAAS && i.deploymentClass === DeploymentClass.D);
  }

   /**
   * Returns the other instance after finding it in the list of instances
   */
  private getOtherInstance(allInstances: any): Instance {
    return allInstances.filter(i => i.type === InstanceType.OTHER || i.type === InstanceType.EAAS);
  }

  /**
   * Sets the dev instance
   */

  private getEndpointTypes(instance: Instance): void {
    const instanceEndpoints: any = instance;
    if(this.isSandbox && instanceEndpoints?.length) {
      instanceEndpoints?.forEach(data => {
        if (data?.endpoints) {
          this.configTypeEndpoints = data.endpoints.filter(endpoint => endpoint.useType === EndpointType.CONFIGURATION);
          this.accessTypeEndpoints = data.endpoints.filter(endpoint => endpoint.useType === EndpointType.UI);
          this.exploreTypeEndpoints = data.endpoints.filter(endpoint => endpoint.useType === EndpointType.API);
          this.otherTypeEndpoints = data.endpoints.filter(endpoint => endpoint.useType === EndpointType.OTHER);
          if (this.configTypeEndpoints.length > 0
            || this.accessTypeEndpoints.length > 0
            || this.exploreTypeEndpoints.length > 0
            || this.otherTypeEndpoints.length > 0) {
            this.isEndpointAvailable = true;
          }

          if (this.configTypeEndpoints.length > 0) {
            this.availableEndpoints = this.availableEndpoints + 1;
          }
          if (this.accessTypeEndpoints.length > 0) {
            this.availableEndpoints = this.availableEndpoints + 1;
          }
          if (this.exploreTypeEndpoints.length > 0) {
            this.availableEndpoints = this.availableEndpoints + 1;
          }
        } else {
          this.isEndpointAvailable = false;
        }
      });
    }
  }

  private setDevInstance(allInstances: Instance[]): void {
    const devInstanceExpanded = this.devInstance?.expanded;
    this.sandboxCreationStatus = allInstances.find(i => i.dataZone === DataZone.DEVELOPMENT)?.status;
    this.devInstance = this.getDevInstance(allInstances);
    const previousInstanceId = this.selectedInstanceId;

    // Prioritize selecting an instance with 'ing' status from ALL instances, otherwise select first dev instance
    if (allInstances && allInstances.length > 0) {
      // First, try to find ANY instance in allInstances with 'ing' status
      const instanceWithIngStatus = allInstances.find(inst =>
        inst.status && inst.status.toLowerCase().endsWith('ing')
      );
      if (instanceWithIngStatus) {
        this.selectedInstanceId = instanceWithIngStatus.id;
      } else if (Array.isArray(this.devInstance) && this.devInstance.length > 0) {
        this.selectedInstanceId = this.devInstance[0]?.id || '';
      } else {
        this.selectedInstanceId = '';
      }
    } else {
      this.selectedInstanceId = '';
    }

    if (this.selectedInstanceId !== previousInstanceId) {
      this.instancePollingService.resetTimer(this.selectedInstanceId);
      this.lastUpdateTime$ = this.instancePollingService.getLastUpdateTime(this.selectedInstanceId);
      this.displayTime$ = combineLatest([
        this.lastUpdateTime$.pipe(
          startWith(new Date()),
          map(value => value || new Date())
        ),
        interval(1000).pipe(startWith(0))
      ]).pipe(
        map(([lastUpdate]) => lastUpdate),
        takeUntilDestroyed(this.destroyRef)
      );
      // Ensure polling is set up for the newly selected instance
      if (this.dataLoaded) {
        this.updatePollingBasedOnStatus();
      }
    }

    this.isDevInstanceDeployed = this.devInstance.find((item)=> item.type !== InstanceType.OTHER && item.type !== InstanceType.EAAS && !this.INSTANCE_DRAG_DROP_NEGATIVE_STATUS.includes(item.status));
    if (this.devInstance) {
      this.devInstance.expanded = devInstanceExpanded;
      this.getEndpointTypes(this.devInstance);
    }

  }

/**
 * Sets the other instance
 */
  private setOtherInstance(allInstances: Instance[]): void {
    const otherInstanceExpanded = this.otherInstance?.expanded;
    this.sandboxCreationStatus = allInstances.find(i => i.type === (InstanceType.OTHER || InstanceType.EAAS))?.status;
    this.otherInstance = this.getOtherInstance(allInstances);
    if (this.otherInstance) {
      this.otherInstance = this.sortInstancesByDateCreated(this.otherInstance);
      this.otherInstance.expanded = otherInstanceExpanded;
      this.getEndpointTypes(this.otherInstance);
    }
  }

  /**
   * Sets the workbench url if present
   */
  private setWorkbenchUrl(): void {
    if (this.devInstance?.length > 0) {
      this.workbenchUrl = this.devInstance[0]?.endpoints?.find(endpoint => endpoint.useType === EndpointType.CONFIGURATION)?.url;
    }
  }

  private setPTLInstances(allInstances: Instance[]): void {
    this.allInstances?.forEach((item: any) => {
          this.instanceService.getInstanceParameters(item.id).pipe(takeUntilDestroyed(this.destroyRef))
          .subscribe((data) => {
            this.showLoaderConfig = false;
            if(data?.parameters?.componentParameterStatus === DeployStatus.FAILED) {
              item.configurationStatus = false;
            } else if(data?.parameters?.components?.length || data?.parameters?.componentParameterStatus === DeployStatus.SUCCESS || Object.keys(data?.parameters ?? {}).length === 0 || data?.parameters?.components?.length === 0) {
              item.configurationStatus = true;
            }
          }, (error) => {
            this.showLoaderConfig = false;
            item.configurationStatus = true;
        setTimeout(() => {
		  const title = translate('ERRORS.SERVICE_AVAILABILITY');
          const message = error?.message ? error?.message : (error?.error?.message ? error?.error?.message : (error?.errmsg ? error?.errmsg : translate('SERVICE.INTERNAL_SERVER_ERROR')));
          this.toastrService.errMessage(message, title);
        }, 500);
          });
         if (this.INSTANCE_FAILED_STATES.includes(item.status)) {
            forkJoin({ showWarning: this.getInstaceActivity(item.id) }).subscribe(({ showWarning }) => {
              this.instanceWarningStatus.set(item.id, showWarning);
            });
          }
        })
    if (this.blueprint.pathToLiveConfiguration) {
      const instancesMap = allInstances
        .reduce((acc, instance) => {
          acc[instance.id] = instance;
          return acc;
        }, {});

      const expandedMap = {};
      if (this.pathToLiveInstances) {
        this.pathToLiveInstances.reduce((acc, instance) => {
          expandedMap[instance.environment] = instance.expanded;
          return expandedMap;
        }, expandedMap);
      }

      this.pathToLiveInstances = this.blueprint.pathToLiveConfiguration.map((pathToLiveConfiguration, index, pathToLiveArray) => {
        let instance;
        if (pathToLiveConfiguration.instanceId && instancesMap[pathToLiveConfiguration.instanceId]) {
          instance = instancesMap[pathToLiveConfiguration.instanceId];
          instance.environment = pathToLiveConfiguration.environment;
        } else {
          instance = this.buildInstancePlaceholder(pathToLiveConfiguration);
        }

        const previousEnvironment = pathToLiveArray[index - 1];
        if (!previousEnvironment && index === 0) {
          const devInstance: any = this.getDevInstance(allInstances);
          const disableStatuses = [DeployStatus.INITIALIZING, DeployStatus.INITIALIZE_FAILED, DeployStatus.NOT_DEPLOYED, DeployStatus.DEPLOYING, DeployStatus.FAILED]
          this.devDeployed = devInstance.some(item => item.availabilityState !== 'not_ready' && !disableStatuses.includes(item.status))
        } else if (previousEnvironment) {
          instance.previousEnvironment = previousEnvironment;
          instance.previousInstance = instancesMap[previousEnvironment.instanceId];
        } else if (!this.serviceVersionsInfo?.currentVersion?.applyConfigurationInstructionId) {
          // Fake instance to allow deployment of first environment in PTL for non configurable services
          instance.previousInstance = {
            status: DeployStatus.DEPLOYED
          };
        } else {
          instance.previousInstance = this.devInstance[0];
        }

        instance.expanded = expandedMap[instance.environment];
        return instance;
      });

      // Add terminated PTL instances from allInstances at the top
      const terminatedPTLInstances = allInstances.filter(i => (i.type === InstanceType.PTL || i.type === InstanceType.PROD) && i.status === DeployStatus.TERMINATED);
      terminatedPTLInstances.forEach(terminatedInstance => {
        const alreadyExists = this.pathToLiveInstances.some(pti => pti.id === terminatedInstance.id);
        if (!alreadyExists) {
          this.pathToLiveInstances.unshift(terminatedInstance);
        }
      });

      this.filterPathToLiveInstances();
      this.loadWorkflowApprovals();
    } else {
      // Remove PTL instances if it is a demo blueprint or blueprint without PTL configuration
      delete this.pathToLiveInstances;
      delete this.testDataZoneInstances;
      delete this.piiDataZoneInstances;
    }
  }

  private buildInstancePlaceholder(pathToLiveConfiguration: PathToLiveConfiguration): any {
    return {
      name: `${pathToLiveConfiguration.environment}_${translate('BLUEPRINT_SUMMARY.NA')}`,
      environment: pathToLiveConfiguration.environment,
      deploymentClass: pathToLiveConfiguration.deploymentClass,
      dataZone: pathToLiveConfiguration.dataZone,
      status: DeployStatus.NOT_DEPLOYED
    };
  }

  /**
   * Filters test and PII data zone instances
   */
  private filterPathToLiveInstances(): void {
    if (this.pathToLiveInstances?.length > 0) {
      this.piiDataZoneInstances = this.pathToLiveInstances.filter(this.filterInstanceByDataZone([DataZone.DEVELOPMENT, DataZone.SECURE, DataZone.LIVE]));
      this.liveDataZone = this.pathToLiveInstances.find(this.filterInstanceByDataZone([DataZone.LIVE]));
      this.getActivityDetailsETA(this.pathToLiveInstances);
  } else {
      if (this.instanceBlueprint?.length) { 
        const updatedInstances = this.bookmarkInstance(this.getActivityDetailsETA());
        this.devInstances = updatedInstances?.filter((item: any) => item.type !== InstanceType.OTHER && item.type !== InstanceType.EAAS && item.deploymentClass === DeploymentClass.D);
        this.piiDataZoneInstances = updatedInstances?.filter((item: any) => ((item.type !== InstanceType.OTHER && item.type !== InstanceType.EAAS && item.dataZone === DataZone.SECURE && (item.deploymentClass === DeploymentClass.C || item.deploymentClass === DeploymentClass.B)) || item.deploymentClass === DeploymentClass.A));
        this.liveDataZone = updatedInstances?.filter((item: any) => item.type !== InstanceType.OTHER && item.type !== InstanceType.EAAS && item.deploymentClass === DeploymentClass.A);
        this.otherInstances = updatedInstances?.filter((item: any) => item.type === InstanceType.OTHER || item.type === InstanceType.EAAS);
        this.changeDetectorRef.detectChanges();

        // TODO: Wrap lines 3568-3573 in forkJoin to execute after activity logs complete
      }
    }
    this.instancesByOrder = [];
    this.instancesByOrder = this.testDataZoneInstances?.length > 0 ? [...this.testDataZoneInstances] : this.instancesByOrder;
    this.instancesByOrder = this.piiDataZoneInstances?.length > 0 ? [...this.instancesByOrder, ...this.piiDataZoneInstances] : this.instancesByOrder;
    if (this.instanceBlueprint?.length) {
      this.ptlTerminatedInstances = this.instanceBlueprint?.filter(item => (item.deploymentClass === DeploymentClass.C && item.status === DeployStatus.TERMINATED) || (item.deploymentClass === DeploymentClass.B && item.status === DeployStatus.TERMINATED) || (item.deploymentClass === DeploymentClass.A && item.status === DeployStatus.TERMINATED));
    }
  }

  private configureBreadcrumb(blueprint: Blueprint, service: Solution): void {
    this.breadcrumbItems = [];
    this.breadcrumbItems.push({ label: 'Home', url: [] });
    this.breadcrumbItems.push({ label: translate('CATALOGUE.CATALOGUE'), url: ['catalogue'] });
    this.breadcrumbItems.push({ label: service.name, url: ['services', service.id] });
  }
/**
 * Compares the release versions of prod and preprod and displays alert accordingly
*/
  private checkForVersions(): void {
    const getPTLInstance = (env: PathToLiveEnvironment) =>
      this.pathToLiveInstances?.find(
        (e) =>
          e.environment === env
      );

    const live = getPTLInstance(PathToLiveEnvironment.LIVE);
    const preprod = getPTLInstance(PathToLiveEnvironment.PREPROD);

    if (!live || !preprod) {
      this.showVersionAlert = false;
      return;
    }

    const liveVersion = this.getBuildVersion(live.solutionVersionId);
    const preprodVersion = this.getBuildVersion(preprod.solutionVersionId);

    if (!liveVersion || !preprodVersion) {
      this.showVersionAlert = false;
      return;
    }

    if (liveVersion === preprodVersion) {
      this.showVersionAlert = false;
      this.solVersionMsg = '';
    } else {
      const comparisonKey =
        liveVersion > preprodVersion
        ? translate('INSTANCE_DETAILS.VERSION_COMPARISION.HIGHER_THAN')
        : translate('INSTANCE_DETAILS.VERSION_COMPARISION.LOWER_THAN');

      this.showVersionAlert = true;
      this.solVersionMsg = `${translate('INSTANCE_DETAILS.VERSION_COMPARISION.PROD_SOL_VER')} ${liveVersion} ${translate(comparisonKey)} ${translate('INSTANCE_DETAILS.VERSION_COMPARISION.PREPROD_VER')} ${preprodVersion}${translate('INSTANCE_DETAILS.VERSION_COMPARISION.TAKE_ACTION')}`;
    }
  }


  /**
   * After the list of configurations is fetched, the active applied configurations are marked
   *
   * @param instances - the instances array
   */
  private prepareActiveConfigurations(instances: any[]): void {
     this.configurationsService.getConfigurations(this.blueprint.id)
    .pipe(takeUntilDestroyed(this.destroyRef))
    .subscribe((configurations)=>{
      this.configurations = configurations;
      instances.forEach((instance: any) => {
      if(instance.dataZone === DataZone.LIVE &&instance.latestConfigurationState?.status !== ConfigurationApplicationStatus.VERIFIED) {
        if(instance.latestConfigurationState?.status === ConfigurationApplicationStatus.SUCCESS) {
          instance.activeConfiguration = this.configurations?.find(config => config.id === instance.configurationId);
          if(instance.activeConfiguration) {
            this.liveReleaseData = instance.activeConfiguration.manifest.version;
          }
        }
      } else if(instance.dataZone !== DataZone.LIVE) {
        instance.activeConfiguration = this.configurations?.find(config => config.id === instance.configurationId);
      }
    });
    },(error) => {
        setTimeout(() => {
		  const title = translate('ERRORS.SERVICE_AVAILABILITY');
          const message = error?.message ? error?.message : (error?.error?.message ? error?.error?.message : (error?.errmsg ? error?.errmsg : translate('SERVICE.INTERNAL_SERVER_ERROR')));
          this.toastrService.errMessage(message, title);
        }, 500);
      }
  )

  }

  private resolveLiveStatus(instances: Instance[]): boolean {
    if (this.isSandbox) {
      return instances[0].status === DeployStatus.DEPLOYED;
    }
    const live = instances.find(instance => instance.deploymentClass === DeploymentClass.A);
    return this.INSTANCE_DEPLOYED_STATES.includes(live?.status);
  }

  private resolveShowCharts(instances: Instance[]): boolean {
    return instances.some(instance => instance.deploymentClass !== DeploymentClass.D
      && this.INSTANCE_DEPLOYED_STATES.includes(instance.status));
  }

  private resolveTrialLabel(): string {

    if (!this.isSandbox) {
      return;
    }
    const expirationDate = this.devInstance[0]?.expirationDate;
    const label = translate('BLUEPRINT_SUMMARY.TRIAL_EXPIRES_ON') + ' ' + moment(expirationDate).utc().format('DD MMM YYYY hh:mm')+ ' UTC';

    const lastDate = expirationDate;
    const remainingDays = getDiffDays(new Date(), lastDate);
    if (remainingDays <= 0) {
      return translate('BLUEPRINT_SUMMARY.TRIAL_EXPIRED') + ' ' + moment(expirationDate).utc().format('Do MMM YYYY');
    }

    return label;
  }

  private loadService(): void {
    const serviceId = this.blueprint.solutionId;
    combineLatest([this.solutionsService.getSolutionById(serviceId), this.solutionsService.getSolutionVersions(serviceId)])
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(([service, serviceVersions]) => {
        this.sortedSolutionVersionId =
        (serviceVersions.sort((a,b) => a?.version && b?.version ? b?.version?.localeCompare(a?.version) : !b?.version ? -1 : 1));
        const findVersion =  serviceVersions.find(item => item.id === service.latestSolutionVersionId);
        this.onBoardingProcess = findVersion?.onboardingProcess;
        this.service = service;
        this.serviceVersions = serviceVersions;
        // if(this.serviceVersions[0]?.sandboxType === 'enterprise') {
        //   this.enterPriseSandbox = true;
        // }
        this.publishedServiceVersions = serviceVersions.filter(serviceVersion => serviceVersion.status === translate('VERSIONS.PUBLISHED'));
        // this.includedCapabilities = this.serviceVersions[0].capabilities?.filter(item => item.required === CapabilityType.MANDATORY);
        this.capabilitiesGroups = this.frameCapabilities(this.selectedCapabilities);
        for (const serviceVersionsNotes of this.serviceVersions) {
          this.viewReleaseNotes = serviceVersionsNotes.releaseNotes;
        }
        this.loadBlueprint();
        this.loadInstances();
      }
      // , (err) => this.errorPageService.show404Page()
      );
  }

  private capabilitiesMapping(capabilitiesByType?: any): any {
    return Object.keys(capabilitiesByType)
      .map(capabilityType => ({name: capabilityType, capabilities: capabilitiesByType[capabilityType]}));
  }


  private loadBlueprint(): void {
      this.blueprintsService.getBlueprint(this.blueprint.id)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(
        (blueprints: any) => {
        const blueprint = blueprints;
        if (!this.permissionsMap[PermissionKeys.BLUEPRINT_READ] && !blueprint.demo) {
          this.router.navigate(['/', this.tenantId, 'tenant', 'permission-unauthorized'], {skipLocationChange: true});
        }
        this.extendSandbox = !!(blueprint.capabilities && this.serviceVersions[0].capabilities);
        this.bluerprintById = blueprint;
        // this.selectedCapabilities = blueprint.capabilities?.filter(item => item.required === CapabilityType.OPTIONAL);
        if (!blueprint.demo) {
          this.loadBlueprintVersion(blueprint.id);
        }
        this.onLoadBlueprintSubscription(blueprint);
      }, (err) => this.errorPageService.show404Page());
    if (this.blueprintId) {
      //Call this api once the latest blueprint version api is available
      this.blueprintsService.getBlueprintsIdLatestVersion(this.blueprintId)
        .pipe(takeUntilDestroyed(this.destroyRef))
        .subscribe(blueprintLatestVersion => {
          this.blueprintLatestVersion = blueprintLatestVersion;
         this.loadBlueprintVersionById(this.blueprintId, blueprintLatestVersion.id);
        },  (error) => {
        setTimeout(() => {
		  const title = translate('ERRORS.SERVICE_AVAILABILITY');
          const message = error?.message ? error?.message : (error?.error?.message ? error?.error?.message : (error?.errmsg ? error?.errmsg : translate('SERVICE.INTERNAL_SERVER_ERROR')));
          this.toastrService.errMessage(message, title);
        }, 500);
        });
    }
  }

  private onLoadBlueprintSubscription(blueprint: Blueprint): void {
    this.blueprint = blueprint;
    this.isSandbox = blueprint.demo;
    this.configureBreadcrumb(this.blueprint, this.service);
    this.loadData();
  }

  private loadBlueprintVersion(id: string): void {
    this.blueprintsService.getBlueprintVersion(id).pipe(takeUntilDestroyed(this.destroyRef)).subscribe(
      blueprintVersion => {
        if (blueprintVersion) {
          this.blueprintsVersionList = blueprintVersion;
          this.blueprintsVersionList = this.blueprintsVersionList.sort((a, b) => Number(a.version) - Number(b.version));
      }
      this.blueprintsVersionList.map(item => item.deleteDisable = false);
      this.disableDeleteForBpVersion();
      this.isInstance = blueprintVersion.length > 1;
      this.blueprintVersion = blueprintVersion[0];
      this.blueprintSingleVersion = blueprintVersion[0];
      this.getCapabilitiesGroup(this.blueprintsVersionList);
    },
    (error) => {
      this.blueprintsVersionList = [];
      this.blueprintsVersionList = error;
      }
    );
  }

  // Disable delete option for versions less than the latest in progress version;
  private disableDeleteForBpVersion(): void {
    if (Array.isArray(this.blueprintsVersionList) && this.allInstances) {
      const versionsList = cloneDeep(this.blueprintsVersionList);
      versionsList.sort((a, b) => new Date(b?.dateCreated)?.getTime() - new Date(a?.dateCreated)?.getTime());
      let latestVersionFound = false;
      let latestVersion;
      versionsList.forEach(version => {
        if (!latestVersionFound && this.allInstances.find(item => item.blueprintVersionId === version.id)) {
          latestVersionFound = true;
          latestVersion = version;
        }
      })
      this.blueprintsVersionList.forEach(item => {
        if (latestVersion?.dateCreated?.localeCompare(item?.dateCreated) === 1) {
          item.deleteDisable = true;
        }
      })
    }
  }

  private loadBlueprintVersionById(blueprintId: string, id: string): void {
    this.blueprintsService.getBlueprintVersionById(blueprintId, id).pipe(takeUntilDestroyed(this.destroyRef)).subscribe(
      blueprintVersion => {
        this.extendSandbox = !!(blueprintVersion.capabilities && this.serviceVersions[0].capabilities);
        this.selectedCapabilities = blueprintVersion.capabilities;
        this.capabilitiesGroups = this.frameCapabilities(this.selectedCapabilities);
        this.blueprintVersion = blueprintVersion;
      }
    );
  }

  private loadInstances(): void {
    this.updateServiceId = localStorage.getItem("updatedServiceInstance");
    this.showLoaderConfig = true;
    this.instanceService.getInstancesForSolution(this.service.id, this.blueprint.id, this.tenantId)
      .pipe(takeUntilDestroyed(this.destroyRef)).subscribe(
      (instance: any) => {
    if (instance) {
    const instancePayload: any = {
      solutionId: this.service.id,
      blueprintId:  this.blueprint.id,
      tenantId: this.tenantId
    };
    if (instance.total && instance.total > 10) { instancePayload.size = instance.total; }
    this.instanceService.getInstances(instancePayload)
      .pipe(takeUntilDestroyed(this.destroyRef)).subscribe(
      (instance: any) => {
        this.initialLoader = false;
        this.instances = instance.data;
        this.instances = this.instances.map(obj => ({ ...obj, serviceDefinitionUpdate: obj.id === this.updateServiceId}));
        this.deleteBlueprints.emit(this.instances);
        const instances = instance.data;
        instances.filter((x) => {
          if (x.name === translate('BLUEPRINT_SUMMARY.DEMO_INSTANCE_SANDBOX') && x.blueprintId === this.blueprintId) {
            if(x.dateCreated !== x.dateUpdated) {
              this.extendSandboxMessage = true;
            }
            this.instanceId = x.id;
          }
        });
        const updatedInstances = this.bookmarkInstance(instances);
        this.instanceUpdatedMessage(updatedInstances);
        this.setDevInstance(updatedInstances);
        this.setPTLInstances(updatedInstances);
        this.setOtherInstance(updatedInstances);
        this.isLive = this.resolveLiveStatus(updatedInstances);
        this.showCharts = this.resolveShowCharts(updatedInstances);
        this.setWorkbenchUrl();
        this.loadInitStatus(updatedInstances);
      }, (error) => {
        this.initialLoader = true;
        setTimeout(() => {
          const title = translate('ERRORS.SERVICE_AVAILABILITY');
          const message = error?.message ? error?.message : (error?.error?.message ? error?.error?.message : (error?.errmsg ? error?.errmsg : translate('SERVICE.INTERNAL_SERVER_ERROR')));
          this.toastrService.errMessage(message, title);
        }, 500);
      });
  }});
  }



  private loadData(): void {
    this.updateServiceId = localStorage.getItem("updatedServiceInstance");
    this.dataLoaded = false;
    this.showLoaderConfig = false;
    // Reset timer for all instances whenever data is loaded
    if (this.allInstances && this.allInstances.length > 0) {
      this.allInstances.forEach(instance => {
        this.instancePollingService.resetTimer(instance.id);
      });
    }
    this.titleService.setTitle(this.service?.name);
    if (this.loadDataSubscription) {
      this.loadDataSubscription.unsubscribe();
      this.loadDataSubscription = null;
    }
    this.instanceService.getInstancesForBlueprint(this.blueprint.id, this.tenantId)
    .pipe(takeUntilDestroyed(this.destroyRef)).subscribe(
      (data: any) => {
    if (data) {
    const instancePayload: any = {
      blueprintId:  this.blueprint.id,
      tenantId: this.tenantId
    };
    if (data.total && data.total > 10) { instancePayload.size = data.total; }
    this.instanceService.getInstances(instancePayload)
    .pipe(takeUntilDestroyed(this.destroyRef)).subscribe(
      (data: any) => {
        data.data = data.data.map(obj => ({ ...obj, serviceDefinitionUpdate: obj.id === this.updateServiceId }));
        this.instanceTotal = data.total;
        this.classEInstances = data.data.filter((item: any) => item.deploymentClass === DeploymentClass.E);
        this.allInstances = data.data.filter((item: any) => item.deploymentClass !== DeploymentClass.E);
        this.allInstancesWithClassE = data.data;
        this.resolveDeployAgentIds(this.allInstances);
        this.instancesLoaded = true;
        this.restoreEnvironments = this.allInstances.filter(item => !this.INSTANCE_DRAG_DROP_NEGATIVE_STATUS.includes(item.status));
        this.restoreEnvironments = this.restoreEnvironments.sort((a, b) => a?.name.localeCompare(b?.name));
        this.getInstanceRestores();
        this.loadDataSubscription = this.loadInstancesWithConfigurationState(this.blueprint.id, this.instanceTotal)
      .pipe(
        finalize(() => {
          this.dataLoaded = true;
          this.updatePollingBasedOnStatus();
        }),
        takeUntilDestroyed(this.destroyRef))
      .subscribe((instances:any) => {
        instances = instances.map(obj => ({ ...obj, serviceDefinitionUpdate: obj.id === this.updateServiceId }));
        this.classEInstances = instances.filter((item: any) => item.deploymentClass === DeploymentClass.E);
        this.allInstances = instances.filter((item: any) => item.deploymentClass !== DeploymentClass.E);
        this.allInstancesWithClassE = instances;
        this.resolveDeployAgentIds(this.allInstances);
        this.setPTLInstances(this.allInstances);
        this.prepareActiveConfigurations(this.allInstances);
        this.checkForRunningJobs(this.allInstances);
      });
        this.allInstances.forEach((item: any) => {
          const stored = localStorage.getItem( `scheduleClicked_${item?.tenantId}_${item?.id}`) === 'true';
          if(stored){
            item.isEAASScheduleClicked = true;
          }
          item.showHeader = false;
        });
       
        // this.otherInstance.forEach((item: any)=> {
        //   item.showHeader = false;
        // });
        this.allInstancesWithClassE.forEach((item: any) => {
          if (this.INSTANCE_DEPLOYING_STATES.includes(item.status) && item.status !== DeployStatus.TERMINATED) {
            const instanceId = item.id;
            this.activityService.getInstanceActivityLogs(instanceId).pipe(takeUntilDestroyed(this.destroyRef))
            .subscribe((activityLogs) => {
              const target = this.allInstancesWithClassE.find(i => i.id === instanceId) ?? item;
              const logs = Array.isArray(activityLogs) ? activityLogs : (activityLogs?.data ?? []);
              if (target.status === DeployStatus.DEPLOYING && logs?.length === 0) {
                target.agentCreationProgress = DeployStatus.TENANT_AGENT_CREATION_IN_PROGRESS;
              }
              const latestLog = [...logs].sort((a, b) =>
                new Date(b?.startTime).getTime() - new Date(a?.startTime).getTime()
              )[0];
             this.activityService.getInstanceActivityLogsById(instanceId, latestLog?.id).pipe(takeUntilDestroyed(this.destroyRef))
            .subscribe((activityLogs) => {                     
             target.activityDetails = activityLogs;
              const stages: any[] = activityLogs?.stages ?? [];
              const execStage = stages.find(s => s.type === 'component_execution');
              const components: any[] = execStage?.components ?? [];
        let countData: any = {};
        target.activityDetails.countData = {};
        if (execStage?.count?.total) {
          countData.total       = Number(execStage.count.total);
          countData.completed   = Number(execStage.count.completed ?? 0);
          countData.skipped     = Number(execStage.count.skipped   ?? 0);
          countData.pending     = Number(countData.total - (countData.completed + countData.skipped));
          countData.completedPercent = countData?.completed !== 0 ? Math.round(((countData?.completed + countData.skipped) / countData.total) * 100) : 0;
          target.activityDetails.countData.total  = countData.total;
          target.activityDetails.countData.completedPercent  = countData.completedPercent;
        }
            });
              const activeStage = latestLog?.stages?.find((s: any) => !s.finishTime);
              // if (activeStage?.startTime && activeStage?.expectedDurationMs) {
                target.activityStartTime = latestLog.startTime;
                target.expectedDurationMs = latestLog.expectedDurationMs;
              // }
              if (latestLog?.count && latestLog?.count?.total) {
                target.total = Number(latestLog.count.total);
                target.completed = Number(latestLog.count.completed ?? 0);
                target.skipped = Number(latestLog.count.skipped ?? 0);
                target.pending = Number(target.total - (target.completed + target.skipped));
                target.completedPercent = target?.completed !== 0 ? Math.round(((target?.completed + target?.skipped) / target.total) * 100) : 0;
              }
            });
          }
        });

        const configCalls = this.allInstances.map(item =>
        this.instanceService.getInstanceParameters(item.id).pipe(
          map((data) => {
            if(data?.parameters?.componentParameterStatus === DeployStatus.FAILED) {
              item.configurationStatus = false;
            } else if(data?.parameters?.components?.length || data?.parameters?.componentParameterStatus === DeployStatus.SUCCESS || Object.keys(data?.parameters ?? {}).length === 0 || data?.parameters?.components?.length === 0) {
              item.configurationStatus = true;
            }
            return item;
          }),
          catchError(() => {
            item.configurationStatus = true;
            return of(item);
          })
        )
      );
      forkJoin(configCalls).subscribe(() => {
        const updatedInstances = [...this.allInstances];
        this.setDevInstance(updatedInstances);
        this.setPTLInstances(updatedInstances);
        this.setOtherInstance(updatedInstances);
      });

        this.allInstances?.forEach((item: any) => {
          if (item.status === DeployStatus.OPERATION_INPROGRESS) {
            this.dbBackupService.getInstanceDbBackups(item.id)
            .pipe(takeUntilDestroyed(this.destroyRef))
            .subscribe(dbResults => {
              if (Number(dbResults.total) > 10) {
                this.dbBackupService.getInstanceDbBackups(item.id, dbResults?.total)
                .pipe(takeUntilDestroyed(this.destroyRef))
                  .subscribe(response => {
                    const isDbStatusInprogress = response?.data?.find(db => db.status === 'inprogress');
                    if (isDbStatusInprogress) {
                      item.dbBackupStatus = true;
                    }
                  })
              } else {
                const isDbStatusInprogress = dbResults?.data?.find(db => db.status === 'inprogress');
                if (isDbStatusInprogress) {
                  item.dbBackupStatus = true;
                }
              }
            });
          }
          if (item.status !== DeployStatus.TERMINATED && item.status !== DeployStatus.TERMINATING && item.status !== DeployStatus.TERMINATION_FAILED) {
            this.instanceService.getInstanceById(item.id)
            .pipe(takeUntilDestroyed(this.destroyRef))
                .subscribe((instanceResult: any) => {
                  if(instanceResult && instanceResult?.cob) {
                this.cobService.getCobConfigResults(item.id)
                .pipe(takeUntilDestroyed(this.destroyRef))
                .subscribe(cobResults => {
                    const size = cobResults?.total;
                    this.cobService.getCobConfigResults(item.id, size)
                    .pipe(takeUntilDestroyed(this.destroyRef))
                    .subscribe((cobResults: any) => {
                  if (cobResults?.data.length === 0) {
                    item.cobConfigurationInprogress = true;
                  }
                  cobResults?.data?.forEach(element => {
                    element.updatedStages = [];
                    let obj;
                    element.stages = element?.stages.filter(item => item.stage !== 'COB-REPORT');
                    element?.stages.forEach(innerElement => {
                      if(element?.updatedStages?.find(item => (item.stage === innerElement.stage) && (innerElement.status.toLowerCase() !== 'started'))) {
                        element.updatedStages.find(item => (item.stage === innerElement.stage)).status = innerElement.status.toLowerCase();
                      } else {
                      obj = innerElement;
                      obj.status = innerElement.status.toLowerCase();
                      element.updatedStages = [...element.updatedStages, obj];
                      }
                    })
                    element.updatedStages.find(item => (item.status.toLowerCase() === 'failed')) ? element.status = 'failed' : (element.updatedStages.find(item => (item.status.toLowerCase() === 'started'))) ? element.status = 'started' : ((element.updatedStages.find(item => (item.status.toLowerCase() === 'not started'))) ? element.status = 'not started' : element.status = 'completed');
                    const isCOBStatuInprogress = element.status.toLowerCase() === 'started';
                      if (isCOBStatuInprogress) {
                        if(element.completionMode !== 'manual') {
                        item.cobStatus = true;
                        }
                      }
                    });
                  });
                });
              }
            });
        }

        })
        this.disableDeleteForBpVersion();
        this.buildNumber = [];
        this.serviceVersionsInfo = this.solutionVersionsService.getSolutionVersionsInfo(this.service, this.serviceVersions, this.allInstances);
        this.buildNumber.push(this.isSandbox ? this.serviceVersionsInfo?.devVersion?.version
          : this.serviceVersionsInfo?.currentVersion?.version);

        const liveInstance = this.allInstances.find(instance => instance.deploymentClass === DeploymentClass.A);
        if (liveInstance) {
          this.latestReleaseVersion = this.serviceVersions.filter(version =>
            version.id === liveInstance.solutionVersionId)[0]?.releaseVersion;
        } else {
          const instanceLength = this.allInstances.length;
          const latestInstanceSolutionVersion = this.allInstances[instanceLength - 1]?.solutionVersionId;
          this.latestReleaseVersion = this.serviceVersions.filter(version =>
            version.id === latestInstanceSolutionVersion)[0]?.releaseVersion;
        }

        const updatedInstances = this.bookmarkInstance(this.allInstances);
        this.createNewBtnEnable = this.serviceVersions[0]?.capabilities?.length > this.blueprintLatestVersion?.capabilities?.length;
        this.isLive = this.resolveLiveStatus(this.allInstances);
        this.showCharts = this.resolveShowCharts(this.allInstances);
        this.prepareActiveConfigurations(this.allInstances);
        this.setDevInstance(updatedInstances);
        this.setWorkbenchUrl();
        this.setOtherInstance(updatedInstances);
        // this.trialStatus = this.resolveTrialLabel();
        this.setPTLInstances(updatedInstances);
        this.loadInitStatus(this.allInstances);
        // TODO: Fix problem with scrolling to element
        // this.triggerGuideIfApplicable();
        if (this.allInstances[0]) {
          this.demoInstance = this.allInstances[0];
          this.checkIfDeployed();
          this.isInit = true;
        }
        this.checkForVersions();
        let releaseVersionText;
        if (this.latestReleaseVersion) {
          releaseVersionText = this.latestReleaseVersion;
        } else if (this.isSandbox) {
          releaseVersionText = this.serviceVersionsInfo?.devVersion?.releaseVersion;
        } else {
          releaseVersionText = this.serviceVersionsInfo?.currentVersion?.releaseVersion;
        }

        this.isAMR = releaseVersionText && this.solutionVersionsService.releaseVersion(releaseVersionText) ? true : false;
      }, (error) => {
        setTimeout(() => {
          const title = translate('ERRORS.SERVICE_AVAILABILITY');
          const message = error?.message ? error?.message : (error?.error?.message ? error?.error?.message : (error?.errmsg ? error?.errmsg : translate('SERVICE.INTERNAL_SERVER_ERROR')));
          this.toastrService.errMessage(message, title);
        }, 500);
      }
      // Enable this line when the api is available
      //, () => this.errorPageService.show404Page()
      );
    }})

  }

  private loadInstancesWithConfigurationState(blueprintId: string, total?: number): Observable<Instance[]> {
    let size;
    if(total > 0) {
      size = total;
    }
    return this.instanceService.getInstancesForBlueprint(blueprintId, this.tenantId, size)
      .pipe(mergeMap((instances: any) => {
        this.instanceBlueprint = instances.data;
        for (const data of instances.data) {
          if (data?.endpoints && data?.endpoints.length !== 0) {
            this.endpointView = true;
            if (data?.endpoints?.find(endpoint => endpoint.useType === EndpointType.CONFIGURATION)) {
              this.gotoWorkBench = true;
            }
          }
        }
        const instanceData = instances.data;
        const latestConfigRequests = instanceData
          .filter(instance => instance.configurationId)
          .map(instance => this.configurationsService.getConfigurationStates(
            instance.id
          ));
        this.deployedDate = instanceData.length > 0 ? instanceData[instanceData.length - 1].dateUpdated : this.currentDate;
        if (latestConfigRequests.length > 0) {
          return combineLatest(latestConfigRequests).pipe(map((configurationStates: any) => {
            if (configurationStates) {
              configurationStates.forEach(configurationStatesForInstance => {
                if (configurationStatesForInstance?.length > 0) {
                  const instance = instanceData.find(inst => configurationStatesForInstance[0].instanceId === inst.id);
                  this.setInstanceConfigurationStates(instance, configurationStatesForInstance);
                }
              });
            }
            return instanceData;
          }));
        }
        return of(instanceData);
      }
      ));
  }

  private loadConfigurationStatesForInstance(instance: Instance): void {
    this.configurationsService.getConfigurationStates(instance.id)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(configurationStates => this.setInstanceConfigurationStates(instance, configurationStates));
  }

  private setInstanceConfigurationStates(instance: Instance, configurationStates: ConfigurationState[]): void {
    if (!instance || !configurationStates) {
      return;
    }
    configurationStates.sort((state1, state2) => state2.applicationStartTime.getTime() - state1.applicationStartTime.getTime());
    instance.configurationStates = configurationStates;

    this.configurationStateMessageStatus(instance.configurationStates);

    if (instance.configurationStates?.length > 0) {
      instance.latestConfigurationState = instance.configurationStates[0];
    }
  }

  private configurationStateMessageStatus(config): any {
    const lastRecordTime = config[0]?.applicationFinishTime;
    const getRemainingTime = this.dateTimeService.differenceBetweenDates(lastRecordTime, new Date(), Constants.TIME_UNIT_SECOND);
    let verifyStatus = false;
    if(this.configStateVerify && this.liveInstanceId === config[0]?.instanceId) {
      verifyStatus = true;
    }

    this.configLastRecord.push({
      instanceId: config[0]?.instanceId,
      remainingTime: getRemainingTime,
      status: verifyStatus
    });
  }

  private instanceUpdatedMessage(config): any {
    const updated = config?.filter((item)=> item.status === DeployStatus.UPDATED);

    const lastRecordTime = updated[0]?.dateUpdated;
    const getRemainingTime = this.dateTimeService.differenceBetweenDates(lastRecordTime, new Date(), Constants.TIME_UNIT_SECOND);
    this.updateMessageRemainingTime = getRemainingTime;
  }

  private buildDeployDialogData(instance: Instance, title: string): any {
    return {
      title,
      subtitle: instance.environment,
      deployment: {
        blueprintId: this.blueprint.id,
        dataZone: instance.dataZone,
        deploymentClass: instance.deploymentClass,
        targetEnvironment: instance.environment,
        region: this.blueprint.region,
        blueprintVersionId: this.blueprintsVersionList[0]?.id,
        pathToLiveFlow: true
      } as Deployment,
      service: this.service,
      tenantDetails: this.tenantDetails,
      instanceBlueprint: this.instanceBlueprint

    };
  }

  private updateMaintenanceWindow(): void {
    this.blueprintsService.getBlueprint(this.blueprint.id)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(blueprint => {
        const blueprintToUpdate = blueprint;
        blueprintToUpdate.updateWindowPolicy = this.updateWindowPolicy;
        this.blueprintsService.updateBlueprint(blueprintToUpdate)
          .pipe(takeUntilDestroyed(this.destroyRef))
          .subscribe((updatedBlueprint) => {
            this.onLoadBlueprintSubscription(updatedBlueprint);
          });
      }, (err) => this.errorPageService.show404Page());
  }

  private getAvailableConfigurations(instance: Instance): Configuration[] {
    const requiredEnvironment = this.blueprint.pathToLiveConfiguration.find(
      ptl => ptl.environment === instance.environment && ptl.instanceId === instance.id)?.requires;
    let availableConfigurations = this.configurations;
    const prodInstance = this.allInstances.find(instances => instances.environment === translate('CONFIGURATIONS.STATE.LIVE'));
    if (instance.environment === translate('CONFIGURATIONS.STATE.LIVE') &&
      prodInstance?.configurationStates?.find(config => config.status === ConfigurationApplicationStatus.VERIFIED)) {
      const latestVerifiedInstance = prodInstance.configurationStates
        .find(configurationState => configurationState.status === ConfigurationApplicationStatus.VERIFIED);
      const verifiedInstanceConfig =
        this.getConfigurationById(latestVerifiedInstance.configurationId);
      availableConfigurations = availableConfigurations
        .filter(configuration => configuration.dateCreated === verifiedInstanceConfig.dateCreated);
    } else if (requiredEnvironment) {
      const requiredInstance = this.allInstances.find(ptlInstance => ptlInstance.environment === requiredEnvironment);
      if (requiredInstance?.configurationStates) {
        const latestSuccessfulStateOfRequiredInstance = requiredInstance.configurationStates
          .find(configurationState => configurationState.status === ConfigurationApplicationStatus.SUCCESS);
        if (latestSuccessfulStateOfRequiredInstance) {
          const configAvailable = availableConfigurations;
          const latestAppliedConfigurationOnRequiredInstance =
            this.getConfigurationById(latestSuccessfulStateOfRequiredInstance.configurationId);
            availableConfigurations = [];
            for(const configStates of requiredInstance.configurationStates) {
              if (configStates.status === ConfigurationApplicationStatus.SUCCESS) {
                for(const availableConfig of configAvailable) {
                  if(availableConfig.id === configStates.configurationId) {
                    availableConfigurations.push(availableConfig);
                  }
                  availableConfigurations = [...new Set(availableConfigurations)];
                }
              }
            }
        } else {
          availableConfigurations = [];
        }
      } else {
        availableConfigurations = [];
      }
    }
    // Only configurations which are created after latest successfully applied configuration
    if (instance.configurationStates) {
      const latestSuccessfulState = instance.configurationStates
        .find(configurationState => configurationState.status === ConfigurationApplicationStatus.SUCCESS);
      if (latestSuccessfulState) {
        const latestAppliedConfiguration = this.getConfigurationById(latestSuccessfulState.configurationId);
        availableConfigurations = availableConfigurations
          .filter(configuration => configuration.dateCreated > latestAppliedConfiguration.dateCreated);
      }
    }

    return availableConfigurations;
  }
  private getConfigurationById(configurationId: string): Configuration {
    return this.configurations.find(configuration => configuration.id === configurationId);
  }

  /**
   * Handles the actual creation of an instance by
   * posting the deployment object. On successful response,
   *
   * @param deployment - the deployment object to be posted
   */
  private deployInstance(deploymentData): Observable<any> {
    const result = new Subject();
    if (deploymentData.targetEnvironment) {
      this.devInstanceEnvironment = deploymentData.targetEnvironment + ' ' + translate('NOTIFICATIONS.DEPLOYMENT_FAILED');
    } else {
      this.devInstanceEnvironment = deploymentData.dataZone  + ' ' + translate('NOTIFICATIONS.INSTANCE_FAILED');
    }
    this.updateWindowPolicy = null;
    // if (deploymentData.dataZone === DataZone.LIVE) {
    //   this.updateWindowPolicy = this.convertDayAndTimeToUTC(deploymentData.dayOfTheWeek,
    //     deploymentData.startingHour, deploymentData.endingHour);
    // } else {
    //   this.updateWindowPolicy = null;
    // }
    delete deploymentData.dayOfTheWeek;
    delete deploymentData.startingHour;
    delete deploymentData.endingHour;
    if(deploymentData.nonPtlFlow === true && deploymentData.targetEnvironment === InstanceType.OTHER){
      deploymentData.type = InstanceType.OTHER;
    }else if(deploymentData.nonPtlFlow === true && deploymentData.targetEnvironment === InstanceType.EAAS){
      deploymentData.type = InstanceType.EAAS;
    }else{
      deploymentData.type = deploymentData.deploymentClass === 'D' ? 'dev' : deploymentData.deploymentClass === 'A' ? 'prod' : 'ptl';
    }
    this.instanceService.deployInstance(deploymentData)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(() => {
        this.loadBlueprint();
            setTimeout(() => {
              const title = translate('TENANT_DASHBOARD.INSTANCE');
              const message = translate('NOTIFICATIONS.INSTANCE_INITIALIZED');
              this.toastrService.successMessage(message, title);
            }, 500);
      }, (error) => {
        const errorMessage = typeof error === 'string' ? error: typeof error?.error === 'string' ? error.error : error;
        this.matDialog.open(ErrorDialogComponent, {
          minHeight: '342px',
          width: '566px',
          panelClass: 'flex-dialog',
          data: {
            title: this.devInstanceEnvironment,
            description: errorMessage,
          }
        });
      });
    return result;
  }

  private subscribeForNotifications(): void {
    this.notificationsService.onAnyNotification([
      { type: 'com.temenos.engine.instance', data: { status: 'created' } },
      { type: 'com.temenos.engine.instance', data: { status: 'deleted' } },
      { type: 'com.temenos.engine.instance', data: { status: 'updated' } }
    ])
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((notification) => {
        if (notification.data?.blueprintId === this.blueprint?.id) {
          this.loadBlueprint();
        }
      });

    this.notificationsService.onNotification({ subject: 'Workflow approval' })
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((notification) => {
        if (notification.data?.blueprintId === this.blueprint?.id) {
          this.loadWorkflowApprovals();
        }
      });

    this.notificationsService.onAnyNotification([
      { type: 'com.temenos.saas.engine.configuration' },
      { subject: 'Change Task', data: { status: 'published' } },
      { subject: 'Change Task', data: { status: 'rejected' } },
      { subject: 'Change Task', data: { status: 'applying' } },
      { subject: 'Change Task', data: { status: 'applied' } }
    ])
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((notification) => {
        // TODO: Engine should add blueprintId to data! When they add it remove first if condition
        if (notification.data?.instanceId === this.devInstance.id) {
          this.loadData();
        } else if (notification.data?.blueprintId === this.blueprint?.id) {
          this.loadData();

          // if (notification.subject === 'Change Task' && notification.data.status === 'applied') {
          //   this.changeTaskApplying = false;
          // }
        }
      });

    this.notificationsService.onAnyNotification([
      { type: 'com.temenos.saas.engine.configuration.apply' },
      { type: 'com.temenos.saas.engine.configuration.verify' }
    ])
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((notification) => {
        const updatedInsance = this.allInstances?.find(instance => instance.id === notification.data?.instanceId);
        if (updatedInsance) {
          this.loadData();
        }
      });
  }

  refreshInstanceForm(): void {
    this.isLoading = true;
    this.loadData();
    this.isLoading = false;

    this.count = this.count !== 1 ? 1 : 0;
    this.defaultState = true;
    this.defaultState = false;
  }

  refreshClick(): void {
    if (this.isRefreshing) {
      return;
    }
    this.isRefreshing = true;
    setTimeout(() => {
      // Reset timer for all instances whenever user manually refreshes
      if (this.allInstances && this.allInstances.length > 0) {
        this.allInstances.forEach(instance => {
          this.instancePollingService.resetTimer(instance.id);
        });
      }
      this.loadData();
      this.instancePollingService.updateLastRefreshTime(this.selectedInstanceId || '');
      this.isRefreshing = false;
    }, 1000);
  }


  private updatePollingBasedOnStatus(): void {
    if (!this.allInstances || this.allInstances.length === 0) {
      this.activelyPolledInstances.forEach(instanceId => {
        this.instancePollingService.stopPolling(instanceId);
      });
      this.activelyPolledInstances.clear();
      return;
    }

    // Find all instances with 'ing' status
    const inProgressInstances = this.allInstances.filter(instance =>
      instance.status && (instance.status.toLowerCase().endsWith('ing') || instance?.lastOperation?.status === DeployStatus.INPROGRESS)
    );

    // Also include the selected instance if it has 'ing' status
    if (this.selectedInstanceId) {
      const selectedInstance = this.allInstances.find(i => i.id === this.selectedInstanceId);
      if (selectedInstance && selectedInstance.status && (selectedInstance.status.toLowerCase().endsWith('ing') ||
         selectedInstance?.lastOperation?.status === DeployStatus.INPROGRESS)) {
        if (!inProgressInstances.find(i => i.id === this.selectedInstanceId)) {
          inProgressInstances.push(selectedInstance);
        }
      }
    }

    // Get instance IDs that should be polling now
    const newPollingIds = new Set(inProgressInstances.map(i => i.id));

    // Stop polling for instances that were polling but should now stop
    this.activelyPolledInstances.forEach(instanceId => {
      if (!newPollingIds.has(instanceId)) {
        this.instancePollingService.stopPolling(instanceId);
        this.activelyPolledInstances.delete(instanceId);
      }
    });

    // Start polling for new instances with 'ing' status
    inProgressInstances.forEach(instance => {
      if (!this.activelyPolledInstances.has(instance.id)) {
        this.instancePollingService.startPolling(instance.id, true, 15000);
        this.activelyPolledInstances.add(instance.id);
      }
    });
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['blueprint'] && this.blueprint) {
      this.updatePollingBasedOnStatus();
    }
  }

  private checkIfDeployed(): void {
    if (this.demoInstance.status === DeployStatus.DEPLOYED) {
      this.showStepsLoadingSection = false;
    }
  }

  private subscribeForNotification(): void {
    this.notificationsService.onNotification(
      { type: 'com.temenos.engine.instance', data: { status: 'created' } }
    )
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((notification) => {
        if (notification.data?.id === this.demoInstance?.id) {
          this.instanceService.getInstanceById(this.demoInstance.id).pipe(takeUntilDestroyed(this.destroyRef)).subscribe(
            (instance) => {
              this.demoInstance = instance;
              this.getEndpointTypes(this.demoInstance);
              this.checkIfDeployed();
            });
        }
      });
  }

  private isUpdated(capability): boolean {
    if (this.selectedCapabilities) {
      return this.selectedCapabilities.some(e => e.name === capability.name);
    }
  }

  private updateConfiguration(instance, event): void {
    event.stopPropagation();
   // this.updateReleasePackage = this.getAvailableConfigurations(instance).length;
  }

  private defaultComparator(config1: Configuration, config2: Configuration): number {
    if (config1?.manifest?.dataGenerated && config2?.manifest?.dataGenerated) {
      return new Date(config2.manifest.dataGenerated).getTime() - new Date(config1.manifest.dataGenerated).getTime();
    }
    return 0;
  }

  // defineWorkflow(): void {
  //   this.sidenavService.openInRightSidenav(PathToLiveWorkflowComponent, {
  //     service: this.service,
  //     pathToLiveConfiguration: this.blueprint.pathToLiveConfiguration,
  //     devInstance: this.devInstance
  //   })
  //     .pipe(
  //       mergeMap(pathToLiveConfiguration => {
  //         if (pathToLiveConfiguration) {
  //           // Clone selected blueprint in case that update is not successfully
  //           return this.blueprintsService.updateBlueprint({ ...this.blueprint, pathToLiveConfiguration });
  //         } else {
  //           return of(null);
  //         }
  //       }),
  //       takeUntilDestroyed(this.destroyRef)
  //     )
  //     .subscribe((result: Blueprint) => {
  //       if (result) {
  //         this.blueprint.pathToLiveConfiguration = result.pathToLiveConfiguration;
  //         this.loadData();
  //       }
  //     },
  //     (error) => {
  //       this.matDialog.open(ErrorDialogComponent, {
  //         minHeight: '342px',
  //         width: '566px',
  //         panelClass: 'flex-dialog',
  //         data: {
  //           title:  translate('NOTIFICATIONS.UPDATE_SERVICE_DEFINITION_FAILED'),
  //           description: error,
  //         }
  //       });
  //     });
  // }

  validateEdgenwSharedserv(instance): void {
    if (this.isAWS || instance?.type === 'tss' || instance?.type === 'tsi') {
      this.changeInstanceStatus(instance);
    } else {
      this.showValidationLoader = true;
      let edgeNetworkInstanceId;
      let sharedServicesInstanceId;
      if (instance?.status === DeployStatus.STOPPED || instance?.status === DeployStatus.START_FAILED) {
        if (instance?.dataZone === DataZone.DEVELOPMENT) {
          edgeNetworkInstanceId = this.tenantDetails?.sharedInfra?.nonpii?.instanceId || this.tenantDetails?.sharedInfra?.pii?.instanceId || this.tenantDetails?.sharedInfra?.nonprod?.instanceId;
          sharedServicesInstanceId = this.tenantDetails?.sharedServices?.nonpii?.instanceId || this.tenantDetails?.sharedServices?.pii?.instanceId || this.tenantDetails?.sharedServices?.nonprod?.instanceId;
          if (!edgeNetworkInstanceId) {
            this.openErrorDialog('BLUEPRINT_SUMMARY.EDGENW_NOT_DEPLOYED_NONPII');
          } else if (!sharedServicesInstanceId) {
            this.openErrorDialog('BLUEPRINT_SUMMARY.SHAREDSERV_NOT_DEPLOYED_NONPII');
          }
        } else if (instance?.dataZone === DataZone.SECURE) {
          edgeNetworkInstanceId = this.tenantDetails?.sharedInfra?.pii?.instanceId || this.tenantDetails?.sharedInfra?.nonprod?.instanceId;
          sharedServicesInstanceId = this.tenantDetails?.sharedServices?.pii?.instanceId || this.tenantDetails?.sharedServices?.nonprod?.instanceId;
          if (!edgeNetworkInstanceId) {
            this.openErrorDialog('BLUEPRINT_SUMMARY.EDGENW_NOT_DEPLOYED_PII');
          } else if (!sharedServicesInstanceId) {
            this.openErrorDialog('BLUEPRINT_SUMMARY.SHAREDSERV_NOT_DEPLOYED_PII');
          }
        } else if (instance?.dataZone === DataZone.LIVE) {
          edgeNetworkInstanceId = this.tenantDetails?.sharedInfra?.prod?.instanceId;
          sharedServicesInstanceId = this.tenantDetails?.sharedServices?.prod?.instanceId;
          if (!edgeNetworkInstanceId) {
            this.openErrorDialog('BLUEPRINT_SUMMARY.EDGENW_NOT_DEPLOYED_LIVE');
          } else if (!sharedServicesInstanceId) {
            this.openErrorDialog('BLUEPRINT_SUMMARY.SHAREDSERV_NOT_DEPLOYED_LIVE');
          }
        }
        if (edgeNetworkInstanceId && sharedServicesInstanceId) {
          combineLatest([this.instanceService.getInstanceById(edgeNetworkInstanceId), this.instanceService.getInstanceById(sharedServicesInstanceId)])
          .pipe(takeUntilDestroyed(this.destroyRef))
          .subscribe(([edgenetwork, sharedService]) => {
            this.showValidationLoader = false;
            if (edgenetwork?.status !== DeployStatus.STOPPED && sharedService?.status !== DeployStatus.STOPPED) {
              this.changeInstanceStatus(instance);
            } else if (edgenetwork?.status === DeployStatus.STOPPED && sharedService?.status === DeployStatus.STOPPED) {
              if (instance?.dataZone === DataZone.DEVELOPMENT) {
                this.openErrorDialog('BLUEPRINT_SUMMARY.EDGENW_SHAREDSERV_NOT_RUNNING_NONPII');
              } else if (instance?.dataZone === DataZone.SECURE) {
                this.openErrorDialog('BLUEPRINT_SUMMARY.EDGENW_SHAREDSERV_NOT_RUNNING_PII');
              } else if (instance?.dataZone === DataZone.LIVE) {
                this.openErrorDialog('BLUEPRINT_SUMMARY.EDGENW_SHAREDSERV_NOT_RUNNING_LIVE');
              }
            } else if (edgenetwork?.status === DeployStatus.STOPPED) {
              if (instance?.dataZone === DataZone.DEVELOPMENT) {
                this.openErrorDialog('BLUEPRINT_SUMMARY.EDGENW_NOT_RUNNING_NONPII');
              } else if (instance?.dataZone === DataZone.SECURE) {
                this.openErrorDialog('BLUEPRINT_SUMMARY.EDGENW_NOT_RUNNING_PII');
              } else if (instance?.dataZone === DataZone.LIVE) {
                this.openErrorDialog('BLUEPRINT_SUMMARY.EDGENW_NOT_RUNNING_LIVE');
              }
            } else if (sharedService?.status === DeployStatus.STOPPED) {
              if (instance?.dataZone === DataZone.DEVELOPMENT) {
                this.openErrorDialog('BLUEPRINT_SUMMARY.SHAREDSERV_NOT_RUNNING_NONPII');
              } else if (instance?.dataZone === DataZone.SECURE) {
                this.openErrorDialog('BLUEPRINT_SUMMARY.SHAREDSERV_NOT_RUNNING_PII');
              } else if (instance?.dataZone === DataZone.LIVE) {
                this.openErrorDialog('BLUEPRINT_SUMMARY.SHAREDSERV_NOT_RUNNING_LIVE');
              }
            }
          }, (error) => {
            this.showValidationLoader = false;
          setTimeout(() => {
            const title = translate('ERRORS.SERVICE_AVAILABILITY');
            const message = error?.message ? error?.message : (error?.error?.message ? error?.error?.message : (error?.errmsg ? error?.errmsg : translate('SERVICE.INTERNAL_SERVER_ERROR')));
            this.toastrService.errMessage(message, title);
          }, 500);
          });
        }
      } else {
        this.showValidationLoader = false;
        this.changeInstanceStatus(instance);
      }
    }
  }

  openErrorDialog(description): void {
    this.dialog.open(ErrorDialogComponent, {
      minHeight: '342px',
      width: '630px',
      panelClass: 'flex-dialog',
      data: {
        title: translate('BLUEPRINT_SUMMARY.VALIDATION_ERROR'),
        description: translate(description)
      }
    });
    this.showValidationLoader = false;
  }

  onReInit(instance: Instance, event): void {
    event.stopPropagation();
    this.dialog.open(ConfirmationDialogComponent, {
      panelClass: 'default-dialog-wrapper',
      width: '566px',
      autoFocus: false,
      data: {
        title: translate('VERSIONS.REINIT_TITLE'),
        message: translate('VERSIONS.REINIT_SUBTITLE'),
        confirmButtonText: translate('DIALOG.SUBMIT')
      }
    })
      .afterClosed()
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(confirm => {
        if (confirm) {
          this.instanceService.reinitInstance(instance.id)
            .pipe(takeUntilDestroyed(this.destroyRef))
            .subscribe(() => {this.loadBlueprint()},
            (error)=>{
              const errorMessage = typeof error === 'string' ? error: typeof error?.error === 'string' ? error.error : error;
              this.dialog.open(ErrorDialogComponent, {
                    minHeight: '342px',
                    width: '630px',
                    panelClass: 'flex-dialog',
                    data: {
                      title: translate('ERROR_DIALOG.REINIT_FAILED'),
                      description: errorMessage
                    }
              });
            }
          );
        }
      });
  }

  changeInstanceStatus(instance?: Instance): void {
    if (instance?.status === DeployStatus.STOPPED || instance?.status === DeployStatus.START_FAILED) {
      this.dialog.open(ConfirmationDialogComponent, {
        panelClass: 'default-dialog-wrapper',
        width: '566px',
        autoFocus: false,
        data: {
          title: translate('INSTANCE_DETAILS.INSTANCE_START_TITLE'),
          message: translate('INSTANCE_DETAILS.INSTANCE_START_DESC'),
          confirmButtonText: translate('BUTTONS.CONFIRM'),
          confirmationTitle: translate('INSTANCE_DETAILS.START_INSTNACE_CONFIRMATION'),
          optionSelection: [
            {value: 'now', label: 'Now', selected: true},
            ...(!this.isAWS ? [{ value: 'schedulelater', label: 'Schedule Later', selected: false }] : [])
          ]
        }
      })
        .afterClosed()
        .pipe(takeUntilDestroyed(this.destroyRef))
        .subscribe(confirm => {
          if (confirm) {
            if (confirm.value === 'schedulelater') {
              this.scheduleTypes('start', instance?.name, this.blueprint?.name);
              this.router.navigate(['/', this.authService.principal.provider, RouterSegments.TENANT , this.tenantId, RouterSegments.SCHEDULE, RouterSegments.CREATE, RouterSegments.TYPE]);
            }
            if (confirm.value === 'now') {
            this.instanceService.instanceStart(instance)
              .pipe(takeUntilDestroyed(this.destroyRef))
              .subscribe(data => {
                this.loadBlueprint();
              },
              (error) => {
                const errorMessage = typeof error === 'string' ? error: typeof error?.error === 'string' ? error.error : error;
                this.dialog.open(ErrorDialogComponent, {
                  minHeight: '342px',
                  width: '566px',
                  panelClass: 'flex-dialog',
                  data: {
                    title: translate('ERROR_DIALOG.INSTANCE_START_FAILED'),
                    description: errorMessage,
                  }
               });
              });
            }
          }
      });
    } else {
      this.dialog.open(ConfirmationDialogComponent, {
        panelClass: 'default-dialog-wrapper',
        width: '566px',
        autoFocus: false,
        data: {
          title: translate('INSTANCE_DETAILS.INSTANCE_STOP_TITLE'),
          message: translate('INSTANCE_DETAILS.INSTANCE_STOP_DESC'),
          confirmButtonText: translate('BUTTONS.CONFIRM'),
          confirmationTitle: translate('INSTANCE_DETAILS.STOP_INSTNACE_CONFIRMATION'),
          optionSelection: [
            {value: 'now', label: 'Now', selected: true},
             ...(!this.isAWS ? [{ value: 'schedulelater', label: 'Schedule Later', selected: false }] : [])
          ]
        }
      })
        .afterClosed()
        .pipe(takeUntilDestroyed(this.destroyRef))
        .subscribe(confirm => {
          if (confirm) {
            if (confirm.value === 'schedulelater') {
              this.scheduleTypes('stop', instance?.name, this.blueprint?.name);
              this.router.navigate(['/', this.authService.principal.provider, RouterSegments.TENANT , this.tenantId, RouterSegments.SCHEDULE, RouterSegments.CREATE, RouterSegments.TYPE]);
            }

            if (confirm.value === 'now') {
            this.instanceService.instanceStop(instance)
              .pipe(takeUntilDestroyed(this.destroyRef))
              .subscribe(data => {
                this.loadBlueprint();
              },
              (error) => {
                const errorMessage = typeof error === 'string' ? error: typeof error?.error === 'string' ? error.error : error;
            this.dialog.open(ErrorDialogComponent, {
              minHeight: '342px',
              width: '630px',
              panelClass: 'flex-dialog',
              data: {
                title: translate('ERROR_DIALOG.INSTANCE_STOP_FAILED'),
                description: errorMessage
              }
            });
                });
              }
          }
      });
    }
  }

  displayInstanceStatus(status?: any): string {
    if (status === DeployStatus.STOPPED || status === DeployStatus.START_FAILED || status === DeployStatus.STOPPING) {
      return 'Start';
    } else {
      return 'Stop';
    }
  }

  isInprogressStatus(status): any {
    return this.INSTANCE_DEPLOYING_STATES.includes(status);
  }

  onActionClick(instance): any {
    this.configLoader = true;
    this.instanceService.getInstanceParameters(instance.id).pipe(takeUntilDestroyed(this.destroyRef))
    .subscribe(data => {
      this.configurationStatus = DeployStatus.NOT_DEPLOYED;
      if(Object.keys(data?.parameters ?? {}).length === 0 || data?.parameters?.components?.length === 0) {
        this.configurationStatus = DeployStatus.NOT_DEPLOYED;
      }
      else if(data?.parameters?.componentParameterStatus === DeployStatus.FAILED) {
        this.configurationStatus = DeployStatus.FAILED;
      } else if(data?.parameters?.components?.length || data?.parameters?.componentParameterStatus === DeployStatus.SUCCESS) {
        this.configurationStatus = DeployStatus.SUCCESS;
      }
      this.configLoader = false;
    },
    (error) => {
      this.configLoader = false;
    });
  }

  scheduleTypes(value, instaneName, blueprintName): void {
    let type;
    switch (value) {
      case 'start':
        type = Types.START_INSTANCE;
        break;
      case 'stop':
        type = Types.STOP_INSTANCE;
        break;
      case 'release_package':
        type = Types.APPLY_RELEASE_PACKAGE;
        break;
    }

    localStorage.setItem('scheduleInstance', JSON.stringify([{'instanceType': type, 'instanceName': instaneName, 'blueprintName': blueprintName}]) );
  }

  private sortInstancesByDateCreated(arr: any[]): any[] {
  return [...arr].sort((a, b) =>
    new Date(a.dateCreated).getTime() - new Date(b.dateCreated).getTime()
  );
}

// getting drgging item source if drag started
onDragStarted(event: CdkDragStart<any>) {
  this.draggingSource = event.source.dropContainer.id;
}

// updating other drop list UI if dragging item enter/leave other souce.
dropListEnter(event: CdkDragEnter<any>){
  if(this.draggingSource === event.container.id){
    return;
  }
  this.isDragging = true;
  const isOtherEmpty = this.otherInstance?.length === 0;
  const isOtherHasOne = this.otherInstance?.length === 1;
  if (!isOtherEmpty) {
    this.showCreateIcon = true;
    this.showCreateButton = false;
    if (this.draggingSource === 'listTwo' && isOtherHasOne) {
      this.showCreateButton = true;
      this.showCreateIcon = false;
    }
  } else {
    if (this.draggingSource === 'listOne') {
      this.showCreateIcon = true;
      this.showCreateButton = false;
    }
  }
}

// Resetting UI if dragging item exit the drop area.
onDropListExited(event: CdkDragExit<any>){
  if(this.draggingSource === event.container.id){
    return;
  }
  this.isDragging = false;
}

//validating conditions if dragged item is dropped to any drop area.
  drop(event: CdkDragDrop<string[]>, data) {
    this.draggingItem = event.item.data;
    let dragged;
    if (event.previousContainer.id === event.container.id) {
      dragged = event.currentIndex <= event.container.data.length ? event.container.data[event.currentIndex] : event.container.data[event.currentIndex+1];
    } else {
      dragged = event.currentIndex < event.container.data.length ? event.container.data[event.currentIndex] : event.container.data[event.currentIndex-1];
    }
    const environment = dragged?.environment ? dragged.environment : dragged?.type ? dragged.type : undefined;
    if (event.previousContainer.id === 'listTwo' && event.container.id === 'listTwo') {
      if (this.blueprint?.pathToLiveConfiguration?.length === 0) {
        const title = translate('BLUEPRINT_SUMMARY.ACTION_NOT_ALLOWED');
        const message = translate('BLUEPRINT_SUMMARY.NO_INSTSANCE_IN_PTL');
        this.toastrService.errMessage(message, title);
      }
      return;
    }
    if(event.previousContainer.id === event.container.id && event.currentIndex === event.previousIndex) {
      return;
    } else {
      if(this.otherInstance.length === 0 && event.container.id === 'listTwo') {
        this.isDragging = false;
          this.dialog.open(ConfirmationDialogComponent, {
            panelClass: 'default-dialog-wrapper',
            autoFocus: false,
            width: '566px',
            data: {
              title: translate(`BLUEPRINT_SUMMARY.DRAG_TITLE`),
              message: translate(`BLUEPRINT_SUMMARY.DRAG_MSG1`) +' <b>'+ this.draggingItem.name + '</b>?',
              confirmButtonText: translate('DIALOG.CONFIRM')
            }
          })
            .afterClosed()
            .pipe(takeUntilDestroyed(this.destroyRef))
            .subscribe(confirm => {
          if (confirm) {
          transferArrayItem(event.previousContainer.data,
            this.otherInstance,
            event.previousIndex,
            event.currentIndex);
            this.draggingItem.type = 'other';
            this.callDropApi(event.previousContainer.data, this.draggingItem, event.previousContainer.id);
          }
        });
        return;
      }
      let error = false;
      let warningMessage;
      if (event.previousContainer.id === event.container.id && (!environment || environment === 'PREPROD' || environment === 'LIVE')) {
        this.isDragging = false;
        const title = translate('BLUEPRINT_SUMMARY.ACTION_NOT_ALLOWED');
        const message = translate('BLUEPRINT_SUMMARY.PREPROD_LIVE_ERROR');
        this.toastrService.errMessage(message, title);
        error = true;
      }
      if (event.previousContainer.id !== event.container.id && (!environment || environment === 'LIVE')) {
        this.isDragging = false;
        const title = translate('BLUEPRINT_SUMMARY.ACTION_NOT_ALLOWED');
        const message = translate('BLUEPRINT_SUMMARY.PREPROD_LIVE_ERROR');
        this.toastrService.errMessage(message, title);
        error = true;
      }


      if (this.otherInstance.length === 0 && environment === 'LIVE') {
        // proceed to next step as this is first element in non ptl
      } else if (event.currentIndex > (event.container.data.length - 1) && (environment === 'other' || environment === 'eaas')){
        // last element, next element check not needed
        this.isDragging = false;
        const previous: any = event.container.data[event.currentIndex - 1];
        const previousIndex = this.otherInstance.findIndex(item => item.name === previous.name);
        const previousList = this.otherInstance.slice(0, previousIndex + 1);
        if (previousList.some(item => this.INSTANCE_DRAG_DROP_NEGATIVE_STATUS.includes(item.status))) {
          warningMessage = translate('BLUEPRINT_SUMMARY.NOT_DEPLOYED_WARNING');
        }
        warningMessage = this.validateForErrors(event, previous, undefined, true) ? this.validateForErrors(event, previous, undefined, true) : warningMessage;
        const previousSolutionVersion = this.serviceVersions.find(item => item.id === previous?.solutionVersionId)?.releaseVersion;
        const elementSolutionVersion = this.serviceVersions.find(item => item.id === event?.item?.data?.solutionVersionId)?.releaseVersion;
        if (previousSolutionVersion && elementSolutionVersion && previousSolutionVersion < elementSolutionVersion) {
          const from = previousSolutionVersion < elementSolutionVersion ? previous?.name : '';
          const to = previousSolutionVersion < elementSolutionVersion ? event?.item?.data?.name : '';
          warningMessage = translate('BLUEPRINT_SUMMARY.SOLUTION_VERSION_WARNING').replace(/from/g, from).replace(/to/g, to);
        }
      } else {
        this.isDragging = false;
        let next;
        let previous;
        if (environment === 'other' || environment === 'eaas') {
          next = event.container.data[event.currentIndex];
          const nextIndex = this.otherInstance.findIndex(item => item.name === next.name);
          if (nextIndex === 0) {
            // if index === 0, previous wont be there, checking for next
            warningMessage = this.validateForErrors(event, previous, next, true) ? this.validateForErrors(event, previous, next, true) : warningMessage;
          }
          if (nextIndex !== 0) {
            previous = this.otherInstance[nextIndex - 1];
            const previousList = this.otherInstance.slice(0, nextIndex);
            if (previousList.some(item => this.INSTANCE_DRAG_DROP_NEGATIVE_STATUS.includes(item.status))) {
              warningMessage = translate('BLUEPRINT_SUMMARY.NOT_DEPLOYED_WARNING');
            }
            warningMessage = this.validateForErrors(event, previous, next, true) ? this.validateForErrors(event, previous, next, true) : warningMessage;
          }
        } else {
          next = event.container.data[event.currentIndex];
          const nextIndex = this.instancesByOrder.findIndex(item => item.name === next.name);
          previous = this.instancesByOrder[nextIndex - 1];
          const previousList = this.instancesByOrder.slice(0, nextIndex);
          if (previousList.some(item => this.INSTANCE_DRAG_DROP_NEGATIVE_STATUS.includes(item.status))) {
            const title = translate('BLUEPRINT_SUMMARY.ACTION_NOT_ALLOWED');
            const message = translate('BLUEPRINT_SUMMARY.NOT_DEPLOYED_ERROR');
            this.toastrService.errMessage(message, title);
            error = true;
          }
          error = this.validateForErrors(event, previous, next) ? true : error;
        }
        const previousSolutionVersion = this.serviceVersions.find(item => item.id === previous?.solutionVersionId)?.releaseVersion;
        const nextSolutionVersion = this.serviceVersions.find(item => item.id === next?.solutionVersionId)?.releaseVersion;
        const elementSolutionVersion = this.serviceVersions.find(item => item.id === event?.item?.data?.solutionVersionId)?.releaseVersion;
        if ((previousSolutionVersion && elementSolutionVersion && previousSolutionVersion < elementSolutionVersion) || (elementSolutionVersion && nextSolutionVersion && elementSolutionVersion < nextSolutionVersion)) {
          const from = previousSolutionVersion < elementSolutionVersion ? previous?.name : elementSolutionVersion < nextSolutionVersion ? event?.item?.data?.name : '';
          const to = previousSolutionVersion < elementSolutionVersion ? event?.item?.data?.name : elementSolutionVersion < nextSolutionVersion ? next?.name : '';
          warningMessage = translate('BLUEPRINT_SUMMARY.SOLUTION_VERSION_WARNING').replace(/from/g, from).replace(/to/g, to);
        }
      }

      if (!error) {
        this.isDragging = false;
        this.dialog.open(ConfirmationDialogComponent, {
          panelClass: 'default-dialog-wrapper',
          autoFocus: false,
          width: '566px',
          data: {
            title: translate(`BLUEPRINT_SUMMARY.DRAG_TITLE`),
            message: translate(`BLUEPRINT_SUMMARY.DRAG_MSG1`) +' <b>'+ this.draggingItem.name + '</b>?',
            noteWithBg: warningMessage ? true : false,
            note: warningMessage,
            confirmButtonText: translate('DIALOG.CONFIRM')
          }
        })
          .afterClosed()
          .pipe(takeUntilDestroyed(this.destroyRef))
          .subscribe(confirm => {
        if (confirm) {
        if (event.previousContainer.id === event.container.id) {
            moveItemInArray(event.container.data, event.previousIndex, event.currentIndex);
            this.callDropApi(event.container.data, this.draggingItem, event.container.id);
        } else {
          transferArrayItem(event.previousContainer.data,
                            event.container.data,
                            event.previousIndex,
                            event.currentIndex);
            if(event.container.id === 'listTwo') {
              event.container.data.forEach((item: any) => {
                  item.type = 'other';
              })
              this.draggingItem.type = 'other';
              this.otherInstance = this.sortInstancesByDateCreated(event.container.data);
              this.changeDetectorRef.detectChanges();
              this.callDropApi(event.previousContainer.data, this.draggingItem, event.previousContainer.id);
            } else if(event.container.id !== 'listTwo') {
              event.container.data.forEach((item: any) => {
                if(item.type === 'other')
                  item.type = 'ptl';
              })
              this.draggingItem.type = 'ptl';
              this.callDropApi(event.container.data,this.draggingItem, event.container.id);
            }
            }
          }
        })
      }
    }
  }

  callDropApi(data, instanceData, id): void {
    data.forEach(item => {
      if(!item?.environment) {
        item.environment = item.name;
      }
    })
     const updatedConfig = data.map((config, index) => {
        const { id } = config;
        return {
        instanceId: config.instanceId || id,
        environment: config.environment,
        requires: data[index-1]?.environment,
        editable: config.editable,
        dataZone: config.dataZone,
        deploymentClass: config.deploymentClass
      };
    });
  this.blueprint.pathToLiveConfiguration = [...updatedConfig];
  this.showLoader = true;
    this.blueprintsService.updateBlueprint(this.blueprint).pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((updatedBlueprint) => {
        if(updatedBlueprint) {
          const instance = {
            id: instanceData.id,
            type: instanceData.type
          }
          this.instanceService.sendingLogBasedOnSelection(instance).pipe(takeUntilDestroyed(this.destroyRef))
          .subscribe((data) => {
            if(data) {
              this.onLoadBlueprintSubscription(updatedBlueprint);
            }
            this.showLoader = false;
          })
        }
      });
    }

  validateForErrors(event, previous, next?, warning?): any {
    const previousBlueprintVersion = this.blueprintsVersionList.find(item => item.id === previous?.blueprintVersionId)?.version;
    const nextBlueprintVersion = this.blueprintsVersionList.find(item => item.id === next?.blueprintVersionId)?.version;
    const elementBlueprintVersion = this.blueprintsVersionList.find(item => item.id === event?.item?.data?.blueprintVersionId)?.version;
    if ((previousBlueprintVersion && elementBlueprintVersion && previousBlueprintVersion < elementBlueprintVersion) || (elementBlueprintVersion && nextBlueprintVersion && elementBlueprintVersion < nextBlueprintVersion)) {
      const title = translate('BLUEPRINT_SUMMARY.ACTION_NOT_ALLOWED');
      const from = previousBlueprintVersion < elementBlueprintVersion ? previous?.name : elementBlueprintVersion < nextBlueprintVersion ? event?.item?.data?.name : '';
      const to = previousBlueprintVersion < elementBlueprintVersion ? event?.item?.data?.name : elementBlueprintVersion < nextBlueprintVersion ? next?.name : '';
      const message = translate('BLUEPRINT_SUMMARY.BLUEPRINT_MISMATCH').replace(/from/g, from).replace(/to/g, to);
      if (!warning) {
        this.toastrService.errMessage(message, title);
      }
      return warning ? message: true;
    }

    const previousReleasePackage = this.configurations?.find(config => config.id === previous?.configurationId)?.manifest?.version;
    const nextReleasePackage = this.configurations.find(config => config.id === next?.configurationId)?.manifest?.version;
    const elementReleasePackage = this.configurations.find(config => config.id === event?.item?.data?.configurationId)?.manifest?.version;
     let previousReleasePackageNum = Number(previousReleasePackage);
     let nextReleasePackageNum = Number(nextReleasePackage);
     let elementReleasePackageNum = Number(elementReleasePackage);


    if ((previousReleasePackageNum && elementReleasePackageNum && previousReleasePackageNum < elementReleasePackageNum) || (elementReleasePackageNum && nextReleasePackageNum && elementReleasePackageNum < nextReleasePackageNum)) {
      const title = translate('BLUEPRINT_SUMMARY.ACTION_NOT_ALLOWED');
      const from = previousReleasePackageNum < elementReleasePackageNum ? previous?.name : elementReleasePackageNum < nextReleasePackageNum ? event?.item?.data?.name : '';
      const to = previousReleasePackageNum < elementReleasePackageNum ? event?.item?.data?.name : elementReleasePackageNum < nextReleasePackageNum ? next?.name : '';
      const message = translate('BLUEPRINT_SUMMARY.RELEASE_PACKAGE_MISMATCH').replace(/from/g, from).replace(/to/g, to);
      if (!warning) {
        this.toastrService.errMessage(message, title);
      }
      return warning ? message: true;
    }
  }

  redirectSchedulePage(instanceData: any){
    localStorage.setItem( `scheduleClicked_${instanceData?.tenantId}_${instanceData?.id}`,'true');
   this.router.navigate(['/', this.authService.principal.provider, RouterSegments.TENANT, instanceData?.tenantId, RouterSegments.SCHEDULE]);

  }

  loadUsageSummary(instanceId?,month?) {
    this.timetakenChartLoaded = false;
    this.isResponseOk = false;
    this.isErrorResponse = false
    this.runHours = 0;
    this.shutDownHours = 0;
    if(instanceId && month){
      this.instanceService
        .getInstanceUsageSummarybyId(instanceId, month)
        .pipe(takeUntilDestroyed(this.destroyRef))
        .subscribe((data) => {
          const usageSum =
            Array.isArray(data) && data.length > 0 ? data[0] : null;
          if (usageSum) {
            if (usageSum.runningHours)
              this.runHours = usageSum.runningHours;
            if (usageSum.shutdownHours)
              this.shutDownHours = usageSum.shutdownHours
          }
       this.isResponseOk = true;
          },
          (error) => {
            this.isErrorResponse = true;
            setTimeout(() => {
              const title = translate('ERRORS.SERVICE_AVAILABILITY');
              const message = error?.message ? error?.message : error?.error?.message ? error?.error?.message : error?.errmsg ? error?.errmsg : translate('SERVICE.INTERNAL_SERVER_ERROR');
              this.toastrService.errMessage(message, title);
            }, 500);
          }
        );
      }
  }

  toSeconds(value: string | number): number {
    if (typeof value === 'number') return value * 3600;
    const parts = value.split(':').map(Number);
    if (parts.length === 3) {
      const [h, m, s] = parts;
      return h * 3600 + m * 60 + s;
    }
    return parseFloat(value) * 3600 || 0;
  }

  toHHMMSS(totalSeconds: number): string {
    const h = Math.floor(totalSeconds / 3600);
    const m = Math.floor((totalSeconds % 3600) / 60);
    const s = totalSeconds % 60;
    const pad = (n: number) => String(n).padStart(2, '0');
    return `${pad(h)}:${pad(m)}:${pad(s)}`;
  }


  environmentSelectionChanged(event): void {
    this.minDate = this.allInstances.find(item => item.id === event.value).dateCreated;
    this.metricConfigMonth = new Date();
    this.metricMonth = new Date();
    this.selectedMetricInstance = event.value;
    const year = this.metricMonth.getFullYear();
    const month = (this.metricMonth.getMonth() + 1).toString().padStart(2, '0');
    const yyyyMm = `${year}-${month}`;
    this.metricMonth = yyyyMm;
    this.loadUsageSummary(this.selectedMetricInstance,this.metricMonth);
    this.getMetricsPieChartData(this.selectedMetricInstance, this.metricConfigMonth);
    this.metricsPieChartLoaded = false;
  }

  applyMonthFilter(selectedMonth){
    this.metricsPieChartLoaded = false;
    this.metricMonth = new Date(selectedMonth);
    this.metricConfigMonth = new Date(selectedMonth);
    this.getMetricsPieChartData(this.selectedMetricInstance, this.metricConfigMonth);
    const year = this.metricMonth.getFullYear();
    const month = (this.metricMonth.getMonth() + 1).toString().padStart(2, '0');
    const yyyyMm = `${year}-${month}`;
    this.metricMonth = yyyyMm;
    this.loadUsageSummary(this.selectedMetricInstance,this.metricMonth);
  }

      // getting configurations states and success states count for showing in metrics pie chart
  getMetricsPieChartData(value: any, month: any): void {
   this.configService.getConfigurationStates(value)
        .pipe(takeUntilDestroyed(this.destroyRef))
        .subscribe(configurationStates => {
          this.configurationStateResponse = configurationStates;
          this.modifyConfigState(month,value)
      });
      this.loadMetricsPieChart(month,this.selectedMetricInstance);


  }
   modifyConfigState(month, instanceId) : void{
    let successStates = [];

    const configurationStates= this.configurationStateResponse?.filter(item => {
      const itemDate = new Date(item?.applicationStartTime);
      return itemDate.getFullYear() === month.getFullYear() && itemDate.getMonth() === month.getMonth()
    });
    configurationStates?.forEach(item => {
      if (item.status === 'success' && !successStates.find(element => element === item.configurationId)) {
        successStates = [...successStates, item.configurationId];
      }
    })
    this.successConfigStates = successStates;
    this.loadMetricsPieChart(month,this.selectedMetricInstance);
  }

  loadMetricsPieChart(month, instanceId): void {
          this.configurationMonth = this.configurations;
    const data = [
      { value:  (this.configurationMonth?.length - this.successConfigStates?.length), name: 'Not Deployed' },
      { value:  this.successConfigStates?.length, name: 'Deployed' },
    ]
    const colorCodes = ['#B3DADE', '#008392'];
    this.metricsPiechart = {
      tooltip: {
        trigger: 'item',
        formatter: '{b}: {c}',
      },
      series: [
        {
          type: 'pie',
          radius: ['80%', '100%'],
          avoidLabelOverlap: false,
          top: 20,
          bottom: 10,
          right: 10,
          left: 10,
          label: {
            show: false,
            position: 'bottom',
            formatter: '',
            fontSize: '20'
          },
          labelLine: {
            show: false
          },
          itemStyle: {
            borderColor: '#fff',
            borderWidth: 0
          },
          color: colorCodes,
          data: data,
        }
      ]
    };
    this.metricsPieChartLoaded = true;
  }

  /**
 * Initializes the usage form by setting up metrics instances, selecting default values,
 * and determining the minimum date based on available instance data.
 * Loads the usage summary and metric chart data for the selected month and instance.
 * @param none: the function uses internal state for initialization
 */
  initializeUsageForm(){
    if (this.allInstances.length > 0) {
      this.metricsInstances = this.allInstances.map((item) => ({name: item.name,value: item.id,configurationId: item.configurationId,}));
      this.metricsInstances = this.metricsInstances.sort((a, b) => a.name.localeCompare(b.name));
      this.selectedMetricInstance = '';
      const now = new Date();
      const currentYearMonth = `${now.getFullYear()}-${String(
        now.getMonth() + 1
      ).padStart(2, '0')}`;
      this.metricConfigMonth = now;
      this.metricMonth = currentYearMonth;
    } else {
      this.metricsInstances = [];
    }
  }

  getTenantAccountDetails() {
    this.tenantService.getTenantAccountDetails(this.tenantId)
    .pipe(takeUntilDestroyed(this.destroyRef))
    .subscribe((data: any) => {
      if (data) {
        this.subscriptionData = data;
      }
    });
  }

  openMenu(button: HTMLElement, menuTemplate: TemplateRef<any>) {
    clearTimeout(this.closeTimeout);

    if (this.overlayRef) {
      this.overlayRef.dispose();
    }

    const positionStrategy = this.positionBuilder
      .flexibleConnectedTo(button)
      .withPositions([{
        originX: 'start',
        originY: 'bottom',
        overlayX: 'start',
        overlayY: 'top'
      }]);

    this.overlayRef = this.overlay.create({
      positionStrategy,
      hasBackdrop: false
    });

    const template = new TemplatePortal(menuTemplate, this.viewContainerRef);
    this.overlayRef.attach(template);

    this.overlayRef.overlayElement.addEventListener('mouseleave', () => {
      this.scheduleClose();
    });
  }

  scheduleClose() {
    this.closeTimeout = setTimeout(() => {
      if (this.overlayRef) {
        this.overlayRef.dispose();
        this.overlayRef = null;
      }
    }, 200);
  }

  cancelClose() {
    clearTimeout(this.closeTimeout);
  }

  /**
     * Opem the agent link in new tab
     * @param suffix - suffix of instance
     */
    agentLink(suffix, dataZone, type) {
      this.dialog.open(RedirectionDialogComponent, {
          panelClass: 'default-dialog-wrapper',
          width: '566px',
          autoFocus: false,
          data: {
            redirectTitle: this.isAWS ? translate('BLUEPRINT_SUMMARY.AWS_PLATFORM') : translate('BLUEPRINT_SUMMARY.AZURE_PLATFORM'),
            redirectMsg: this.isAWS ? translate('BLUEPRINT_SUMMARY.AWS_CLOUD_WATCH_LOG') : translate('BLUEPRINT_SUMMARY.AZURE_AGENT_CONTAINER'),
            proceedButtonText: translate('BUTTONS.PROCEED')
          }
        })
        .afterClosed()
        .pipe(takeUntilDestroyed(this.destroyRef))
        .subscribe(confirm => {
        if (confirm) {
          if (this.isAWS) {
            const url = `https://${this.tenantDetails?.primaryRegion}.console.aws.amazon.com/cloudwatch/home?region=${this.tenantDetails?.primaryRegion}#logsV2:log-groups/log-group`;
            window.open(url, '_blank');
          } else if (this.subscriptionData) {
            const subscriptionId = this.subscriptionData.filter(item => item.dataZone === dataZone)[0]?.azureDetails?.subscriptionId;
            const resourceGroup = (this.isExternalTenant && type !== 'tsi' && type !== 'tss') ? `${suffix}-agent-engine` : `${suffix}-agent`;
            const url = `https://portal.azure.com/#@temenosgroup.onmicrosoft.com/resource/subscriptions/${subscriptionId}/resourceGroups/${resourceGroup}/providers/Microsoft.ContainerInstance/containerGroups/Agent%20Container/containers`;
            window.open(url, '_blank');
          }
        }
      });
    }
  /**
   *
   * @param instanceId
   * @returns true if local config applied for a instance
   */
  isLocalConfigApplied(instanceId: string): boolean {
    return this.instanceService.isConfigApplied(instanceId);
  }

  /**
* Fetches and stores init status for each instance in `initStatusMap`.
* Makes parallel API calls and defaults to `null` if no status is returned.
*/
  loadInitStatus(instances) {
    instances?.forEach(instance => {
      this.localConfigService.getLocalConfigurationInit(instance.id).pipe(takeUntilDestroyed(this.destroyRef)).subscribe({
        next: (res) => {
          this.initStatusMap[instance.id] = res?.status ?? null;
        },
        error: (error) => {
          if (error?.httpStatusCode === 404 || error?.opstatus === 404) {
            this.initStatusMap[instance.id] = null;
          } else {
            setTimeout(() => {
              const title = translate('ERRORS.SERVICE_AVAILABILITY');
              const message = error?.message ? error?.message : (error?.error?.message ? error?.error?.message : (error?.errmsg ? error?.errmsg : translate('SERVICE.INTERNAL_SERVER_ERROR')));
              this.toastrService.errMessage(message, title);
            }, 500);
          }
        }
      });
    });
  }

  /**
   * Handles database backup deletion with confirmation and error handling.
   * @param event
   */
  deleteDataBase(event) : void {
    const status = event.status === DataBaseStatus.DELETE_FAILED ? "" : event.status === DataBaseStatus.PREPARATION_FAILED ? DataBaseStatus.FAILED : event.status === DataBaseStatus.PROMOTED ? DataBaseStatus.RESTORED : event.status === DataBaseStatus.PROMOTION_FAILED ? DataBaseStatus.RESTORE_FAIL : event.status;
    this.dialog.open(ConfirmationDialogComponent, {
      panelClass: 'default-dialog-wrapper',
      width: '566px',
      autoFocus: false,
      data: {
        title: translate('INSTANCE_DETAILS.DATABASE_BACKUP.DELETE_DB'),
        message: translate('INSTANCE_DETAILS.DATABASE_BACKUP.DELETE_DB_MSG',{
                  status: translate(status),
                }),
        confirmButtonText: translate('BUTTONS.CONFIRM')
      }
    })
    .afterClosed()
    .pipe(takeUntilDestroyed(this.destroyRef))
    .subscribe(confirmed => {
      if(confirmed) {
      this.dbBackupService.deleteInstanceRestore(this.selectedTarget.id, event.id).pipe(takeUntilDestroyed(this.destroyRef))
          .subscribe(data => {
            this.restoreRecords.find(item => item.id === data.id).status = data.status;
            this.disableRestore = true;
            this.initialRestoreRecords.forEach(item => { item.disableRestore = this.disableRestore;});
            this.restoreRecords.forEach(item => {item.disableRestore = this.disableRestore;});
          },
          (error) => {
            const errorMessage = typeof error === 'string' ? error: typeof error?.error === 'string' ? error.error : error;
            this.dialog.open(ErrorDialogComponent, {
              minHeight: '280px',
              width: '630px',
              panelClass: 'flex-dialog',
              data: {
                title:  translate('INSTANCE_DETAILS.DATABASE_BACKUP.DELETE_DB_FAILED'),
                description: errorMessage
              }
            });
          });
      }
    })
  }

/**
 * Get bookmarks for the logged-in user and updates the instance.
 * @param data - Instance object to enrich with bookmark details
 */
  getBookmarks(): void {
    const userId = this.authService?.principal?.attributes?.email;
    if (!userId) {
      return;
    }
    this.userService.getBookmarks(userId).subscribe( items => {
      this.bookmark = items;
    });
  }
  //bookmark sleleted instance
  bookmarkInstance(instances): any {
    const bookmarkMap = new Map(
      this.bookmark?.map(b => [b.instanceId, b.id])
    );
    const updatedInstances = instances?.map(instance => ({
      ...instance,
      bookmarked: bookmarkMap.has(instance.id),
      bookmarkedId: bookmarkMap.get(instance.id) || null
    }));

    return updatedInstances;
  }


  isBookmarked(instanceId: string): boolean {
    return !!this.bookmark?.find(b => b.instanceId === instanceId);
  }

  // opens confirmation dialog and triggers agent adoption for deploy or re-deploy
  onClickDeployAgent(data: Instance, type: 'deploy' | 're-deploy'): void {
      this.dialog.open(ConfirmationDialogComponent, {
        panelClass: 'default-dialog-wrapper',
        autoFocus: false,
        width: '566px',
        data: {
          title: translate(type === 're-deploy' ? 'BLUEPRINT_SUMMARY.REDEPLOY_ENV_AGENT' : 'BLUEPRINT_SUMMARY.DEPLOY_ENV_AGENT'),
          message: translate(type === 're-deploy' ? 'BLUEPRINT_SUMMARY.REDEPLOY_CONFIRM' : 'BLUEPRINT_SUMMARY.DEPLOY_CONFIRM'),
          confirmButtonText: translate('BUTTONS.CONFIRM')
        }
      })
        .afterClosed()
        .pipe(takeUntilDestroyed(this.destroyRef))
        .subscribe(confirm => {
          if (confirm) {
            this.deployAgentIds.set(data.id, type);
            this.instanceService.postInstanceAdopt(data.id)
              .pipe(takeUntilDestroyed(this.destroyRef))
              .subscribe(() => {
                this.loadData();
              });
          }
        });
  }

  // checks if agent was recently deployed for the given instance
  isAgentDeployed(instanceId: string): boolean {
    return this.instanceService.isAgentDeployed(instanceId);
  }

  // clears deployAgentIds entry once adoption completes or fails, then marks success transiently
  resolveDeployAgentIds(instances: Instance[]): void {
    this.deployAgentIds.forEach((type, id) => {
      const instance = instances.find(i => i.id === id);
      if (!instance) return;
      if (instance.managementMode === ManagementMode.ADOPTED) {
        this.deployAgentIds.delete(id);
        this.adoptStartedIds.delete(id);
        this.instanceService.setAgentDeployed(id);
      } else if (instance.lifecycleState === 'adopting') {
        this.adoptStartedIds.add(id);
      } else if (instance.lastOperation?.type === 'adopt' && instance.lastOperation?.status === 'failed') {
        if (type === 'deploy' || this.adoptStartedIds.has(id)) {
          this.deployAgentIds.delete(id);
          this.adoptStartedIds.delete(id);
        }
      }
    });
  }

  // returns true when external tenant instance is in any agent deployment related state
  isAgentDeploymentStatus(instance: Instance): boolean {
    return this.isExternalTenant && (
      this.deployAgentIds.has(instance.id) ||
      instance.lifecycleState === 'adopting' ||
      this.instanceService.isAgentDeployed(instance.id) ||
      (instance.lastOperation?.type === 'adopt' && instance.lastOperation?.status === 'failed')
    );
  }
  // updating insatace availability state
  getInstanceState(id:any): void {
    this.instanceService.getInstanceById(id)
    .pipe(takeUntilDestroyed(this.destroyRef))
    .subscribe((result: any) => {
     const updateFields = (item: any) => {
        item.status            = result?.status;
        item.availabilityState = result?.availabilityState;
        item.lifecycleState    = result?.lifecycleState;
        item.lastOperation     = result?.lastOperation;
      };
      if (this.devInstance.find(item => item.id === id)) {
        updateFields(this.devInstance.find(item => item.id === id));
      } else if (this.testDataZoneInstances.find(item => item.id === id)) {
        updateFields(this.testDataZoneInstances.find(item => item.id === id));
      } else if (this.piiDataZoneInstances.find(item => item.id === id)) {
        updateFields (this.piiDataZoneInstances.find(item => item.id === id));
      }
    });
  }

    // open activity details page
  openActivityDetails( instanceData: any) {
    const data = {
      activityDetail: instanceData?.activityDetails,
      instance: instanceData
    }
    this.sidenavService.openInRightSidenav(EnvironmentActivityDetails, data, "activityDetails")
    .pipe(takeUntilDestroyed(this.destroyRef))
    .subscribe((detail) => {
      const arrays = [{ data: this.classEInstances, update: (data: any[]) => this.classEInstances = data},
      { data: this.devInstance, update: (data: any[]) => this.devInstance = data},
      { data: this.piiDataZoneInstances, update: (data: any[]) => this.piiDataZoneInstances = data},
      { data: this.otherInstance, update: (data: any[]) => this.otherInstance = data},
      ];
      const matchedArray = arrays.find(group => group.data?.some(item => item.id === detail?.instanceId));
      if (!matchedArray) {return;}
      const updatedArray = this.activityProgressService.updateInstanceActivityDetail(matchedArray.data,detail);
      matchedArray.update(updatedArray);
    });
  }
   
  getActivityDetailsETA(source?: any[]): any {
    const list = source ?? this.instanceBlueprint;
     if (!list?.length) {
        return this.instanceBlueprint;
    }
    const activityLogsRequests = list.filter((item: any) => this.INSTANCE_DEPLOYING_STATES.includes(item.status) && item.status !== DeployStatus.TERMINATED)
      .map((item: any) => {
        const instanceId = item.id;
        return this.activityService.getInstanceActivityLogs(instanceId).pipe(
          mergeMap((activityLogs) => {
            const target = this.instanceBlueprint?.find(i => i.id === instanceId) ?? item;
            const logs = Array.isArray(activityLogs) ? activityLogs : (activityLogs?.data ?? []);
            if (target.status === DeployStatus.DEPLOYING && logs?.length === 0) {
              target.agentCreationProgress = DeployStatus.TENANT_AGENT_CREATION_IN_PROGRESS;
            }
            const latestLog = [...logs].sort((a, b) =>
              new Date(b?.startTime).getTime() - new Date(a?.startTime).getTime()
            )[0];
            return this.activityService.getInstanceActivityLogsById(instanceId, latestLog?.id).pipe(
              map((activityLogs) => {
                target.activityDetails = activityLogs;
                const stages: any[] = activityLogs?.stages ?? [];
                const execStage = stages.find(s => s.type === 'component_execution');
                let countData: any = {};
                target.activityDetails.countData = {};
                if (execStage?.count?.total) {
                  countData.total = Number(execStage.count.total);
                  countData.completed = Number(execStage.count.completed ?? 0);
                  countData.skipped = Number(execStage.count.skipped ?? 0);
                  countData.pending = Number(countData.total - (countData.completed + countData.skipped));
                  countData.completedPercent = countData?.completed !== 0 ? Math.round(((countData?.completed + countData.skipped) / countData.total) * 100) : 0;
                  target.activityDetails.countData.total = countData.total;
                  target.activityDetails.countData.completedPercent = countData.completedPercent;
                }
                if (latestLog) {
                  target.activityStartTime = latestLog.startTime;
                  target.expectedDurationMs = Number(latestLog.expectedDurationMs);
                }
                if (latestLog?.count?.total) {
                  target.total = Number(latestLog.count.total);
                  target.completed = Number(latestLog.count.completed ?? 0);
                  target.skipped = Number(latestLog.count.skipped ?? 0);
                  target.pending = Number(target.total - (target.completed + target.skipped));
                  target.completedPercent = target?.completed !== 0 ? Math.round(((target?.completed + target?.skipped) / target.total) * 100) : 0;
                }
                target.activityDataLoaded = true;
                return target;
              })
            );
          }),
          takeUntilDestroyed(this.destroyRef)
        );
      });

    if (activityLogsRequests.length > 0) {
      forkJoin(activityLogsRequests).subscribe(() => {
        this.appRef.tick();
        if (!source) {
        const updatedInstances = this.bookmarkInstance(this.instanceBlueprint);
        this.devInstances = updatedInstances?.filter((item: any) => item.type !== InstanceType.OTHER && item.type !== InstanceType.EAAS && item.deploymentClass === DeploymentClass.D);
        this.piiDataZoneInstances = updatedInstances?.filter((item: any) => ((item.type !== InstanceType.OTHER && item.type !== InstanceType.EAAS && item.dataZone === DataZone.SECURE && (item.deploymentClass === DeploymentClass.C || item.deploymentClass === DeploymentClass.B)) || item.deploymentClass === DeploymentClass.A));
        this.liveDataZone = updatedInstances?.filter((item: any) => item.type !== InstanceType.OTHER && item.type !== InstanceType.EAAS && item.deploymentClass === DeploymentClass.A);
        this.otherInstances = updatedInstances?.filter((item: any) => item.type === InstanceType.OTHER || item.type === InstanceType.EAAS);
        }
        this.changeDetectorRef.detectChanges();
      });
    }else if (!source){
       return this.instanceBlueprint;
    }
  }

  private checkForRunningJobs(instances: Instance[]): void {
    instances.forEach(instance => {
      if (this.isAWS) {
        this.envScheduleService.getInstanceJobs(instance.id)
          .pipe(
            mergeMap((response: any) => {
              if (response?.total > 10) {
                return this.envScheduleService.getInstanceJobs(instance.id, response.total);
              }
              return of(response);
            }),
            catchError((error) => {
              this.isErrorResponse = true;
              setTimeout(() => {
                const title = translate('ERRORS.SERVICE_AVAILABILITY');
                const message = error?.message ? error?.message : error?.error?.message ? error?.error?.message : error?.errmsg ? error?.errmsg : translate('SERVICE.INTERNAL_SERVER_ERROR');
                this.toastrService.errMessage(message, title);
                instance.hasRunningJobs = false;
              }, 500);
              return of(instance);
            }),
            takeUntilDestroyed(this.destroyRef)
          )
          .subscribe(
            (response: any) => {
              const hasRunningJob = response?.data?.some((job: any) => job.status?.toLowerCase() === 'running') ?? false;
              instance.hasRunningJobs = hasRunningJob;
            }
          );
      }
    });
  }

  onInstanceMenuOpened(): void {
    handleInstanceMenuPositioning();
  }
}
